//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ActionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    refreshAction(boardId: string, boardItemId: string, actionId: string, cancelToken?: CancelToken): Promise<BoardItemActionDto> {
        let url_ = this.baseUrl + "/api/Actions/{boardId}/{boardItemId}/{actionId}";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (boardItemId === undefined || boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' must be defined.");
        url_ = url_.replace("{boardItemId}", encodeURIComponent("" + boardItemId));
        if (actionId === undefined || actionId === null)
            throw new globalThis.Error("The parameter 'actionId' must be defined.");
        url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshAction(_response);
        });
    }

    protected processRefreshAction(response: AxiosResponse): Promise<BoardItemActionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemActionDto.fromJS(resultData200);
            return Promise.resolve<BoardItemActionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemActionDto>(null as any);
    }
}

export class AdminClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    syncEmails( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/syncemails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncEmails(_response);
        });
    }

    protected processSyncEmails(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSchedulerData( cancelToken?: CancelToken): Promise<JobDto[]> {
        let url_ = this.baseUrl + "/api/Admin/schedulerdata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSchedulerData(_response);
        });
    }

    protected processGetSchedulerData(response: AxiosResponse): Promise<JobDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JobDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobDto[]>(null as any);
    }
}

export class AttachmentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getAllAttachments(id: string, destination: AttachmentDestination, cancelToken?: CancelToken): Promise<AttachmentDto[]> {
        let url_ = this.baseUrl + "/api/Attachment/{id}/{destination}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (destination === undefined || destination === null)
            throw new globalThis.Error("The parameter 'destination' must be defined.");
        url_ = url_.replace("{destination}", encodeURIComponent("" + destination));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAttachments(_response);
        });
    }

    protected processGetAllAttachments(response: AxiosResponse): Promise<AttachmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AttachmentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentDto[]>(null as any);
    }

    downloadAllAttachments(id: string, destination: AttachmentDestination, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Attachment/{id}/{destination}/all";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (destination === undefined || destination === null)
            throw new globalThis.Error("The parameter 'destination' must be defined.");
        url_ = url_.replace("{destination}", encodeURIComponent("" + destination));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAllAttachments(_response);
        });
    }

    protected processDownloadAllAttachments(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addFile(destination: AttachmentDestination, id: string, file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<AttachmentDto> {
        let url_ = this.baseUrl + "/api/Attachment/{destination}/{id}/addfile";
        if (destination === undefined || destination === null)
            throw new globalThis.Error("The parameter 'destination' must be defined.");
        url_ = url_.replace("{destination}", encodeURIComponent("" + destination));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFile(_response);
        });
    }

    protected processAddFile(response: AxiosResponse): Promise<AttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentDto.fromJS(resultData200);
            return Promise.resolve<AttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentDto>(null as any);
    }

    updateFile(attachmentUpdates: UpdateAttachmentDto, cancelToken?: CancelToken): Promise<UpdateAttachmentDto> {
        let url_ = this.baseUrl + "/api/Attachment/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachmentUpdates);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFile(_response);
        });
    }

    protected processUpdateFile(response: AxiosResponse): Promise<UpdateAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateAttachmentDto.fromJS(resultData200);
            return Promise.resolve<UpdateAttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateAttachmentDto>(null as any);
    }

    addImage(id: string, dto: ImageDataDto, cancelToken?: CancelToken): Promise<AttachmentDto> {
        let url_ = this.baseUrl + "/api/Attachment/{id}/addimage";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddImage(_response);
        });
    }

    protected processAddImage(response: AxiosResponse): Promise<AttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentDto.fromJS(resultData200);
            return Promise.resolve<AttachmentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentDto>(null as any);
    }

    deleteAttachment(id: string, dto: DeleteAttachmentDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Attachment/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAttachment(_response);
        });
    }

    protected processDeleteAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadAttachment(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Attachment/attachment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getThumbnail(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Attachment/thumbnail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetThumbnail(_response);
        });
    }

    protected processGetThumbnail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class BoardClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getAvailableBoards( cancelToken?: CancelToken): Promise<BoardDto[]> {
        let url_ = this.baseUrl + "/api/Board/available";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableBoards(_response);
        });
    }

    protected processGetAvailableBoards(response: AxiosResponse): Promise<BoardDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardDto[]>(null as any);
    }

    getAllBoards( cancelToken?: CancelToken): Promise<BoardDto[]> {
        let url_ = this.baseUrl + "/api/Board/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBoards(_response);
        });
    }

    protected processGetAllBoards(response: AxiosResponse): Promise<BoardDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardDto[]>(null as any);
    }

    handoverShift(id: string, dto: ShiftHandoverDto, cancelToken?: CancelToken): Promise<BoardDto> {
        let url_ = this.baseUrl + "/api/Board/handover/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHandoverShift(_response);
        });
    }

    protected processHandoverShift(response: AxiosResponse): Promise<BoardDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardDto.fromJS(resultData200);
            return Promise.resolve<BoardDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardDto>(null as any);
    }

    getBoard(id: string, cancelToken?: CancelToken): Promise<BoardDto> {
        let url_ = this.baseUrl + "/api/Board/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoard(_response);
        });
    }

    protected processGetBoard(response: AxiosResponse): Promise<BoardDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardDto.fromJS(resultData200);
            return Promise.resolve<BoardDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardDto>(null as any);
    }

    cleanup(id: string, cancelToken?: CancelToken): Promise<BoardDto> {
        let url_ = this.baseUrl + "/api/Board/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCleanup(_response);
        });
    }

    protected processCleanup(response: AxiosResponse): Promise<BoardDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardDto.fromJS(resultData200);
            return Promise.resolve<BoardDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardDto>(null as any);
    }

    getBoardCategories( cancelToken?: CancelToken): Promise<BoardItemCategoryDto[]> {
        let url_ = this.baseUrl + "/api/Board/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoardCategories(_response);
        });
    }

    protected processGetBoardCategories(response: AxiosResponse): Promise<BoardItemCategoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardItemCategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardItemCategoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemCategoryDto[]>(null as any);
    }

    createBoard(boardInsertDto: BoardInsertDto, cancelToken?: CancelToken): Promise<BoardDto> {
        let url_ = this.baseUrl + "/api/Board";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(boardInsertDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBoard(_response);
        });
    }

    protected processCreateBoard(response: AxiosResponse): Promise<BoardDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardDto.fromJS(resultData200);
            return Promise.resolve<BoardDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardDto>(null as any);
    }

    archiveDone(id: string, cancelToken?: CancelToken): Promise<BoardDto> {
        let url_ = this.baseUrl + "/archive/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveDone(_response);
        });
    }

    protected processArchiveDone(response: AxiosResponse): Promise<BoardDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardDto.fromJS(resultData200);
            return Promise.resolve<BoardDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardDto>(null as any);
    }
}

export class BoardItemClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getById(boardItemGuid: string | undefined, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItem?";
        if (boardItemGuid === null)
            throw new globalThis.Error("The parameter 'boardItemGuid' cannot be null.");
        else if (boardItemGuid !== undefined)
            url_ += "boardItemGuid=" + encodeURIComponent("" + boardItemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    save(dto: BoardItemUpdateDto, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    getItems(boardGuid: string, rowVersion: number | undefined, cancelToken?: CancelToken): Promise<BoardItemDto[]> {
        let url_ = this.baseUrl + "/api/BoardItem/board/{boardGuid}?";
        if (boardGuid === undefined || boardGuid === null)
            throw new globalThis.Error("The parameter 'boardGuid' must be defined.");
        url_ = url_.replace("{boardGuid}", encodeURIComponent("" + boardGuid));
        if (rowVersion === null)
            throw new globalThis.Error("The parameter 'rowVersion' cannot be null.");
        else if (rowVersion !== undefined)
            url_ += "rowVersion=" + encodeURIComponent("" + rowVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: AxiosResponse): Promise<BoardItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto[]>(null as any);
    }

    add(dto: BoardItemInsertDto, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItem/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    addBoardItemFromTemplate(dto: BoardItemCreateFromTemplateDto, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItem/AddFromTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddBoardItemFromTemplate(_response);
        });
    }

    protected processAddBoardItemFromTemplate(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    comment(dto: BoardItemCommentDto, cancelToken?: CancelToken): Promise<BoardItemCommentDto> {
        let url_ = this.baseUrl + "/api/BoardItem/Comment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComment(_response);
        });
    }

    protected processComment(response: AxiosResponse): Promise<BoardItemCommentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemCommentDto.fromJS(resultData200);
            return Promise.resolve<BoardItemCommentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemCommentDto>(null as any);
    }

    createTemplateFromBoardItem(boardItemId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BoardItem/CreateTemplate/{boardItemId}";
        if (boardItemId === undefined || boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' must be defined.");
        url_ = url_.replace("{boardItemId}", encodeURIComponent("" + boardItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTemplateFromBoardItem(_response);
        });
    }

    protected processCreateTemplateFromBoardItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    processBoardItemView(dto: BoardItemClickDto, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItem/click";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessBoardItemView(_response);
        });
    }

    protected processProcessBoardItemView(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    toggleSubscription(boardItemId: string, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItem/{boardItemId}/toggleSubscription";
        if (boardItemId === undefined || boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' must be defined.");
        url_ = url_.replace("{boardItemId}", encodeURIComponent("" + boardItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleSubscription(_response);
        });
    }

    protected processToggleSubscription(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    toggleAutomaticStatusChange(boardItemId: string, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItem/{boardItemId}/toggleAutomaticStatusChange";
        if (boardItemId === undefined || boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' must be defined.");
        url_ = url_.replace("{boardItemId}", encodeURIComponent("" + boardItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleAutomaticStatusChange(_response);
        });
    }

    protected processToggleAutomaticStatusChange(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    getAllBoardItemTypes( cancelToken?: CancelToken): Promise<BoardItemTypeDto[]> {
        let url_ = this.baseUrl + "/api/BoardItem/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBoardItemTypes(_response);
        });
    }

    protected processGetAllBoardItemTypes(response: AxiosResponse): Promise<BoardItemTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardItemTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardItemTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemTypeDto[]>(null as any);
    }

    getSendAsEmailOptions(getOptionsDto: SendAsEmailGetOptionsDto, cancelToken?: CancelToken): Promise<SendAsEmailOptionsDto> {
        let url_ = this.baseUrl + "/api/BoardItem/getSendAsEmailOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getOptionsDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSendAsEmailOptions(_response);
        });
    }

    protected processGetSendAsEmailOptions(response: AxiosResponse): Promise<SendAsEmailOptionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendAsEmailOptionsDto.fromJS(resultData200);
            return Promise.resolve<SendAsEmailOptionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendAsEmailOptionsDto>(null as any);
    }

    sendAsEmail(boardId: string, boardItemId: string, sendAsEmailDto: SendAsEmailDto, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BoardItem/{boardId}/{boardItemId}/sendAsEmail";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (boardItemId === undefined || boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' must be defined.");
        url_ = url_.replace("{boardItemId}", encodeURIComponent("" + boardItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendAsEmailDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendAsEmail(_response);
        });
    }

    protected processSendAsEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class BoardItemShareClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getSharedBoardItems(boardId: string | undefined, cancelToken?: CancelToken): Promise<BoardItemDto[]> {
        let url_ = this.baseUrl + "/api/BoardItemShare/shared?";
        if (boardId === null)
            throw new globalThis.Error("The parameter 'boardId' cannot be null.");
        else if (boardId !== undefined)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedBoardItems(_response);
        });
    }

    protected processGetSharedBoardItems(response: AxiosResponse): Promise<BoardItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto[]>(null as any);
    }

    share(dto: BoardItemShareDto, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItemShare/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShare(_response);
        });
    }

    protected processShare(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    unShare(dto: BoardItemUnshareDto, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItemShare/unshare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnShare(_response);
        });
    }

    protected processUnShare(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    leaveSharing(dto: BoardItemUnshareDto, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItemShare/leavesharing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLeaveSharing(_response);
        });
    }

    protected processLeaveSharing(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    stopSharing(dto: BoardItemStopSharingDto, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItemShare/stopsharing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopSharing(_response);
        });
    }

    protected processStopSharing(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }
}

export class BoardItemTemplateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getTemplates(boardGuid: string, cancelToken?: CancelToken): Promise<TemplateCategoryWithTemplatesDto[]> {
        let url_ = this.baseUrl + "/api/BoardItemTemplate/templates/{boardGuid}";
        if (boardGuid === undefined || boardGuid === null)
            throw new globalThis.Error("The parameter 'boardGuid' must be defined.");
        url_ = url_.replace("{boardGuid}", encodeURIComponent("" + boardGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplates(_response);
        });
    }

    protected processGetTemplates(response: AxiosResponse): Promise<TemplateCategoryWithTemplatesDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateCategoryWithTemplatesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TemplateCategoryWithTemplatesDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateCategoryWithTemplatesDto[]>(null as any);
    }

    getAvailability(boardItemId: string, cancelToken?: CancelToken): Promise<BoardItemTemplateAvailabilityViewDto[]> {
        let url_ = this.baseUrl + "/api/BoardItemTemplate/templates/{boardItemId}/availability";
        if (boardItemId === undefined || boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' must be defined.");
        url_ = url_.replace("{boardItemId}", encodeURIComponent("" + boardItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailability(_response);
        });
    }

    protected processGetAvailability(response: AxiosResponse): Promise<BoardItemTemplateAvailabilityViewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardItemTemplateAvailabilityViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardItemTemplateAvailabilityViewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemTemplateAvailabilityViewDto[]>(null as any);
    }

    storeAvailability(boardItemId: string, model: BoardItemTemplateAvailabilityViewDto[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BoardItemTemplate/templates/{boardItemId}/availability";
        if (boardItemId === undefined || boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' must be defined.");
        url_ = url_.replace("{boardItemId}", encodeURIComponent("" + boardItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStoreAvailability(_response);
        });
    }

    protected processStoreAvailability(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    removeTemplate(boardItemId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BoardItemTemplate/templates/{boardItemId}";
        if (boardItemId === undefined || boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' must be defined.");
        url_ = url_.replace("{boardItemId}", encodeURIComponent("" + boardItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveTemplate(_response);
        });
    }

    protected processRemoveTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getListForBoard(id: string, cancelToken?: CancelToken): Promise<TemplateCategoryWithTemplatesDto[]> {
        let url_ = this.baseUrl + "/api/BoardItemTemplate/boardtemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListForBoard(_response);
        });
    }

    protected processGetListForBoard(response: AxiosResponse): Promise<TemplateCategoryWithTemplatesDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateCategoryWithTemplatesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TemplateCategoryWithTemplatesDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateCategoryWithTemplatesDto[]>(null as any);
    }
}

export class BoardItemTemplateScheduleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    get(boardItemId: string, cancelToken?: CancelToken): Promise<BoardItemTemplateScheduleDto[]> {
        let url_ = this.baseUrl + "/api/BoardItemTemplateSchedule/{boardItemId}";
        if (boardItemId === undefined || boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' must be defined.");
        url_ = url_.replace("{boardItemId}", encodeURIComponent("" + boardItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BoardItemTemplateScheduleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardItemTemplateScheduleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardItemTemplateScheduleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemTemplateScheduleDto[]>(null as any);
    }

    post(dto: BoardItemTemplateScheduleInsertDto, cancelToken?: CancelToken): Promise<BoardItemTemplateScheduleDto> {
        let url_ = this.baseUrl + "/api/BoardItemTemplateSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<BoardItemTemplateScheduleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemTemplateScheduleDto.fromJS(resultData200);
            return Promise.resolve<BoardItemTemplateScheduleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemTemplateScheduleDto>(null as any);
    }

    delete(boardItemTemplateScheduleId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BoardItemTemplateSchedule/{boardItemTemplateScheduleId}";
        if (boardItemTemplateScheduleId === undefined || boardItemTemplateScheduleId === null)
            throw new globalThis.Error("The parameter 'boardItemTemplateScheduleId' must be defined.");
        url_ = url_.replace("{boardItemTemplateScheduleId}", encodeURIComponent("" + boardItemTemplateScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class BoardItemTransferClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    processDelegatedItem(boardItemId: string | undefined, accept: boolean | undefined, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItemTransfer/process?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        if (accept === null)
            throw new globalThis.Error("The parameter 'accept' cannot be null.");
        else if (accept !== undefined)
            url_ += "accept=" + encodeURIComponent("" + accept) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessDelegatedItem(_response);
        });
    }

    protected processProcessDelegatedItem(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    moveBack(boardItemId: string | undefined, moveType: MoveBackTypeDto | undefined, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItemTransfer/moveback?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        if (moveType === null)
            throw new globalThis.Error("The parameter 'moveType' cannot be null.");
        else if (moveType !== undefined)
            url_ += "moveType=" + encodeURIComponent("" + moveType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveBack(_response);
        });
    }

    protected processMoveBack(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    move(dto: BoardItemTransferDto, cancelToken?: CancelToken): Promise<ValueTupleOfBoardItemDtoAndBoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItemTransfer/move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: AxiosResponse): Promise<ValueTupleOfBoardItemDtoAndBoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValueTupleOfBoardItemDtoAndBoardItemDto.fromJS(resultData200);
            return Promise.resolve<ValueTupleOfBoardItemDtoAndBoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueTupleOfBoardItemDtoAndBoardItemDto>(null as any);
    }

    getDelegatedBoardItems(boardId: string | undefined, cancelToken?: CancelToken): Promise<BoardItemDto[]> {
        let url_ = this.baseUrl + "/api/BoardItemTransfer/delegate?";
        if (boardId === null)
            throw new globalThis.Error("The parameter 'boardId' cannot be null.");
        else if (boardId !== undefined)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDelegatedBoardItems(_response);
        });
    }

    protected processGetDelegatedBoardItems(response: AxiosResponse): Promise<BoardItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto[]>(null as any);
    }

    delegate(dto: BoardItemTransferDto, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/BoardItemTransfer/delegate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelegate(_response);
        });
    }

    protected processDelegate(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }
}

export class ChecklistClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    addChecklist(boardItemId: string | undefined, item: ChecklistDto, cancelToken?: CancelToken): Promise<ChecklistDto> {
        let url_ = this.baseUrl + "/api/Checklist/add/Checklist?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddChecklist(_response);
        });
    }

    protected processAddChecklist(response: AxiosResponse): Promise<ChecklistDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChecklistDto.fromJS(resultData200);
            return Promise.resolve<ChecklistDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistDto>(null as any);
    }

    addChecklistItem(boardItemId: string | undefined, item: ChecklistItemDto, cancelToken?: CancelToken): Promise<ChecklistItemDto> {
        let url_ = this.baseUrl + "/api/Checklist/add/ChecklistItem?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddChecklistItem(_response);
        });
    }

    protected processAddChecklistItem(response: AxiosResponse): Promise<ChecklistItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChecklistItemDto.fromJS(resultData200);
            return Promise.resolve<ChecklistItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistItemDto>(null as any);
    }

    updateChecklist(boardItemId: string | undefined, checkListId: string | undefined, title: string | null | undefined, cancelToken?: CancelToken): Promise<ChecklistDto> {
        let url_ = this.baseUrl + "/api/Checklist/update/Checklist?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        if (checkListId === null)
            throw new globalThis.Error("The parameter 'checkListId' cannot be null.");
        else if (checkListId !== undefined)
            url_ += "checkListId=" + encodeURIComponent("" + checkListId) + "&";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateChecklist(_response);
        });
    }

    protected processUpdateChecklist(response: AxiosResponse): Promise<ChecklistDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChecklistDto.fromJS(resultData200);
            return Promise.resolve<ChecklistDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistDto>(null as any);
    }

    changeSortOrder(boardItemId: string | undefined, checkListId: string | undefined, direction: number | undefined, cancelToken?: CancelToken): Promise<ChecklistDto> {
        let url_ = this.baseUrl + "/api/Checklist/changeSortOrder?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        if (checkListId === null)
            throw new globalThis.Error("The parameter 'checkListId' cannot be null.");
        else if (checkListId !== undefined)
            url_ += "checkListId=" + encodeURIComponent("" + checkListId) + "&";
        if (direction === null)
            throw new globalThis.Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeSortOrder(_response);
        });
    }

    protected processChangeSortOrder(response: AxiosResponse): Promise<ChecklistDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChecklistDto.fromJS(resultData200);
            return Promise.resolve<ChecklistDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistDto>(null as any);
    }

    changeItemSortOrder(boardItemId: string | undefined, checkListItemId: string | undefined, direction: number | undefined, cancelToken?: CancelToken): Promise<ChecklistItemDto> {
        let url_ = this.baseUrl + "/api/Checklist/changeItemSortOrder?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        if (checkListItemId === null)
            throw new globalThis.Error("The parameter 'checkListItemId' cannot be null.");
        else if (checkListItemId !== undefined)
            url_ += "checkListItemId=" + encodeURIComponent("" + checkListItemId) + "&";
        if (direction === null)
            throw new globalThis.Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeItemSortOrder(_response);
        });
    }

    protected processChangeItemSortOrder(response: AxiosResponse): Promise<ChecklistItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChecklistItemDto.fromJS(resultData200);
            return Promise.resolve<ChecklistItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistItemDto>(null as any);
    }

    updateChecklistItem(boardItemId: string | undefined, item: ChecklistItemDto, cancelToken?: CancelToken): Promise<ChecklistItemDto> {
        let url_ = this.baseUrl + "/api/Checklist/update/ChecklistItem?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateChecklistItem(_response);
        });
    }

    protected processUpdateChecklistItem(response: AxiosResponse): Promise<ChecklistItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChecklistItemDto.fromJS(resultData200);
            return Promise.resolve<ChecklistItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistItemDto>(null as any);
    }

    deleteChecklist(boardItemId: string | undefined, checkListId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Checklist/Checklist?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        if (checkListId === null)
            throw new globalThis.Error("The parameter 'checkListId' cannot be null.");
        else if (checkListId !== undefined)
            url_ += "checkListId=" + encodeURIComponent("" + checkListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteChecklist(_response);
        });
    }

    protected processDeleteChecklist(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteChecklistItem(boardItemId: string | undefined, checkListId: string | undefined, checklistItemId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Checklist/ChecklistItem?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        if (checkListId === null)
            throw new globalThis.Error("The parameter 'checkListId' cannot be null.");
        else if (checkListId !== undefined)
            url_ += "checkListId=" + encodeURIComponent("" + checkListId) + "&";
        if (checklistItemId === null)
            throw new globalThis.Error("The parameter 'checklistItemId' cannot be null.");
        else if (checklistItemId !== undefined)
            url_ += "checklistItemId=" + encodeURIComponent("" + checklistItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteChecklistItem(_response);
        });
    }

    protected processDeleteChecklistItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CommentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    updateComment(updates: BoardItemCommentDto, cancelToken?: CancelToken): Promise<BoardItemCommentDto> {
        let url_ = this.baseUrl + "/api/Comment/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updates);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComment(_response);
        });
    }

    protected processUpdateComment(response: AxiosResponse): Promise<BoardItemCommentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemCommentDto.fromJS(resultData200);
            return Promise.resolve<BoardItemCommentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemCommentDto>(null as any);
    }
}

export class ConfigClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getPublicConfig(tenant: string | null | undefined, cancelToken?: CancelToken): Promise<PublicConfigDto> {
        let url_ = this.baseUrl + "/api/Config/public?";
        if (tenant !== undefined && tenant !== null)
            url_ += "tenant=" + encodeURIComponent("" + tenant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicConfig(_response);
        });
    }

    protected processGetPublicConfig(response: AxiosResponse): Promise<PublicConfigDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicConfigDto.fromJS(resultData200);
            return Promise.resolve<PublicConfigDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicConfigDto>(null as any);
    }
}

export class LabelsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getGeneralLabels( cancelToken?: CancelToken): Promise<LabelDto[]> {
        let url_ = this.baseUrl + "/api/Labels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralLabels(_response);
        });
    }

    protected processGetGeneralLabels(response: AxiosResponse): Promise<LabelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LabelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabelDto[]>(null as any);
    }

    updateBoardLabels(boardId: string | null | undefined, labels: LabelDto[], cancelToken?: CancelToken): Promise<LabelDto[]> {
        let url_ = this.baseUrl + "/api/Labels?";
        if (boardId !== undefined && boardId !== null)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(labels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBoardLabels(_response);
        });
    }

    protected processUpdateBoardLabels(response: AxiosResponse): Promise<LabelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LabelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabelDto[]>(null as any);
    }

    deleteLabel(labelId: string | undefined, cancelToken?: CancelToken): Promise<ServiceResultOfGuid> {
        let url_ = this.baseUrl + "/api/Labels?";
        if (labelId === null)
            throw new globalThis.Error("The parameter 'labelId' cannot be null.");
        else if (labelId !== undefined)
            url_ += "labelId=" + encodeURIComponent("" + labelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLabel(_response);
        });
    }

    protected processDeleteLabel(response: AxiosResponse): Promise<ServiceResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfGuid.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfGuid>(null as any);
    }

    getBoardSpecificLabels(boardId: string, cancelToken?: CancelToken): Promise<LabelDto[]> {
        let url_ = this.baseUrl + "/api/Labels/{boardId}";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoardSpecificLabels(_response);
        });
    }

    protected processGetBoardSpecificLabels(response: AxiosResponse): Promise<LabelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LabelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabelDto[]>(null as any);
    }

    getSelectedBoardLabels(boardId: string, cancelToken?: CancelToken): Promise<BoardLabelDto[]> {
        let url_ = this.baseUrl + "/api/Labels/selected/board/{boardId}";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectedBoardLabels(_response);
        });
    }

    protected processGetSelectedBoardLabels(response: AxiosResponse): Promise<BoardLabelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardLabelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardLabelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardLabelDto[]>(null as any);
    }

    updateSelectedBoardLabels(boardId: string, selectedLabels: string[], cancelToken?: CancelToken): Promise<BoardLabelDto[]> {
        let url_ = this.baseUrl + "/api/Labels/board/{boardId}";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedLabels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSelectedBoardLabels(_response);
        });
    }

    protected processUpdateSelectedBoardLabels(response: AxiosResponse): Promise<BoardLabelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardLabelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardLabelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardLabelDto[]>(null as any);
    }

    archiveLabel(id: string, cancelToken?: CancelToken): Promise<ServiceResultOfGuid> {
        let url_ = this.baseUrl + "/api/Labels/archive/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveLabel(_response);
        });
    }

    protected processArchiveLabel(response: AxiosResponse): Promise<ServiceResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfGuid.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfGuid>(null as any);
    }

    reactivateLabel(id: string, cancelToken?: CancelToken): Promise<ServiceResultOfGuid> {
        let url_ = this.baseUrl + "/api/Labels/reactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivateLabel(_response);
        });
    }

    protected processReactivateLabel(response: AxiosResponse): Promise<ServiceResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfGuid.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfGuid>(null as any);
    }

    addLabelToBoardItem(boardItemId: string | undefined, labelId: string | undefined, cancelToken?: CancelToken): Promise<BoardItemLabelsDto> {
        let url_ = this.baseUrl + "/api/Labels/boardItem?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        if (labelId === null)
            throw new globalThis.Error("The parameter 'labelId' cannot be null.");
        else if (labelId !== undefined)
            url_ += "labelId=" + encodeURIComponent("" + labelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddLabelToBoardItem(_response);
        });
    }

    protected processAddLabelToBoardItem(response: AxiosResponse): Promise<BoardItemLabelsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemLabelsDto.fromJS(resultData200);
            return Promise.resolve<BoardItemLabelsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemLabelsDto>(null as any);
    }

    removeLabelFromBoardItem(boardItemId: string | undefined, labelId: string | undefined, cancelToken?: CancelToken): Promise<BoardItemLabelsDto> {
        let url_ = this.baseUrl + "/api/Labels/boardItem?";
        if (boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' cannot be null.");
        else if (boardItemId !== undefined)
            url_ += "boardItemId=" + encodeURIComponent("" + boardItemId) + "&";
        if (labelId === null)
            throw new globalThis.Error("The parameter 'labelId' cannot be null.");
        else if (labelId !== undefined)
            url_ += "labelId=" + encodeURIComponent("" + labelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveLabelFromBoardItem(_response);
        });
    }

    protected processRemoveLabelFromBoardItem(response: AxiosResponse): Promise<BoardItemLabelsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemLabelsDto.fromJS(resultData200);
            return Promise.resolve<BoardItemLabelsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemLabelsDto>(null as any);
    }
}

export class LogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    get( cancelToken?: CancelToken): Promise<LogDto[]> {
        let url_ = this.baseUrl + "/api/Log";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<LogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LogDto[]>(null as any);
    }

    getConnectedUsers( cancelToken?: CancelToken): Promise<ConnectedUserInfo[]> {
        let url_ = this.baseUrl + "/api/Log/connectedusers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConnectedUsers(_response);
        });
    }

    protected processGetConnectedUsers(response: AxiosResponse): Promise<ConnectedUserInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConnectedUserInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ConnectedUserInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConnectedUserInfo[]>(null as any);
    }
}

export class LookupClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getAirports( cancelToken?: CancelToken): Promise<AirportDto[]> {
        let url_ = this.baseUrl + "/api/Lookup/airports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAirports(_response);
        });
    }

    protected processGetAirports(response: AxiosResponse): Promise<AirportDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AirportDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AirportDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AirportDto[]>(null as any);
    }

    getEmailContacts(boardId: string, query: string | null | undefined, cancelToken?: CancelToken): Promise<EmailContactDto[]> {
        let url_ = this.baseUrl + "/api/Lookup/{boardId}/emailcontacts?";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailContacts(_response);
        });
    }

    protected processGetEmailContacts(response: AxiosResponse): Promise<EmailContactDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailContactDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmailContactDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailContactDto[]>(null as any);
    }

    getDiversionReasons( cancelToken?: CancelToken): Promise<DiversionReasonDto[]> {
        let url_ = this.baseUrl + "/api/Lookup/diversionreasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiversionReasons(_response);
        });
    }

    protected processGetDiversionReasons(response: AxiosResponse): Promise<DiversionReasonDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiversionReasonDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DiversionReasonDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiversionReasonDto[]>(null as any);
    }

    syncEmailContacts( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Lookup/Sync/InfoboxContacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncEmailContacts(_response);
        });
    }

    protected processSyncEmailContacts(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MaterialRequestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getById(id: string, cancelToken?: CancelToken): Promise<MaterialRequestDto> {
        let url_ = this.baseUrl + "/api/MaterialRequest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<MaterialRequestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialRequestDto.fromJS(resultData200);
            return Promise.resolve<MaterialRequestDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialRequestDto>(null as any);
    }

    getParts(id: string, cancelToken?: CancelToken): Promise<PartOverviewViewDto[]> {
        let url_ = this.baseUrl + "/api/MaterialRequest/{id}/partsoverview";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetParts(_response);
        });
    }

    protected processGetParts(response: AxiosResponse): Promise<PartOverviewViewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartOverviewViewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PartOverviewViewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartOverviewViewDto[]>(null as any);
    }

    createFromTechnicalOccurrence(id: string, cancelToken?: CancelToken): Promise<MaterialRequestDto> {
        let url_ = this.baseUrl + "/api/MaterialRequest/createFromTechnicalOccurrence/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFromTechnicalOccurrence(_response);
        });
    }

    protected processCreateFromTechnicalOccurrence(response: AxiosResponse): Promise<MaterialRequestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialRequestDto.fromJS(resultData200);
            return Promise.resolve<MaterialRequestDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialRequestDto>(null as any);
    }

    saveChanges(dto: MaterialRequestDto, cancelToken?: CancelToken): Promise<MaterialRequestDto> {
        let url_ = this.baseUrl + "/api/MaterialRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveChanges(_response);
        });
    }

    protected processSaveChanges(response: AxiosResponse): Promise<MaterialRequestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialRequestDto.fromJS(resultData200);
            return Promise.resolve<MaterialRequestDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialRequestDto>(null as any);
    }

    getPartEditDto(materialRequestId: string, partId: string, cancelToken?: CancelToken): Promise<PartDto> {
        let url_ = this.baseUrl + "/api/MaterialRequest/editPart/{materialRequestId}/{partId}";
        if (materialRequestId === undefined || materialRequestId === null)
            throw new globalThis.Error("The parameter 'materialRequestId' must be defined.");
        url_ = url_.replace("{materialRequestId}", encodeURIComponent("" + materialRequestId));
        if (partId === undefined || partId === null)
            throw new globalThis.Error("The parameter 'partId' must be defined.");
        url_ = url_.replace("{partId}", encodeURIComponent("" + partId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartEditDto(_response);
        });
    }

    protected processGetPartEditDto(response: AxiosResponse): Promise<PartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PartDto.fromJS(resultData200);
            return Promise.resolve<PartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartDto>(null as any);
    }

    editPart(dto: PartDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/editPart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditPart(_response);
        });
    }

    protected processEditPart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getVendorRequests(id: string, cancelToken?: CancelToken): Promise<VendorRequestDto[]> {
        let url_ = this.baseUrl + "/api/MaterialRequest/{id}/vendorrequests";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVendorRequests(_response);
        });
    }

    protected processGetVendorRequests(response: AxiosResponse): Promise<VendorRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorRequestDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<VendorRequestDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorRequestDto[]>(null as any);
    }

    addVendor(dto: AddMaterialRequestVendorDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/addvendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddVendor(_response);
        });
    }

    protected processAddVendor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getMaterialRequestSettings( cancelToken?: CancelToken): Promise<ServiceResultOfMaterialRequestSettingsDto> {
        let url_ = this.baseUrl + "/api/MaterialRequest/setings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialRequestSettings(_response);
        });
    }

    protected processGetMaterialRequestSettings(response: AxiosResponse): Promise<ServiceResultOfMaterialRequestSettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfMaterialRequestSettingsDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfMaterialRequestSettingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfMaterialRequestSettingsDto>(null as any);
    }

    updateMaterialRequestSettings(updates: MaterialRequestSettingsDto, cancelToken?: CancelToken): Promise<ServiceResultOfMaterialRequestSettingsDto> {
        let url_ = this.baseUrl + "/api/MaterialRequest/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updates);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMaterialRequestSettings(_response);
        });
    }

    protected processUpdateMaterialRequestSettings(response: AxiosResponse): Promise<ServiceResultOfMaterialRequestSettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfMaterialRequestSettingsDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfMaterialRequestSettingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfMaterialRequestSettingsDto>(null as any);
    }

    selectVendors(dto: SelectMaterialRequestVendorDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/selectvendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSelectVendors(_response);
        });
    }

    protected processSelectVendors(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    editVendorRequestRemarks(editDto: VendorRequestEditRemarksDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/editVendorRequestRemarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditVendorRequestRemarks(_response);
        });
    }

    protected processEditVendorRequestRemarks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getVendorRequestPartEditDto(vendorRequestPartId: string, cancelToken?: CancelToken): Promise<VendorRequestPartEditDto> {
        let url_ = this.baseUrl + "/api/MaterialRequest/editVendorRequestPart/{vendorRequestPartId}";
        if (vendorRequestPartId === undefined || vendorRequestPartId === null)
            throw new globalThis.Error("The parameter 'vendorRequestPartId' must be defined.");
        url_ = url_.replace("{vendorRequestPartId}", encodeURIComponent("" + vendorRequestPartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVendorRequestPartEditDto(_response);
        });
    }

    protected processGetVendorRequestPartEditDto(response: AxiosResponse): Promise<VendorRequestPartEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VendorRequestPartEditDto.fromJS(resultData200);
            return Promise.resolve<VendorRequestPartEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorRequestPartEditDto>(null as any);
    }

    editVendorRequestPart(dto: VendorRequestPartEditDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/editVendorRequestPart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditVendorRequestPart(_response);
        });
    }

    protected processEditVendorRequestPart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getVendorRequestPartOrderEditDto(vendorRequestPartId: string, cancelToken?: CancelToken): Promise<VendorRequestPartOrderEditDto> {
        let url_ = this.baseUrl + "/api/MaterialRequest/editVendorRequestPartOrder/{vendorRequestPartId}";
        if (vendorRequestPartId === undefined || vendorRequestPartId === null)
            throw new globalThis.Error("The parameter 'vendorRequestPartId' must be defined.");
        url_ = url_.replace("{vendorRequestPartId}", encodeURIComponent("" + vendorRequestPartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVendorRequestPartOrderEditDto(_response);
        });
    }

    protected processGetVendorRequestPartOrderEditDto(response: AxiosResponse): Promise<VendorRequestPartOrderEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VendorRequestPartOrderEditDto.fromJS(resultData200);
            return Promise.resolve<VendorRequestPartOrderEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorRequestPartOrderEditDto>(null as any);
    }

    markAllPartsAsNotAvailable(vendorRequestId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/markallpartsasnotavailable/{vendorRequestId}";
        if (vendorRequestId === undefined || vendorRequestId === null)
            throw new globalThis.Error("The parameter 'vendorRequestId' must be defined.");
        url_ = url_.replace("{vendorRequestId}", encodeURIComponent("" + vendorRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAllPartsAsNotAvailable(_response);
        });
    }

    protected processMarkAllPartsAsNotAvailable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    editVendorRequestPartOrder(dto: VendorRequestPartOrderEditDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/editVendorRequestPartOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditVendorRequestPartOrder(_response);
        });
    }

    protected processEditVendorRequestPartOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getShipper( cancelToken?: CancelToken): Promise<ShipperDto[]> {
        let url_ = this.baseUrl + "/api/MaterialRequest/Shipper";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShipper(_response);
        });
    }

    protected processGetShipper(response: AxiosResponse): Promise<ShipperDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShipperDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShipperDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShipperDto[]>(null as any);
    }

    getRequestStatus( cancelToken?: CancelToken): Promise<RequestStatusDto[]> {
        let url_ = this.baseUrl + "/api/MaterialRequest/RequestStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestStatus(_response);
        });
    }

    protected processGetRequestStatus(response: AxiosResponse): Promise<RequestStatusDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequestStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RequestStatusDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestStatusDto[]>(null as any);
    }

    getOrderStatus( cancelToken?: CancelToken): Promise<OrderStatusDto[]> {
        let url_ = this.baseUrl + "/api/MaterialRequest/OrderStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderStatus(_response);
        });
    }

    protected processGetOrderStatus(response: AxiosResponse): Promise<OrderStatusDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderStatusDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderStatusDto[]>(null as any);
    }

    getShipmentStatus( cancelToken?: CancelToken): Promise<ShipmentStatusDto[]> {
        let url_ = this.baseUrl + "/api/MaterialRequest/ShipmentStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShipmentStatus(_response);
        });
    }

    protected processGetShipmentStatus(response: AxiosResponse): Promise<ShipmentStatusDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShipmentStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShipmentStatusDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShipmentStatusDto[]>(null as any);
    }

    getVendorRequestEmailById(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MaterialRequest/vendorrequestemail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVendorRequestEmailById(_response);
        });
    }

    protected processGetVendorRequestEmailById(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    sendVendorRequest(dto: SendVendorRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/SendVendorRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendVendorRequest(_response);
        });
    }

    protected processSendVendorRequest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getNumberOfPendingVendorRequests(materialRequestId: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/MaterialRequest/GetNumberOfPendingVendorRequests/{materialRequestId}";
        if (materialRequestId === undefined || materialRequestId === null)
            throw new globalThis.Error("The parameter 'materialRequestId' must be defined.");
        url_ = url_.replace("{materialRequestId}", encodeURIComponent("" + materialRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNumberOfPendingVendorRequests(_response);
        });
    }

    protected processGetNumberOfPendingVendorRequests(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    sendAllPendingVendorRequests(materialRequestId: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/MaterialRequest/SendAllPendingVendorRequests/{materialRequestId}";
        if (materialRequestId === undefined || materialRequestId === null)
            throw new globalThis.Error("The parameter 'materialRequestId' must be defined.");
        url_ = url_.replace("{materialRequestId}", encodeURIComponent("" + materialRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendAllPendingVendorRequests(_response);
        });
    }

    protected processSendAllPendingVendorRequests(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getLogisticsEmailById(id: string, shipperId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MaterialRequest/logisticsemail/{id}/{shipperId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (shipperId === undefined || shipperId === null)
            throw new globalThis.Error("The parameter 'shipperId' must be defined.");
        url_ = url_.replace("{shipperId}", encodeURIComponent("" + shipperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogisticsEmailById(_response);
        });
    }

    protected processGetLogisticsEmailById(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    sendLogisticsEmail(dto: SendLogisticsEmailDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/SendLogisticsEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendLogisticsEmail(_response);
        });
    }

    protected processSendLogisticsEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getManagementStatusEmailById(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MaterialRequest/managementstatusemail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManagementStatusEmailById(_response);
        });
    }

    protected processGetManagementStatusEmailById(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    sendManagementStatusEmail(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/sendmanagementstatusemail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendManagementStatusEmail(_response);
        });
    }

    protected processSendManagementStatusEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getVendors( cancelToken?: CancelToken): Promise<VendorDto[]> {
        let url_ = this.baseUrl + "/api/MaterialRequest/vendors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVendors(_response);
        });
    }

    protected processGetVendors(response: AxiosResponse): Promise<VendorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<VendorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorDto[]>(null as any);
    }

    getVendorsWithDistance(materialRequestId: string, cancelToken?: CancelToken): Promise<VendorDto[]> {
        let url_ = this.baseUrl + "/api/MaterialRequest/vendorsWithDistance/{materialRequestId}";
        if (materialRequestId === undefined || materialRequestId === null)
            throw new globalThis.Error("The parameter 'materialRequestId' must be defined.");
        url_ = url_.replace("{materialRequestId}", encodeURIComponent("" + materialRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVendorsWithDistance(_response);
        });
    }

    protected processGetVendorsWithDistance(response: AxiosResponse): Promise<VendorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<VendorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorDto[]>(null as any);
    }

    deletePart(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/part/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePart(_response);
        });
    }

    protected processDeletePart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteVendorRequestPart(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MaterialRequest/vendorrequestpart/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVendorRequestPart(_response);
        });
    }

    protected processDeleteVendorRequestPart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    processMaterialRequestReport(id: string, cancelToken?: CancelToken): Promise<MaterialRequestReportResponse> {
        let url_ = this.baseUrl + "/api/MaterialRequest/processmaterialrequestreport/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessMaterialRequestReport(_response);
        });
    }

    protected processProcessMaterialRequestReport(response: AxiosResponse): Promise<MaterialRequestReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaterialRequestReportResponse.fromJS(resultData200);
            return Promise.resolve<MaterialRequestReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialRequestReportResponse>(null as any);
    }

    postponeManagementReport(postponeDto: ManagementReportPostponeDto, cancelToken?: CancelToken): Promise<ServiceResultOfManagementReportInfoDto> {
        let url_ = this.baseUrl + "/api/MaterialRequest/postpone-management-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postponeDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostponeManagementReport(_response);
        });
    }

    protected processPostponeManagementReport(response: AxiosResponse): Promise<ServiceResultOfManagementReportInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfManagementReportInfoDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfManagementReportInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfManagementReportInfoDto>(null as any);
    }
}

export class NodeStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    get( cancelToken?: CancelToken): Promise<NodeStatusDto> {
        let url_ = this.baseUrl + "/api/NodeStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<NodeStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NodeStatusDto.fromJS(resultData200);
            return Promise.resolve<NodeStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NodeStatusDto>(null as any);
    }
}

export class NotificationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getAllBoardNotifications(boardId: string, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Notification/board/{boardId}";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBoardNotifications(_response);
        });
    }

    protected processGetAllBoardNotifications(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class OverviewClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getBoardOverview(entityId: string | undefined, dateRangeFrom: string | null | undefined, dateRangeTo: string | null | undefined, orderByDesc: boolean | undefined, searchString: string | null | undefined, cancelToken?: CancelToken): Promise<BoardItemDto[]> {
        let url_ = this.baseUrl + "/api/Overview/board?";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (dateRangeFrom !== undefined && dateRangeFrom !== null)
            url_ += "DateRangeFrom=" + encodeURIComponent("" + dateRangeFrom) + "&";
        if (dateRangeTo !== undefined && dateRangeTo !== null)
            url_ += "DateRangeTo=" + encodeURIComponent("" + dateRangeTo) + "&";
        if (orderByDesc === null)
            throw new globalThis.Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "OrderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoardOverview(_response);
        });
    }

    protected processGetBoardOverview(response: AxiosResponse): Promise<BoardItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto[]>(null as any);
    }

    getShiftsHandoverOverview(entityId: string | undefined, dateRangeFrom: string | null | undefined, dateRangeTo: string | null | undefined, orderByDesc: boolean | undefined, searchString: string | null | undefined, cancelToken?: CancelToken): Promise<ShiftHandoverOverviewDto[]> {
        let url_ = this.baseUrl + "/api/Overview/shifts?";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (dateRangeFrom !== undefined && dateRangeFrom !== null)
            url_ += "DateRangeFrom=" + encodeURIComponent("" + dateRangeFrom) + "&";
        if (dateRangeTo !== undefined && dateRangeTo !== null)
            url_ += "DateRangeTo=" + encodeURIComponent("" + dateRangeTo) + "&";
        if (orderByDesc === null)
            throw new globalThis.Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "OrderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiftsHandoverOverview(_response);
        });
    }

    protected processGetShiftsHandoverOverview(response: AxiosResponse): Promise<ShiftHandoverOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftHandoverOverviewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShiftHandoverOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftHandoverOverviewDto[]>(null as any);
    }

    getShiftOverview(entityId: string | undefined, searchString: string | null | undefined, cancelToken?: CancelToken): Promise<ShiftHandoverBoardItemDto[]> {
        let url_ = this.baseUrl + "/api/Overview/shift?";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiftOverview(_response);
        });
    }

    protected processGetShiftOverview(response: AxiosResponse): Promise<ShiftHandoverBoardItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftHandoverBoardItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShiftHandoverBoardItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftHandoverBoardItemDto[]>(null as any);
    }

    getSpecialOccurrencesOverview(dateRangeFrom: string | null | undefined, dateRangeTo: string | null | undefined, orderByDesc: boolean | undefined, searchString: string | null | undefined, cancelToken?: CancelToken): Promise<SpecialOccurrenceOverviewDto[]> {
        let url_ = this.baseUrl + "/api/Overview?";
        if (dateRangeFrom !== undefined && dateRangeFrom !== null)
            url_ += "DateRangeFrom=" + encodeURIComponent("" + dateRangeFrom) + "&";
        if (dateRangeTo !== undefined && dateRangeTo !== null)
            url_ += "DateRangeTo=" + encodeURIComponent("" + dateRangeTo) + "&";
        if (orderByDesc === null)
            throw new globalThis.Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "OrderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpecialOccurrencesOverview(_response);
        });
    }

    protected processGetSpecialOccurrencesOverview(response: AxiosResponse): Promise<SpecialOccurrenceOverviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecialOccurrenceOverviewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SpecialOccurrenceOverviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceOverviewDto[]>(null as any);
    }
}

export class PingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    get( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getWithDatabase( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/db";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWithDatabase(_response);
        });
    }

    protected processGetWithDatabase(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ReportsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getLabelsReport(query: GetLabelsStatisticQuery, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLabelsReport(_response);
        });
    }

    protected processGetLabelsReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLabelsUsageStatistics(query: GetLabelsStatisticQuery, cancelToken?: CancelToken): Promise<GeneralLabelUsageInfo[]> {
        let url_ = this.baseUrl + "/api/Reports/mostly-used-labels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLabelsUsageStatistics(_response);
        });
    }

    protected processGetLabelsUsageStatistics(response: AxiosResponse): Promise<GeneralLabelUsageInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralLabelUsageInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GeneralLabelUsageInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralLabelUsageInfo[]>(null as any);
    }

    getLabelsOverTimeUsageStatistic(query: GetLabelsStatisticQuery, cancelToken?: CancelToken): Promise<LabelsOverTimeUsageApiDto> {
        let url_ = this.baseUrl + "/api/Reports/labels-over-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLabelsOverTimeUsageStatistic(_response);
        });
    }

    protected processGetLabelsOverTimeUsageStatistic(response: AxiosResponse): Promise<LabelsOverTimeUsageApiDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LabelsOverTimeUsageApiDto.fromJS(resultData200);
            return Promise.resolve<LabelsOverTimeUsageApiDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabelsOverTimeUsageApiDto>(null as any);
    }

    getBoardItemPdfReport(id: string, includeAttachments: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeAttachments === null)
            throw new globalThis.Error("The parameter 'includeAttachments' cannot be null.");
        else if (includeAttachments !== undefined)
            url_ += "includeAttachments=" + encodeURIComponent("" + includeAttachments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoardItemPdfReport(_response);
        });
    }

    protected processGetBoardItemPdfReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getBoardInitialSettings(boardId: string, cancelToken?: CancelToken): Promise<InitialBoardSettingsDto> {
        let url_ = this.baseUrl + "/api/Settings/{boardId}/initial";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoardInitialSettings(_response);
        });
    }

    protected processGetBoardInitialSettings(response: AxiosResponse): Promise<InitialBoardSettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InitialBoardSettingsDto.fromJS(resultData200);
            return Promise.resolve<InitialBoardSettingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InitialBoardSettingsDto>(null as any);
    }

    updateBoardInitialSettings(settings: InitialBoardSettingsDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Settings/initial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBoardInitialSettings(_response);
        });
    }

    protected processUpdateBoardInitialSettings(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSendAsEmailSettings(boardId: string, cancelToken?: CancelToken): Promise<SendAsEmailConfigDto> {
        let url_ = this.baseUrl + "/api/Settings/{boardId}/sendasemail";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSendAsEmailSettings(_response);
        });
    }

    protected processGetSendAsEmailSettings(response: AxiosResponse): Promise<SendAsEmailConfigDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendAsEmailConfigDto.fromJS(resultData200);
            return Promise.resolve<SendAsEmailConfigDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendAsEmailConfigDto>(null as any);
    }

    storeSendAsEmailSettings(boardId: string, model: SendAsEmailConfigDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Settings/{boardId}/sendasemail";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStoreSendAsEmailSettings(_response);
        });
    }

    protected processStoreSendAsEmailSettings(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getShiftValidationSettings(boardId: string, cancelToken?: CancelToken): Promise<ShiftValidationSettingsDto> {
        let url_ = this.baseUrl + "/api/Settings/{boardId}/shift-validation";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiftValidationSettings(_response);
        });
    }

    protected processGetShiftValidationSettings(response: AxiosResponse): Promise<ShiftValidationSettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShiftValidationSettingsDto.fromJS(resultData200);
            return Promise.resolve<ShiftValidationSettingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftValidationSettingsDto>(null as any);
    }

    updateShiftValidationSettings(settings: ShiftValidationSettingsDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Settings/shift-validation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateShiftValidationSettings(_response);
        });
    }

    protected processUpdateShiftValidationSettings(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getEmailConfig(boardId: string, cancelToken?: CancelToken): Promise<EmailConfigDto[]> {
        let url_ = this.baseUrl + "/api/Settings/{boardId}/emailconfig";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailConfig(_response);
        });
    }

    protected processGetEmailConfig(response: AxiosResponse): Promise<EmailConfigDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailConfigDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmailConfigDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailConfigDto[]>(null as any);
    }

    storeEmailConfig(emailConfig: EmailConfigDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Settings/emailconfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailConfig);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStoreEmailConfig(_response);
        });
    }

    protected processStoreEmailConfig(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ShiftClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    prepareShiftHandover(boardId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Shift/{boardId}/prepare";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrepareShiftHandover(_response);
        });
    }

    protected processPrepareShiftHandover(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SpecialOccurrenceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getActiveAndArchivedOccurrences( cancelToken?: CancelToken): Promise<SpecialOccurrenceViewListDto> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/ActiveAndArchived";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveAndArchivedOccurrences(_response);
        });
    }

    protected processGetActiveAndArchivedOccurrences(response: AxiosResponse): Promise<SpecialOccurrenceViewListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpecialOccurrenceViewListDto.fromJS(resultData200);
            return Promise.resolve<SpecialOccurrenceViewListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceViewListDto>(null as any);
    }

    getMaintenanceCompanies( cancelToken?: CancelToken): Promise<MaintenanceCompanyDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaintenanceCompanies(_response);
        });
    }

    protected processGetMaintenanceCompanies(response: AxiosResponse): Promise<MaintenanceCompanyDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintenanceCompanyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MaintenanceCompanyDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaintenanceCompanyDto[]>(null as any);
    }

    getTechnicalOccurrenceTypes( cancelToken?: CancelToken): Promise<TechnicalOccurrenceTypeDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/TechnicalOccurrenceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTechnicalOccurrenceTypes(_response);
        });
    }

    protected processGetTechnicalOccurrenceTypes(response: AxiosResponse): Promise<TechnicalOccurrenceTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TechnicalOccurrenceTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TechnicalOccurrenceTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TechnicalOccurrenceTypeDto[]>(null as any);
    }

    getSelectedFlightReasons( cancelToken?: CancelToken): Promise<SelectedFlightReasonDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/selectedFlightReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectedFlightReasons(_response);
        });
    }

    protected processGetSelectedFlightReasons(response: AxiosResponse): Promise<SelectedFlightReasonDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectedFlightReasonDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SelectedFlightReasonDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectedFlightReasonDto[]>(null as any);
    }

    getPossibleOwnerBoards( cancelToken?: CancelToken): Promise<BoardDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/possibleOwnerBoards";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPossibleOwnerBoards(_response);
        });
    }

    protected processGetPossibleOwnerBoards(response: AxiosResponse): Promise<BoardDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardDto[]>(null as any);
    }

    getCurrentUserAccessLevel(id: string, cancelToken?: CancelToken): Promise<SpecialOccurrenceAccessLevel> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/currentUserAccessLevel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserAccessLevel(_response);
        });
    }

    protected processGetCurrentUserAccessLevel(response: AxiosResponse): Promise<SpecialOccurrenceAccessLevel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<SpecialOccurrenceAccessLevel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceAccessLevel>(null as any);
    }

    getAll( cancelToken?: CancelToken): Promise<SpecialOccurrenceDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<SpecialOccurrenceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecialOccurrenceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SpecialOccurrenceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceDto[]>(null as any);
    }

    post(occurrence: CreateSpecialOccurrenceDto, cancelToken?: CancelToken): Promise<SpecialOccurrenceDto> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(occurrence);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<SpecialOccurrenceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpecialOccurrenceDto.fromJS(resultData200);
            return Promise.resolve<SpecialOccurrenceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceDto>(null as any);
    }

    saveChanges(dto: SpecialOccurrenceDto, cancelToken?: CancelToken): Promise<SpecialOccurrenceDto> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveChanges(_response);
        });
    }

    protected processSaveChanges(response: AxiosResponse): Promise<SpecialOccurrenceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpecialOccurrenceDto.fromJS(resultData200);
            return Promise.resolve<SpecialOccurrenceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceDto>(null as any);
    }

    getAllGrouped( cancelToken?: CancelToken): Promise<SpecialOccurrenceListDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/getAllActiveGrouped";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllGrouped(_response);
        });
    }

    protected processGetAllGrouped(response: AxiosResponse): Promise<SpecialOccurrenceListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecialOccurrenceListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SpecialOccurrenceListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceListDto[]>(null as any);
    }

    getById(id: string, cancelToken?: CancelToken): Promise<SpecialOccurrenceDto> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SpecialOccurrenceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpecialOccurrenceDto.fromJS(resultData200);
            return Promise.resolve<SpecialOccurrenceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceDto>(null as any);
    }

    getBoardItemTemplates(specialOccurrenceId: string, cancelToken?: CancelToken): Promise<BoardItemTemplateSpecialOccurenceDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/templates/{specialOccurrenceId}";
        if (specialOccurrenceId === undefined || specialOccurrenceId === null)
            throw new globalThis.Error("The parameter 'specialOccurrenceId' must be defined.");
        url_ = url_.replace("{specialOccurrenceId}", encodeURIComponent("" + specialOccurrenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoardItemTemplates(_response);
        });
    }

    protected processGetBoardItemTemplates(response: AxiosResponse): Promise<BoardItemTemplateSpecialOccurenceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardItemTemplateSpecialOccurenceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BoardItemTemplateSpecialOccurenceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemTemplateSpecialOccurenceDto[]>(null as any);
    }

    getAirports( cancelToken?: CancelToken): Promise<AirportDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/airports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAirports(_response);
        });
    }

    protected processGetAirports(response: AxiosResponse): Promise<AirportDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AirportDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AirportDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AirportDto[]>(null as any);
    }

    getAircrafts( cancelToken?: CancelToken): Promise<AircraftDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/aircrafts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAircrafts(_response);
        });
    }

    protected processGetAircrafts(response: AxiosResponse): Promise<AircraftDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AircraftDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AircraftDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AircraftDto[]>(null as any);
    }

    getAogFlights(date: string, cancelToken?: CancelToken): Promise<FlightInfoDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/AogFlights/{date}";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAogFlights(_response);
        });
    }

    protected processGetAogFlights(response: AxiosResponse): Promise<FlightInfoDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FlightInfoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<FlightInfoDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlightInfoDto[]>(null as any);
    }

    getComatRoutings(departure: string, arrival: string, date: string, cancelToken?: CancelToken): Promise<ComatRoutingDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/ComatRoutings/{departure}/{arrival}/{date}";
        if (departure === undefined || departure === null)
            throw new globalThis.Error("The parameter 'departure' must be defined.");
        url_ = url_.replace("{departure}", encodeURIComponent("" + departure));
        if (arrival === undefined || arrival === null)
            throw new globalThis.Error("The parameter 'arrival' must be defined.");
        url_ = url_.replace("{arrival}", encodeURIComponent("" + arrival));
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComatRoutings(_response);
        });
    }

    protected processGetComatRoutings(response: AxiosResponse): Promise<ComatRoutingDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComatRoutingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ComatRoutingDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComatRoutingDto[]>(null as any);
    }

    getDiversionFlights( cancelToken?: CancelToken): Promise<FlightInfoDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/DiversionFlights";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiversionFlights(_response);
        });
    }

    protected processGetDiversionFlights(response: AxiosResponse): Promise<FlightInfoDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FlightInfoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<FlightInfoDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlightInfoDto[]>(null as any);
    }

    createSpecialOccurrenceBoardItem(dto: BoardItemCreateFromTemplateDto, cancelToken?: CancelToken): Promise<BoardItemUpdateResultOfBoardItemDto> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/boardItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSpecialOccurrenceBoardItem(_response);
        });
    }

    protected processCreateSpecialOccurrenceBoardItem(response: AxiosResponse): Promise<BoardItemUpdateResultOfBoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemUpdateResultOfBoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemUpdateResultOfBoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemUpdateResultOfBoardItemDto>(null as any);
    }

    getSpecialOccurrenceBoardItems(occurrenceId: string, cancelToken?: CancelToken): Promise<SpecialOccurrenceBoardDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/boardItems/{occurrenceId}";
        if (occurrenceId === undefined || occurrenceId === null)
            throw new globalThis.Error("The parameter 'occurrenceId' must be defined.");
        url_ = url_.replace("{occurrenceId}", encodeURIComponent("" + occurrenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpecialOccurrenceBoardItems(_response);
        });
    }

    protected processGetSpecialOccurrenceBoardItems(response: AxiosResponse): Promise<SpecialOccurrenceBoardDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecialOccurrenceBoardDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SpecialOccurrenceBoardDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceBoardDto[]>(null as any);
    }

    getSpecialOccurrenceBoardSummary(occurrenceId: string | undefined, cancelToken?: CancelToken): Promise<SpecialOccurrenceBoardSummaryDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/items/status?";
        if (occurrenceId === null)
            throw new globalThis.Error("The parameter 'occurrenceId' cannot be null.");
        else if (occurrenceId !== undefined)
            url_ += "occurrenceId=" + encodeURIComponent("" + occurrenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpecialOccurrenceBoardSummary(_response);
        });
    }

    protected processGetSpecialOccurrenceBoardSummary(response: AxiosResponse): Promise<SpecialOccurrenceBoardSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecialOccurrenceBoardSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SpecialOccurrenceBoardSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceBoardSummaryDto[]>(null as any);
    }

    complete(dto: CompleteOccurrenceDto, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComplete(_response);
        });
    }

    protected processComplete(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    saveOccurrenceFlights(dto: SpecialOccurrenceFlightInsertDto, cancelToken?: CancelToken): Promise<SpecialOccurrenceDto> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/flights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveOccurrenceFlights(_response);
        });
    }

    protected processSaveOccurrenceFlights(response: AxiosResponse): Promise<SpecialOccurrenceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpecialOccurrenceDto.fromJS(resultData200);
            return Promise.resolve<SpecialOccurrenceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceDto>(null as any);
    }

    linkBoardItem(occurrenceId: string, boardItemId: string, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/{occurrenceId}/link/{boardItemId}";
        if (occurrenceId === undefined || occurrenceId === null)
            throw new globalThis.Error("The parameter 'occurrenceId' must be defined.");
        url_ = url_.replace("{occurrenceId}", encodeURIComponent("" + occurrenceId));
        if (boardItemId === undefined || boardItemId === null)
            throw new globalThis.Error("The parameter 'boardItemId' must be defined.");
        url_ = url_.replace("{boardItemId}", encodeURIComponent("" + boardItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkBoardItem(_response);
        });
    }

    protected processLinkBoardItem(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    unlinkBoardItem(boardItem: string, cancelToken?: CancelToken): Promise<BoardItemDto> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/unlink/{boardItem}";
        if (boardItem === undefined || boardItem === null)
            throw new globalThis.Error("The parameter 'boardItem' must be defined.");
        url_ = url_.replace("{boardItem}", encodeURIComponent("" + boardItem));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkBoardItem(_response);
        });
    }

    protected processUnlinkBoardItem(response: AxiosResponse): Promise<BoardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BoardItemDto.fromJS(resultData200);
            return Promise.resolve<BoardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BoardItemDto>(null as any);
    }

    getSpecialOccurrenceUpdates(occurrenceId: string, cancelToken?: CancelToken): Promise<SpecialOccurrenceUpdatesDto> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/updates/{occurrenceId}";
        if (occurrenceId === undefined || occurrenceId === null)
            throw new globalThis.Error("The parameter 'occurrenceId' must be defined.");
        url_ = url_.replace("{occurrenceId}", encodeURIComponent("" + occurrenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpecialOccurrenceUpdates(_response);
        });
    }

    protected processGetSpecialOccurrenceUpdates(response: AxiosResponse): Promise<SpecialOccurrenceUpdatesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpecialOccurrenceUpdatesDto.fromJS(resultData200);
            return Promise.resolve<SpecialOccurrenceUpdatesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceUpdatesDto>(null as any);
    }

    createSpecialOccurrenceUpdate(update: SpecialOccurrenceUpdateDto, cancelToken?: CancelToken): Promise<SpecialOccurrenceUpdateDto> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/updates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(update);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSpecialOccurrenceUpdate(_response);
        });
    }

    protected processCreateSpecialOccurrenceUpdate(response: AxiosResponse): Promise<SpecialOccurrenceUpdateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpecialOccurrenceUpdateDto.fromJS(resultData200);
            return Promise.resolve<SpecialOccurrenceUpdateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceUpdateDto>(null as any);
    }

    getOccurrenceUpdateRecipients(id: string, cancelToken?: CancelToken): Promise<OccurrenceUpdateRecipientDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/update-recipients/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOccurrenceUpdateRecipients(_response);
        });
    }

    protected processGetOccurrenceUpdateRecipients(response: AxiosResponse): Promise<OccurrenceUpdateRecipientDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OccurrenceUpdateRecipientDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OccurrenceUpdateRecipientDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OccurrenceUpdateRecipientDto[]>(null as any);
    }

    getComatTransportReport(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/ComatTransportReport/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComatTransportReport(_response);
        });
    }

    protected processGetComatTransportReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getComatStickerReport(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/ComatStickerReport/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComatStickerReport(_response);
        });
    }

    protected processGetComatStickerReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAccessLevels(id: string, cancelToken?: CancelToken): Promise<SpecialOccurrenceAccessLevelDto[]> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/AccessLevels/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccessLevels(_response);
        });
    }

    protected processGetAccessLevels(response: AxiosResponse): Promise<SpecialOccurrenceAccessLevelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecialOccurrenceAccessLevelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SpecialOccurrenceAccessLevelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialOccurrenceAccessLevelDto[]>(null as any);
    }

    setAccessLevel(dto: SpecialOccurrenceAccessLevelUpdateDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/SpecialOccurrence/AccessLevels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetAccessLevel(_response);
        });
    }

    protected processSetAccessLevel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SystemSettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getIsMaterialRequestEnabled( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SystemSettings/materialrequestenabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsMaterialRequestEnabled(_response);
        });
    }

    protected processGetIsMaterialRequestEnabled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSystemSettings( cancelToken?: CancelToken): Promise<SystemSettingsDto> {
        let url_ = this.baseUrl + "/api/SystemSettings/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSystemSettings(_response);
        });
    }

    protected processGetSystemSettings(response: AxiosResponse): Promise<SystemSettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemSettingsDto.fromJS(resultData200);
            return Promise.resolve<SystemSettingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemSettingsDto>(null as any);
    }
}

export class TemplateCategoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getByBoard(boardGuid: string, cancelToken?: CancelToken): Promise<TemplateCategoryDto[]> {
        let url_ = this.baseUrl + "/api/TemplateCategory/{boardGuid}";
        if (boardGuid === undefined || boardGuid === null)
            throw new globalThis.Error("The parameter 'boardGuid' must be defined.");
        url_ = url_.replace("{boardGuid}", encodeURIComponent("" + boardGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByBoard(_response);
        });
    }

    protected processGetByBoard(response: AxiosResponse): Promise<TemplateCategoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateCategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TemplateCategoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateCategoryDto[]>(null as any);
    }

    create(dto: TemplateCategoryDto, cancelToken?: CancelToken): Promise<TemplateCategoryDto> {
        let url_ = this.baseUrl + "/api/TemplateCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<TemplateCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateCategoryDto.fromJS(resultData200);
            return Promise.resolve<TemplateCategoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateCategoryDto>(null as any);
    }

    update(guid: string, dto: TemplateCategoryDto, cancelToken?: CancelToken): Promise<TemplateCategoryDto> {
        let url_ = this.baseUrl + "/api/TemplateCategory/{guid}";
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<TemplateCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateCategoryDto.fromJS(resultData200);
            return Promise.resolve<TemplateCategoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateCategoryDto>(null as any);
    }

    delete(guid: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TemplateCategory/{guid}";
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setTemplateCategory(boardItemGuid: string, categoryGuid: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TemplateCategory/template/{boardItemGuid}/category";
        if (boardItemGuid === undefined || boardItemGuid === null)
            throw new globalThis.Error("The parameter 'boardItemGuid' must be defined.");
        url_ = url_.replace("{boardItemGuid}", encodeURIComponent("" + boardItemGuid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(categoryGuid);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTemplateCategory(_response);
        });
    }

    protected processSetTemplateCategory(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5003";

    }

    getCurrentUser( cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    getAllUsers( cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/User/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUsers(_response);
        });
    }

    protected processGetAllUsers(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    getAvailableUsers(entityType: AvailabilityEntityType | undefined, entityId: string | undefined, cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/User/available?";
        if (entityType === null)
            throw new globalThis.Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableUsers(_response);
        });
    }

    protected processGetAvailableUsers(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    setTimezone(timezone: string | null | undefined, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/settimezone?";
        if (timezone !== undefined && timezone !== null)
            url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTimezone(_response);
        });
    }

    protected processSetTimezone(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    getNotificationSettings( cancelToken?: CancelToken): Promise<UserEditDto> {
        let url_ = this.baseUrl + "/api/User/notificationsettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationSettings(_response);
        });
    }

    protected processGetNotificationSettings(response: AxiosResponse): Promise<UserEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserEditDto.fromJS(resultData200);
            return Promise.resolve<UserEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserEditDto>(null as any);
    }

    updateNotificationSettings(user: UserEditDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/notificationsettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNotificationSettings(_response);
        });
    }

    protected processUpdateNotificationSettings(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class BoardItemActionDto implements IBoardItemActionDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    type?: ActionTypeDto;
    responseType?: ActionResponseTypeDto;
    url?: string | undefined;
    isLiveData?: boolean;
    resultCode?: string | undefined;
    result?: string | undefined;
    error?: string | undefined;
    lastUpdate?: string | undefined;
    postResult?: string | undefined;
    postResultCode?: string | undefined;
    postError?: string | undefined;
    postLastUpdate?: string | undefined;
    sortOrder?: number;
    data?: ActionDataDto[] | undefined;

    constructor(data?: IBoardItemActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.responseType = _data["responseType"];
            this.url = _data["url"];
            this.isLiveData = _data["isLiveData"];
            this.resultCode = _data["resultCode"];
            this.result = _data["result"];
            this.error = _data["error"];
            this.lastUpdate = _data["lastUpdate"];
            this.postResult = _data["postResult"];
            this.postResultCode = _data["postResultCode"];
            this.postError = _data["postError"];
            this.postLastUpdate = _data["postLastUpdate"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ActionDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BoardItemActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["responseType"] = this.responseType;
        data["url"] = this.url;
        data["isLiveData"] = this.isLiveData;
        data["resultCode"] = this.resultCode;
        data["result"] = this.result;
        data["error"] = this.error;
        data["lastUpdate"] = this.lastUpdate;
        data["postResult"] = this.postResult;
        data["postResultCode"] = this.postResultCode;
        data["postError"] = this.postError;
        data["postLastUpdate"] = this.postLastUpdate;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBoardItemActionDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    type?: ActionTypeDto;
    responseType?: ActionResponseTypeDto;
    url?: string | undefined;
    isLiveData?: boolean;
    resultCode?: string | undefined;
    result?: string | undefined;
    error?: string | undefined;
    lastUpdate?: string | undefined;
    postResult?: string | undefined;
    postResultCode?: string | undefined;
    postError?: string | undefined;
    postLastUpdate?: string | undefined;
    sortOrder?: number;
    data?: ActionDataDto[] | undefined;
}

export enum ActionTypeDto {
    Get = "Get",
    Post = "Post",
}

export enum ActionResponseTypeDto {
    Text = "Text",
    Html = "Html",
    Json = "Json",
    CrewContactInformation = "CrewContactInformation",
    GroundOpsFlightInformation = "GroundOpsFlightInformation",
    GroundOpsRemark = "GroundOpsRemark",
    GroundOpsFindings = "GroundOpsFindings",
    CommercialDelay = "CommercialDelay",
}

export class ActionDataDto implements IActionDataDto {
    id?: string;
    fieldName?: string | undefined;
    displayName?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    type?: ActionDataTypeDto;
    rules?: ActionDataRulesDto | undefined;
    sortOrder?: number;
    selectValues?: string | undefined;

    constructor(data?: IActionDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fieldName = _data["fieldName"];
            this.displayName = _data["displayName"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.rules = _data["rules"] ? ActionDataRulesDto.fromJS(_data["rules"]) : undefined as any;
            this.sortOrder = _data["sortOrder"];
            this.selectValues = _data["selectValues"];
        }
    }

    static fromJS(data: any): ActionDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fieldName"] = this.fieldName;
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        data["description"] = this.description;
        data["type"] = this.type;
        data["rules"] = this.rules ? this.rules.toJSON() : undefined as any;
        data["sortOrder"] = this.sortOrder;
        data["selectValues"] = this.selectValues;
        return data;
    }
}

export interface IActionDataDto {
    id?: string;
    fieldName?: string | undefined;
    displayName?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    type?: ActionDataTypeDto;
    rules?: ActionDataRulesDto | undefined;
    sortOrder?: number;
    selectValues?: string | undefined;
}

export enum ActionDataTypeDto {
    MinMax = "MinMax",
    Input = "Input",
    FromToDate = "FromToDate",
    TextArea = "TextArea",
    Checkbox = "Checkbox",
    Select = "Select",
    Multiselect = "Multiselect",
    IncludeImages = "IncludeImages",
}

export class ActionDataRulesDto implements IActionDataRulesDto {
    length?: number | undefined;
    min?: number | undefined;
    max?: number | undefined;
    from?: string | undefined;
    to?: string | undefined;
    isRequired?: boolean;

    constructor(data?: IActionDataRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.length = _data["length"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): ActionDataRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionDataRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["min"] = this.min;
        data["max"] = this.max;
        data["from"] = this.from;
        data["to"] = this.to;
        data["isRequired"] = this.isRequired;
        return data;
    }
}

export interface IActionDataRulesDto {
    length?: number | undefined;
    min?: number | undefined;
    max?: number | undefined;
    from?: string | undefined;
    to?: string | undefined;
    isRequired?: boolean;
}

export class JobDto implements IJobDto {
    boardItemGuid?: string | undefined;
    description?: string | undefined;
    triggers?: JobTriggerDto[] | undefined;

    constructor(data?: IJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardItemGuid = _data["boardItemGuid"];
            this.description = _data["description"];
            if (Array.isArray(_data["triggers"])) {
                this.triggers = [] as any;
                for (let item of _data["triggers"])
                    this.triggers!.push(JobTriggerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardItemGuid"] = this.boardItemGuid;
        data["description"] = this.description;
        if (Array.isArray(this.triggers)) {
            data["triggers"] = [];
            for (let item of this.triggers)
                data["triggers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IJobDto {
    boardItemGuid?: string | undefined;
    description?: string | undefined;
    triggers?: JobTriggerDto[] | undefined;
}

export class JobTriggerDto implements IJobTriggerDto {
    nextFireTime?: string | undefined;

    constructor(data?: IJobTriggerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextFireTime = _data["nextFireTime"];
        }
    }

    static fromJS(data: any): JobTriggerDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobTriggerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextFireTime"] = this.nextFireTime;
        return data;
    }
}

export interface IJobTriggerDto {
    nextFireTime?: string | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    id?: string;
    isWideBoardItemAttachment?: boolean;
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    userFullName?: string | undefined;
    createdDate?: string;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isWideBoardItemAttachment = _data["isWideBoardItemAttachment"];
            this.fileName = _data["fileName"];
            this.fileExtension = _data["fileExtension"];
            this.userFullName = _data["userFullName"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isWideBoardItemAttachment"] = this.isWideBoardItemAttachment;
        data["fileName"] = this.fileName;
        data["fileExtension"] = this.fileExtension;
        data["userFullName"] = this.userFullName;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IAttachmentDto {
    id?: string;
    isWideBoardItemAttachment?: boolean;
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    userFullName?: string | undefined;
    createdDate?: string;
}

export enum AttachmentDestination {
    BoardItem = "BoardItem",
    SpecialOccurrence = "SpecialOccurrence",
    MaterialPart = "MaterialPart",
    WideBoardItem = "WideBoardItem",
}

export class UpdateAttachmentDto implements IUpdateAttachmentDto {
    id?: string;
    boardItemId?: string;
    isWideBoardItemAttachment?: boolean;

    constructor(data?: IUpdateAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.boardItemId = _data["boardItemId"];
            this.isWideBoardItemAttachment = _data["isWideBoardItemAttachment"];
        }
    }

    static fromJS(data: any): UpdateAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["boardItemId"] = this.boardItemId;
        data["isWideBoardItemAttachment"] = this.isWideBoardItemAttachment;
        return data;
    }
}

export interface IUpdateAttachmentDto {
    id?: string;
    boardItemId?: string;
    isWideBoardItemAttachment?: boolean;
}

export class ImageDataDto implements IImageDataDto {
    image?: string | undefined;

    constructor(data?: IImageDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): ImageDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        return data;
    }
}

export interface IImageDataDto {
    image?: string | undefined;
}

export class DeleteAttachmentDto implements IDeleteAttachmentDto {
    ownerId?: string;
    attachmentDestination?: AttachmentDestination;

    constructor(data?: IDeleteAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.attachmentDestination = _data["attachmentDestination"];
        }
    }

    static fromJS(data: any): DeleteAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["attachmentDestination"] = this.attachmentDestination;
        return data;
    }
}

export interface IDeleteAttachmentDto {
    ownerId?: string;
    attachmentDestination?: AttachmentDestination;
}

export class BoardDto implements IBoardDto {
    id?: string;
    title?: string | undefined;
    enableShifts?: boolean;
    lists?: BoardItemListDto[] | undefined;
    shiftTypes?: ShiftTypeDto[] | undefined;
    currentShift?: ShiftDto | undefined;
    isValidationEnabled?: boolean;
    shiftHandoverGrouping?: string | undefined;
    createdDate?: string;
    backgroundImage?: string | undefined;
    backgroundImageOpacity?: number | undefined;

    constructor(data?: IBoardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.enableShifts = _data["enableShifts"];
            if (Array.isArray(_data["lists"])) {
                this.lists = [] as any;
                for (let item of _data["lists"])
                    this.lists!.push(BoardItemListDto.fromJS(item));
            }
            if (Array.isArray(_data["shiftTypes"])) {
                this.shiftTypes = [] as any;
                for (let item of _data["shiftTypes"])
                    this.shiftTypes!.push(ShiftTypeDto.fromJS(item));
            }
            this.currentShift = _data["currentShift"] ? ShiftDto.fromJS(_data["currentShift"]) : undefined as any;
            this.isValidationEnabled = _data["isValidationEnabled"];
            this.shiftHandoverGrouping = _data["shiftHandoverGrouping"];
            this.createdDate = _data["createdDate"];
            this.backgroundImage = _data["backgroundImage"];
            this.backgroundImageOpacity = _data["backgroundImageOpacity"];
        }
    }

    static fromJS(data: any): BoardDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["enableShifts"] = this.enableShifts;
        if (Array.isArray(this.lists)) {
            data["lists"] = [];
            for (let item of this.lists)
                data["lists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.shiftTypes)) {
            data["shiftTypes"] = [];
            for (let item of this.shiftTypes)
                data["shiftTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentShift"] = this.currentShift ? this.currentShift.toJSON() : undefined as any;
        data["isValidationEnabled"] = this.isValidationEnabled;
        data["shiftHandoverGrouping"] = this.shiftHandoverGrouping;
        data["createdDate"] = this.createdDate;
        data["backgroundImage"] = this.backgroundImage;
        data["backgroundImageOpacity"] = this.backgroundImageOpacity;
        return data;
    }
}

export interface IBoardDto {
    id?: string;
    title?: string | undefined;
    enableShifts?: boolean;
    lists?: BoardItemListDto[] | undefined;
    shiftTypes?: ShiftTypeDto[] | undefined;
    currentShift?: ShiftDto | undefined;
    isValidationEnabled?: boolean;
    shiftHandoverGrouping?: string | undefined;
    createdDate?: string;
    backgroundImage?: string | undefined;
    backgroundImageOpacity?: number | undefined;
}

export class BoardItemListDto implements IBoardItemListDto {
    id?: string;
    name?: string | undefined;
    listGroup?: string | undefined;
    listGroupType?: ListGroupTypeDto;
    sortOrder?: number;
    displayShiftTime?: boolean;
    displayNotifications?: boolean;
    newBoardItemStatus?: BoardItemStatusDto;
    autoUserAssign?: boolean;
    autoUserUnAssign?: boolean;

    constructor(data?: IBoardItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.listGroup = _data["listGroup"];
            this.listGroupType = _data["listGroupType"];
            this.sortOrder = _data["sortOrder"];
            this.displayShiftTime = _data["displayShiftTime"];
            this.displayNotifications = _data["displayNotifications"];
            this.newBoardItemStatus = _data["newBoardItemStatus"];
            this.autoUserAssign = _data["autoUserAssign"];
            this.autoUserUnAssign = _data["autoUserUnAssign"];
        }
    }

    static fromJS(data: any): BoardItemListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["listGroup"] = this.listGroup;
        data["listGroupType"] = this.listGroupType;
        data["sortOrder"] = this.sortOrder;
        data["displayShiftTime"] = this.displayShiftTime;
        data["displayNotifications"] = this.displayNotifications;
        data["newBoardItemStatus"] = this.newBoardItemStatus;
        data["autoUserAssign"] = this.autoUserAssign;
        data["autoUserUnAssign"] = this.autoUserUnAssign;
        return data;
    }
}

export interface IBoardItemListDto {
    id?: string;
    name?: string | undefined;
    listGroup?: string | undefined;
    listGroupType?: ListGroupTypeDto;
    sortOrder?: number;
    displayShiftTime?: boolean;
    displayNotifications?: boolean;
    newBoardItemStatus?: BoardItemStatusDto;
    autoUserAssign?: boolean;
    autoUserUnAssign?: boolean;
}

export enum ListGroupTypeDto {
    None = "None",
    BoardItem = "BoardItem",
    Information = "Information",
    Delegated = "Delegated",
    Shared = "Shared",
}

export enum BoardItemStatusDto {
    None = "None",
    Planned = "Planned",
    InProgress = "InProgress",
    Done = "Done",
    Deleted = "Deleted",
    Information = "Information",
    Delegated = "Delegated",
    UnderReview = "UnderReview",
    Shared = "Shared",
}

export class ShiftTypeDto implements IShiftTypeDto {
    id?: string;
    name?: string | undefined;
    defaultTimeFrom?: string;
    defaultTimeTo?: string;
    timeFromDst?: string;
    timeToDst?: string;
    sortOrder?: number;

    constructor(data?: IShiftTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.defaultTimeFrom = _data["defaultTimeFrom"];
            this.defaultTimeTo = _data["defaultTimeTo"];
            this.timeFromDst = _data["timeFromDst"];
            this.timeToDst = _data["timeToDst"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ShiftTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["defaultTimeFrom"] = this.defaultTimeFrom;
        data["defaultTimeTo"] = this.defaultTimeTo;
        data["timeFromDst"] = this.timeFromDst;
        data["timeToDst"] = this.timeToDst;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IShiftTypeDto {
    id?: string;
    name?: string | undefined;
    defaultTimeFrom?: string;
    defaultTimeTo?: string;
    timeFromDst?: string;
    timeToDst?: string;
    sortOrder?: number;
}

export class ShiftDto implements IShiftDto {
    id?: string;
    boardId?: string;
    board?: BoardDto | undefined;
    dateFrom?: string;
    dateTo?: string;
    shiftType?: ShiftTypeDto | undefined;
    supervisor?: UserDto | undefined;
    isHandoverPrepared?: boolean;

    constructor(data?: IShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.boardId = _data["boardId"];
            this.board = _data["board"] ? BoardDto.fromJS(_data["board"]) : undefined as any;
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.shiftType = _data["shiftType"] ? ShiftTypeDto.fromJS(_data["shiftType"]) : undefined as any;
            this.supervisor = _data["supervisor"] ? UserDto.fromJS(_data["supervisor"]) : undefined as any;
            this.isHandoverPrepared = _data["isHandoverPrepared"];
        }
    }

    static fromJS(data: any): ShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["boardId"] = this.boardId;
        data["board"] = this.board ? this.board.toJSON() : undefined as any;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["shiftType"] = this.shiftType ? this.shiftType.toJSON() : undefined as any;
        data["supervisor"] = this.supervisor ? this.supervisor.toJSON() : undefined as any;
        data["isHandoverPrepared"] = this.isHandoverPrepared;
        return data;
    }
}

export interface IShiftDto {
    id?: string;
    boardId?: string;
    board?: BoardDto | undefined;
    dateFrom?: string;
    dateTo?: string;
    shiftType?: ShiftTypeDto | undefined;
    supervisor?: UserDto | undefined;
    isHandoverPrepared?: boolean;
}

export class UserDto implements IUserDto {
    id?: string;
    username?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    shortName?: string | undefined;
    tlc?: string | undefined;
    timeZone?: string | undefined;
    email?: string | undefined;
    userHasAccess?: boolean;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;
    isMaterialRequestAdmin?: boolean;
    isShiftSupervisor?: boolean;
    displayName?: string | undefined;
    notificationAssigned?: boolean;
    notificationSubscription?: boolean;
    notificationNewTask?: boolean;
    notificationNewSpecialOccurrence?: boolean;
    notificationCompletedSpecialOccurrence?: boolean;
    boardPermissions?: BoardUserDto[] | undefined;
    isMasterUser?: boolean;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.shortName = _data["shortName"];
            this.tlc = _data["tlc"];
            this.timeZone = _data["timeZone"];
            this.email = _data["email"];
            this.userHasAccess = _data["userHasAccess"];
            this.isAdmin = _data["isAdmin"];
            this.isSuperAdmin = _data["isSuperAdmin"];
            this.isMaterialRequestAdmin = _data["isMaterialRequestAdmin"];
            this.isShiftSupervisor = _data["isShiftSupervisor"];
            this.displayName = _data["displayName"];
            this.notificationAssigned = _data["notificationAssigned"];
            this.notificationSubscription = _data["notificationSubscription"];
            this.notificationNewTask = _data["notificationNewTask"];
            this.notificationNewSpecialOccurrence = _data["notificationNewSpecialOccurrence"];
            this.notificationCompletedSpecialOccurrence = _data["notificationCompletedSpecialOccurrence"];
            if (Array.isArray(_data["boardPermissions"])) {
                this.boardPermissions = [] as any;
                for (let item of _data["boardPermissions"])
                    this.boardPermissions!.push(BoardUserDto.fromJS(item));
            }
            this.isMasterUser = _data["isMasterUser"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["shortName"] = this.shortName;
        data["tlc"] = this.tlc;
        data["timeZone"] = this.timeZone;
        data["email"] = this.email;
        data["userHasAccess"] = this.userHasAccess;
        data["isAdmin"] = this.isAdmin;
        data["isSuperAdmin"] = this.isSuperAdmin;
        data["isMaterialRequestAdmin"] = this.isMaterialRequestAdmin;
        data["isShiftSupervisor"] = this.isShiftSupervisor;
        data["displayName"] = this.displayName;
        data["notificationAssigned"] = this.notificationAssigned;
        data["notificationSubscription"] = this.notificationSubscription;
        data["notificationNewTask"] = this.notificationNewTask;
        data["notificationNewSpecialOccurrence"] = this.notificationNewSpecialOccurrence;
        data["notificationCompletedSpecialOccurrence"] = this.notificationCompletedSpecialOccurrence;
        if (Array.isArray(this.boardPermissions)) {
            data["boardPermissions"] = [];
            for (let item of this.boardPermissions)
                data["boardPermissions"].push(item ? item.toJSON() : undefined as any);
        }
        data["isMasterUser"] = this.isMasterUser;
        return data;
    }
}

export interface IUserDto {
    id?: string;
    username?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    shortName?: string | undefined;
    tlc?: string | undefined;
    timeZone?: string | undefined;
    email?: string | undefined;
    userHasAccess?: boolean;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;
    isMaterialRequestAdmin?: boolean;
    isShiftSupervisor?: boolean;
    displayName?: string | undefined;
    notificationAssigned?: boolean;
    notificationSubscription?: boolean;
    notificationNewTask?: boolean;
    notificationNewSpecialOccurrence?: boolean;
    notificationCompletedSpecialOccurrence?: boolean;
    boardPermissions?: BoardUserDto[] | undefined;
    isMasterUser?: boolean;
}

export class BoardUserDto implements IBoardUserDto {
    boardGuid?: string;
    isShiftSupervisor?: boolean;
    isBoardAdmin?: boolean;

    constructor(data?: IBoardUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardGuid = _data["boardGuid"];
            this.isShiftSupervisor = _data["isShiftSupervisor"];
            this.isBoardAdmin = _data["isBoardAdmin"];
        }
    }

    static fromJS(data: any): BoardUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardGuid"] = this.boardGuid;
        data["isShiftSupervisor"] = this.isShiftSupervisor;
        data["isBoardAdmin"] = this.isBoardAdmin;
        return data;
    }
}

export interface IBoardUserDto {
    boardGuid?: string;
    isShiftSupervisor?: boolean;
    isBoardAdmin?: boolean;
}

export class ShiftHandoverDto implements IShiftHandoverDto {
    boardGuid?: string;
    comment?: string | undefined;
    currentShiftTo?: string;
    nextShiftFrom?: string;
    nextShiftTo?: string;
    supervisorId?: string;
    shiftTypeId?: string;
    relevantItems?: string[] | undefined;

    constructor(data?: IShiftHandoverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardGuid = _data["boardGuid"];
            this.comment = _data["comment"];
            this.currentShiftTo = _data["currentShiftTo"];
            this.nextShiftFrom = _data["nextShiftFrom"];
            this.nextShiftTo = _data["nextShiftTo"];
            this.supervisorId = _data["supervisorId"];
            this.shiftTypeId = _data["shiftTypeId"];
            if (Array.isArray(_data["relevantItems"])) {
                this.relevantItems = [] as any;
                for (let item of _data["relevantItems"])
                    this.relevantItems!.push(item);
            }
        }
    }

    static fromJS(data: any): ShiftHandoverDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftHandoverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardGuid"] = this.boardGuid;
        data["comment"] = this.comment;
        data["currentShiftTo"] = this.currentShiftTo;
        data["nextShiftFrom"] = this.nextShiftFrom;
        data["nextShiftTo"] = this.nextShiftTo;
        data["supervisorId"] = this.supervisorId;
        data["shiftTypeId"] = this.shiftTypeId;
        if (Array.isArray(this.relevantItems)) {
            data["relevantItems"] = [];
            for (let item of this.relevantItems)
                data["relevantItems"].push(item);
        }
        return data;
    }
}

export interface IShiftHandoverDto {
    boardGuid?: string;
    comment?: string | undefined;
    currentShiftTo?: string;
    nextShiftFrom?: string;
    nextShiftTo?: string;
    supervisorId?: string;
    shiftTypeId?: string;
    relevantItems?: string[] | undefined;
}

export class BoardItemCategoryDto implements IBoardItemCategoryDto {
    id?: string;
    short?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    boardItemTypes?: BoardItemTypeDto[] | undefined;

    constructor(data?: IBoardItemCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.short = _data["short"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["boardItemTypes"])) {
                this.boardItemTypes = [] as any;
                for (let item of _data["boardItemTypes"])
                    this.boardItemTypes!.push(BoardItemTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BoardItemCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["short"] = this.short;
        data["name"] = this.name;
        data["icon"] = this.icon;
        if (Array.isArray(this.boardItemTypes)) {
            data["boardItemTypes"] = [];
            for (let item of this.boardItemTypes)
                data["boardItemTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBoardItemCategoryDto {
    id?: string;
    short?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    boardItemTypes?: BoardItemTypeDto[] | undefined;
}

export class BoardItemTypeDto implements IBoardItemTypeDto {
    id?: string;
    name?: string | undefined;
    short?: string | undefined;
    interfaceBk?: string | undefined;
    boardItemCategoryId?: string;
    boardItemCategory?: BoardItemCategoryDto | undefined;

    constructor(data?: IBoardItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.short = _data["short"];
            this.interfaceBk = _data["interfaceBk"];
            this.boardItemCategoryId = _data["boardItemCategoryId"];
            this.boardItemCategory = _data["boardItemCategory"] ? BoardItemCategoryDto.fromJS(_data["boardItemCategory"]) : undefined as any;
        }
    }

    static fromJS(data: any): BoardItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["short"] = this.short;
        data["interfaceBk"] = this.interfaceBk;
        data["boardItemCategoryId"] = this.boardItemCategoryId;
        data["boardItemCategory"] = this.boardItemCategory ? this.boardItemCategory.toJSON() : undefined as any;
        return data;
    }
}

export interface IBoardItemTypeDto {
    id?: string;
    name?: string | undefined;
    short?: string | undefined;
    interfaceBk?: string | undefined;
    boardItemCategoryId?: string;
    boardItemCategory?: BoardItemCategoryDto | undefined;
}

export class BoardInsertDto implements IBoardInsertDto {
    title?: string | undefined;
    enableShifts?: boolean;

    constructor(data?: IBoardInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.enableShifts = _data["enableShifts"];
        }
    }

    static fromJS(data: any): BoardInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["enableShifts"] = this.enableShifts;
        return data;
    }
}

export interface IBoardInsertDto {
    title?: string | undefined;
    enableShifts?: boolean;
}

export class BoardItemDto implements IBoardItemDto {
    id?: string;
    initialOwnerBoardId?: string | undefined;
    ownerBoardId?: string | undefined;
    isMoved?: boolean;
    isDelegated?: boolean;
    isConfidential?: boolean;
    isShared?: boolean;
    isRelevantForReport?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    validFromDate?: string | undefined;
    validToDate?: string | undefined;
    dueDate?: string | undefined;
    plannedDate?: string | undefined;
    assignedToUserId?: string | undefined;
    assignedToUser?: UserDto | undefined;
    spreadsheetData?: string | undefined;
    boardItemListId?: string;
    boardItemList?: BoardItemListDto | undefined;
    boardItemCategoryId?: string;
    boardItemCategory?: BoardItemCategoryDto | undefined;
    boardItemTypeId?: string;
    boardItemType?: BoardItemTypeDto | undefined;
    boardItemClass?: BoardItemClassEnum;
    boardItemStatus?: BoardItemStatusDto;
    isSystemGenerated?: boolean;
    rowVersion?: number;
    comments?: BoardItemCommentDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    parentBoardItemId?: string | undefined;
    parentBoardItem?: BoardItemDto | undefined;
    linkedBoardItems?: BoardItemDto[] | undefined;
    changeSets?: VarianceChangeSet[] | undefined;
    priority?: BoardItemPriorityDto;
    actions?: BoardItemActionDto[] | undefined;
    isArchived?: boolean;
    isReadonly?: boolean;
    checklists?: ChecklistDto[] | undefined;
    specialOccurrenceId?: string | undefined;
    specialOccurrenceName?: string | undefined;
    specialOccurrenceCouldBeUnlinked?: boolean;
    notificationSound?: string | undefined;
    labels?: LabelDto[] | undefined;
    createdDate?: string;
    archivedDate?: string | undefined;
    isTemplate?: boolean;
    templateCategoryGuid?: string | undefined;
    currentUserIsSubscribed?: boolean;
    actionsJson?: string | undefined;
    dynamicTemplateFilesJson?: string | undefined;
    enableAutomaticStatusChangeOnShiftHandover?: boolean;
    sharedBoards?: SharedBoardDto[] | undefined;
    boardItemViews?: BoardItemViewDto[] | undefined;

    constructor(data?: IBoardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.initialOwnerBoardId = _data["initialOwnerBoardId"];
            this.ownerBoardId = _data["ownerBoardId"];
            this.isMoved = _data["isMoved"];
            this.isDelegated = _data["isDelegated"];
            this.isConfidential = _data["isConfidential"];
            this.isShared = _data["isShared"];
            this.isRelevantForReport = _data["isRelevantForReport"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.validFromDate = _data["validFromDate"];
            this.validToDate = _data["validToDate"];
            this.dueDate = _data["dueDate"];
            this.plannedDate = _data["plannedDate"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"] ? UserDto.fromJS(_data["assignedToUser"]) : undefined as any;
            this.spreadsheetData = _data["spreadsheetData"];
            this.boardItemListId = _data["boardItemListId"];
            this.boardItemList = _data["boardItemList"] ? BoardItemListDto.fromJS(_data["boardItemList"]) : undefined as any;
            this.boardItemCategoryId = _data["boardItemCategoryId"];
            this.boardItemCategory = _data["boardItemCategory"] ? BoardItemCategoryDto.fromJS(_data["boardItemCategory"]) : undefined as any;
            this.boardItemTypeId = _data["boardItemTypeId"];
            this.boardItemType = _data["boardItemType"] ? BoardItemTypeDto.fromJS(_data["boardItemType"]) : undefined as any;
            this.boardItemClass = _data["boardItemClass"];
            this.boardItemStatus = _data["boardItemStatus"];
            this.isSystemGenerated = _data["isSystemGenerated"];
            this.rowVersion = _data["rowVersion"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(BoardItemCommentDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.parentBoardItemId = _data["parentBoardItemId"];
            this.parentBoardItem = _data["parentBoardItem"] ? BoardItemDto.fromJS(_data["parentBoardItem"]) : undefined as any;
            if (Array.isArray(_data["linkedBoardItems"])) {
                this.linkedBoardItems = [] as any;
                for (let item of _data["linkedBoardItems"])
                    this.linkedBoardItems!.push(BoardItemDto.fromJS(item));
            }
            if (Array.isArray(_data["changeSets"])) {
                this.changeSets = [] as any;
                for (let item of _data["changeSets"])
                    this.changeSets!.push(VarianceChangeSet.fromJS(item));
            }
            this.priority = _data["priority"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(BoardItemActionDto.fromJS(item));
            }
            this.isArchived = _data["isArchived"];
            this.isReadonly = _data["isReadonly"];
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(ChecklistDto.fromJS(item));
            }
            this.specialOccurrenceId = _data["specialOccurrenceId"];
            this.specialOccurrenceName = _data["specialOccurrenceName"];
            this.specialOccurrenceCouldBeUnlinked = _data["specialOccurrenceCouldBeUnlinked"];
            this.notificationSound = _data["notificationSound"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(LabelDto.fromJS(item));
            }
            this.createdDate = _data["createdDate"];
            this.archivedDate = _data["archivedDate"];
            this.isTemplate = _data["isTemplate"];
            this.templateCategoryGuid = _data["templateCategoryGuid"];
            this.currentUserIsSubscribed = _data["currentUserIsSubscribed"];
            this.actionsJson = _data["actionsJson"];
            this.dynamicTemplateFilesJson = _data["dynamicTemplateFilesJson"];
            this.enableAutomaticStatusChangeOnShiftHandover = _data["enableAutomaticStatusChangeOnShiftHandover"];
            if (Array.isArray(_data["sharedBoards"])) {
                this.sharedBoards = [] as any;
                for (let item of _data["sharedBoards"])
                    this.sharedBoards!.push(SharedBoardDto.fromJS(item));
            }
            if (Array.isArray(_data["boardItemViews"])) {
                this.boardItemViews = [] as any;
                for (let item of _data["boardItemViews"])
                    this.boardItemViews!.push(BoardItemViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BoardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["initialOwnerBoardId"] = this.initialOwnerBoardId;
        data["ownerBoardId"] = this.ownerBoardId;
        data["isMoved"] = this.isMoved;
        data["isDelegated"] = this.isDelegated;
        data["isConfidential"] = this.isConfidential;
        data["isShared"] = this.isShared;
        data["isRelevantForReport"] = this.isRelevantForReport;
        data["title"] = this.title;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["validFromDate"] = this.validFromDate;
        data["validToDate"] = this.validToDate;
        data["dueDate"] = this.dueDate;
        data["plannedDate"] = this.plannedDate;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser ? this.assignedToUser.toJSON() : undefined as any;
        data["spreadsheetData"] = this.spreadsheetData;
        data["boardItemListId"] = this.boardItemListId;
        data["boardItemList"] = this.boardItemList ? this.boardItemList.toJSON() : undefined as any;
        data["boardItemCategoryId"] = this.boardItemCategoryId;
        data["boardItemCategory"] = this.boardItemCategory ? this.boardItemCategory.toJSON() : undefined as any;
        data["boardItemTypeId"] = this.boardItemTypeId;
        data["boardItemType"] = this.boardItemType ? this.boardItemType.toJSON() : undefined as any;
        data["boardItemClass"] = this.boardItemClass;
        data["boardItemStatus"] = this.boardItemStatus;
        data["isSystemGenerated"] = this.isSystemGenerated;
        data["rowVersion"] = this.rowVersion;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentBoardItemId"] = this.parentBoardItemId;
        data["parentBoardItem"] = this.parentBoardItem ? this.parentBoardItem.toJSON() : undefined as any;
        if (Array.isArray(this.linkedBoardItems)) {
            data["linkedBoardItems"] = [];
            for (let item of this.linkedBoardItems)
                data["linkedBoardItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.changeSets)) {
            data["changeSets"] = [];
            for (let item of this.changeSets)
                data["changeSets"].push(item ? item.toJSON() : undefined as any);
        }
        data["priority"] = this.priority;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : undefined as any);
        }
        data["isArchived"] = this.isArchived;
        data["isReadonly"] = this.isReadonly;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        data["specialOccurrenceId"] = this.specialOccurrenceId;
        data["specialOccurrenceName"] = this.specialOccurrenceName;
        data["specialOccurrenceCouldBeUnlinked"] = this.specialOccurrenceCouldBeUnlinked;
        data["notificationSound"] = this.notificationSound;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdDate"] = this.createdDate;
        data["archivedDate"] = this.archivedDate;
        data["isTemplate"] = this.isTemplate;
        data["templateCategoryGuid"] = this.templateCategoryGuid;
        data["currentUserIsSubscribed"] = this.currentUserIsSubscribed;
        data["actionsJson"] = this.actionsJson;
        data["dynamicTemplateFilesJson"] = this.dynamicTemplateFilesJson;
        data["enableAutomaticStatusChangeOnShiftHandover"] = this.enableAutomaticStatusChangeOnShiftHandover;
        if (Array.isArray(this.sharedBoards)) {
            data["sharedBoards"] = [];
            for (let item of this.sharedBoards)
                data["sharedBoards"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.boardItemViews)) {
            data["boardItemViews"] = [];
            for (let item of this.boardItemViews)
                data["boardItemViews"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBoardItemDto {
    id?: string;
    initialOwnerBoardId?: string | undefined;
    ownerBoardId?: string | undefined;
    isMoved?: boolean;
    isDelegated?: boolean;
    isConfidential?: boolean;
    isShared?: boolean;
    isRelevantForReport?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    validFromDate?: string | undefined;
    validToDate?: string | undefined;
    dueDate?: string | undefined;
    plannedDate?: string | undefined;
    assignedToUserId?: string | undefined;
    assignedToUser?: UserDto | undefined;
    spreadsheetData?: string | undefined;
    boardItemListId?: string;
    boardItemList?: BoardItemListDto | undefined;
    boardItemCategoryId?: string;
    boardItemCategory?: BoardItemCategoryDto | undefined;
    boardItemTypeId?: string;
    boardItemType?: BoardItemTypeDto | undefined;
    boardItemClass?: BoardItemClassEnum;
    boardItemStatus?: BoardItemStatusDto;
    isSystemGenerated?: boolean;
    rowVersion?: number;
    comments?: BoardItemCommentDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    parentBoardItemId?: string | undefined;
    parentBoardItem?: BoardItemDto | undefined;
    linkedBoardItems?: BoardItemDto[] | undefined;
    changeSets?: VarianceChangeSet[] | undefined;
    priority?: BoardItemPriorityDto;
    actions?: BoardItemActionDto[] | undefined;
    isArchived?: boolean;
    isReadonly?: boolean;
    checklists?: ChecklistDto[] | undefined;
    specialOccurrenceId?: string | undefined;
    specialOccurrenceName?: string | undefined;
    specialOccurrenceCouldBeUnlinked?: boolean;
    notificationSound?: string | undefined;
    labels?: LabelDto[] | undefined;
    createdDate?: string;
    archivedDate?: string | undefined;
    isTemplate?: boolean;
    templateCategoryGuid?: string | undefined;
    currentUserIsSubscribed?: boolean;
    actionsJson?: string | undefined;
    dynamicTemplateFilesJson?: string | undefined;
    enableAutomaticStatusChangeOnShiftHandover?: boolean;
    sharedBoards?: SharedBoardDto[] | undefined;
    boardItemViews?: BoardItemViewDto[] | undefined;
}

export enum BoardItemClassEnum {
    Task = "Task",
    Information = "Information",
    Department = "Department",
}

export class BoardItemCommentDto implements IBoardItemCommentDto {
    id?: string;
    userId?: string | undefined;
    boardItemId?: string;
    text?: string | undefined;
    createdDate?: string;
    updatedDate?: string | undefined;
    parentCommentId?: string | undefined;
    parentComment?: BoardItemCommentDto | undefined;
    isSystemComment?: boolean;
    userTlc?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    userUserName?: string | undefined;
    userFullName?: string | undefined;
    attachmentId?: string | undefined;
    attachment?: AttachmentDto | undefined;

    constructor(data?: IBoardItemCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.boardItemId = _data["boardItemId"];
            this.text = _data["text"];
            this.createdDate = _data["createdDate"];
            this.updatedDate = _data["updatedDate"];
            this.parentCommentId = _data["parentCommentId"];
            this.parentComment = _data["parentComment"] ? BoardItemCommentDto.fromJS(_data["parentComment"]) : undefined as any;
            this.isSystemComment = _data["isSystemComment"];
            this.userTlc = _data["userTlc"];
            this.userFirstName = _data["userFirstName"];
            this.userLastName = _data["userLastName"];
            this.userUserName = _data["userUserName"];
            this.userFullName = _data["userFullName"];
            this.attachmentId = _data["attachmentId"];
            this.attachment = _data["attachment"] ? AttachmentDto.fromJS(_data["attachment"]) : undefined as any;
        }
    }

    static fromJS(data: any): BoardItemCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["boardItemId"] = this.boardItemId;
        data["text"] = this.text;
        data["createdDate"] = this.createdDate;
        data["updatedDate"] = this.updatedDate;
        data["parentCommentId"] = this.parentCommentId;
        data["parentComment"] = this.parentComment ? this.parentComment.toJSON() : undefined as any;
        data["isSystemComment"] = this.isSystemComment;
        data["userTlc"] = this.userTlc;
        data["userFirstName"] = this.userFirstName;
        data["userLastName"] = this.userLastName;
        data["userUserName"] = this.userUserName;
        data["userFullName"] = this.userFullName;
        data["attachmentId"] = this.attachmentId;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : undefined as any;
        return data;
    }
}

export interface IBoardItemCommentDto {
    id?: string;
    userId?: string | undefined;
    boardItemId?: string;
    text?: string | undefined;
    createdDate?: string;
    updatedDate?: string | undefined;
    parentCommentId?: string | undefined;
    parentComment?: BoardItemCommentDto | undefined;
    isSystemComment?: boolean;
    userTlc?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    userUserName?: string | undefined;
    userFullName?: string | undefined;
    attachmentId?: string | undefined;
    attachment?: AttachmentDto | undefined;
}

export class VarianceChangeSet implements IVarianceChangeSet {
    id?: string;
    entityId?: string;
    variance?: VarianceDto[] | undefined;
    createdDate?: string;
    author?: UserDto | undefined;

    constructor(data?: IVarianceChangeSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["variance"])) {
                this.variance = [] as any;
                for (let item of _data["variance"])
                    this.variance!.push(VarianceDto.fromJS(item));
            }
            this.createdDate = _data["createdDate"];
            this.author = _data["author"] ? UserDto.fromJS(_data["author"]) : undefined as any;
        }
    }

    static fromJS(data: any): VarianceChangeSet {
        data = typeof data === 'object' ? data : {};
        let result = new VarianceChangeSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        if (Array.isArray(this.variance)) {
            data["variance"] = [];
            for (let item of this.variance)
                data["variance"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdDate"] = this.createdDate;
        data["author"] = this.author ? this.author.toJSON() : undefined as any;
        return data;
    }
}

export interface IVarianceChangeSet {
    id?: string;
    entityId?: string;
    variance?: VarianceDto[] | undefined;
    createdDate?: string;
    author?: UserDto | undefined;
}

export class VarianceDto implements IVarianceDto {
    name?: string | undefined;
    oldValue?: any | undefined;
    newValue?: any | undefined;

    constructor(data?: IVarianceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): VarianceDto {
        data = typeof data === 'object' ? data : {};
        let result = new VarianceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IVarianceDto {
    name?: string | undefined;
    oldValue?: any | undefined;
    newValue?: any | undefined;
}

export enum BoardItemPriorityDto {
    Normal = "Normal",
    High = "High",
}

export class ChecklistDto implements IChecklistDto {
    id?: string;
    createdDate?: string;
    boardItemId?: string;
    title?: string | undefined;
    items?: ChecklistItemDto[] | undefined;
    sortOrder?: number;

    constructor(data?: IChecklistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"];
            this.boardItemId = _data["boardItemId"];
            this.title = _data["title"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChecklistItemDto.fromJS(item));
            }
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ChecklistDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate;
        data["boardItemId"] = this.boardItemId;
        data["title"] = this.title;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IChecklistDto {
    id?: string;
    createdDate?: string;
    boardItemId?: string;
    title?: string | undefined;
    items?: ChecklistItemDto[] | undefined;
    sortOrder?: number;
}

export class ChecklistItemDto implements IChecklistItemDto {
    id?: string;
    checklistId?: string;
    title?: string | undefined;
    description?: string | undefined;
    isCompleted?: boolean;
    isEditable?: boolean;
    createdDate?: string;
    updatedDate?: string | undefined;
    completedDate?: string | undefined;
    createdUser?: string | undefined;
    updatedUser?: string | undefined;
    completedUser?: string | undefined;
    sortOrder?: number;

    constructor(data?: IChecklistItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.checklistId = _data["checklistId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isCompleted = _data["isCompleted"];
            this.isEditable = _data["isEditable"];
            this.createdDate = _data["createdDate"];
            this.updatedDate = _data["updatedDate"];
            this.completedDate = _data["completedDate"];
            this.createdUser = _data["createdUser"];
            this.updatedUser = _data["updatedUser"];
            this.completedUser = _data["completedUser"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ChecklistItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checklistId"] = this.checklistId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isCompleted"] = this.isCompleted;
        data["isEditable"] = this.isEditable;
        data["createdDate"] = this.createdDate;
        data["updatedDate"] = this.updatedDate;
        data["completedDate"] = this.completedDate;
        data["createdUser"] = this.createdUser;
        data["updatedUser"] = this.updatedUser;
        data["completedUser"] = this.completedUser;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IChecklistItemDto {
    id?: string;
    checklistId?: string;
    title?: string | undefined;
    description?: string | undefined;
    isCompleted?: boolean;
    isEditable?: boolean;
    createdDate?: string;
    updatedDate?: string | undefined;
    completedDate?: string | undefined;
    createdUser?: string | undefined;
    updatedUser?: string | undefined;
    completedUser?: string | undefined;
    sortOrder?: number;
}

export class LabelDto implements ILabelDto {
    id?: string | undefined;
    category?: string | undefined;
    title?: string | undefined;
    color?: string | undefined;
    icon?: string | undefined;
    sortOrder?: number;
    isUsed?: boolean;
    boardId?: string | undefined;
    isDeleted?: boolean;
    isArchived?: boolean;

    constructor(data?: ILabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.title = _data["title"];
            this.color = _data["color"];
            this.icon = _data["icon"];
            this.sortOrder = _data["sortOrder"];
            this.isUsed = _data["isUsed"];
            this.boardId = _data["boardId"];
            this.isDeleted = _data["isDeleted"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): LabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["title"] = this.title;
        data["color"] = this.color;
        data["icon"] = this.icon;
        data["sortOrder"] = this.sortOrder;
        data["isUsed"] = this.isUsed;
        data["boardId"] = this.boardId;
        data["isDeleted"] = this.isDeleted;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface ILabelDto {
    id?: string | undefined;
    category?: string | undefined;
    title?: string | undefined;
    color?: string | undefined;
    icon?: string | undefined;
    sortOrder?: number;
    isUsed?: boolean;
    boardId?: string | undefined;
    isDeleted?: boolean;
    isArchived?: boolean;
}

export class SharedBoardDto implements ISharedBoardDto {
    boardId?: string;
    title?: string | undefined;

    constructor(data?: ISharedBoardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): SharedBoardDto {
        data = typeof data === 'object' ? data : {};
        let result = new SharedBoardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        data["title"] = this.title;
        return data;
    }
}

export interface ISharedBoardDto {
    boardId?: string;
    title?: string | undefined;
}

export class BoardItemViewDto implements IBoardItemViewDto {
    id?: string;
    boardId?: string;
    boardItemId?: string;
    lastViewDate?: string;

    constructor(data?: IBoardItemViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.boardId = _data["boardId"];
            this.boardItemId = _data["boardItemId"];
            this.lastViewDate = _data["lastViewDate"];
        }
    }

    static fromJS(data: any): BoardItemViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["boardId"] = this.boardId;
        data["boardItemId"] = this.boardItemId;
        data["lastViewDate"] = this.lastViewDate;
        return data;
    }
}

export interface IBoardItemViewDto {
    id?: string;
    boardId?: string;
    boardItemId?: string;
    lastViewDate?: string;
}

export class BoardItemInsertDto implements IBoardItemInsertDto {
    guid?: string;
    specialOccurrenceId?: string | undefined;
    boardId?: string;
    title?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    assignedToUserId?: string | undefined;
    dueDate?: string | undefined;
    plannedDate?: string | undefined;
    boardItemCategoryId?: string;
    boardItemTypeId?: string;
    isTemplate?: boolean;
    isConfidential?: boolean;
    spreadsheetData?: string | undefined;

    constructor(data?: IBoardItemInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.specialOccurrenceId = _data["specialOccurrenceId"];
            this.boardId = _data["boardId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"];
            this.plannedDate = _data["plannedDate"];
            this.boardItemCategoryId = _data["boardItemCategoryId"];
            this.boardItemTypeId = _data["boardItemTypeId"];
            this.isTemplate = _data["isTemplate"];
            this.isConfidential = _data["isConfidential"];
            this.spreadsheetData = _data["spreadsheetData"];
        }
    }

    static fromJS(data: any): BoardItemInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["specialOccurrenceId"] = this.specialOccurrenceId;
        data["boardId"] = this.boardId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate;
        data["plannedDate"] = this.plannedDate;
        data["boardItemCategoryId"] = this.boardItemCategoryId;
        data["boardItemTypeId"] = this.boardItemTypeId;
        data["isTemplate"] = this.isTemplate;
        data["isConfidential"] = this.isConfidential;
        data["spreadsheetData"] = this.spreadsheetData;
        return data;
    }
}

export interface IBoardItemInsertDto {
    guid?: string;
    specialOccurrenceId?: string | undefined;
    boardId?: string;
    title?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    assignedToUserId?: string | undefined;
    dueDate?: string | undefined;
    plannedDate?: string | undefined;
    boardItemCategoryId?: string;
    boardItemTypeId?: string;
    isTemplate?: boolean;
    isConfidential?: boolean;
    spreadsheetData?: string | undefined;
}

export class BoardItemCreateFromTemplateDto implements IBoardItemCreateFromTemplateDto {
    id?: string | undefined;
    templateId?: string;
    specialOccurrenceId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    flightLegEventId?: string | undefined;
    creationComment?: string | undefined;
    plannedMinutesAfterCreation?: number;
    dueMinutesAfterCreation?: number;
    interfaceBk?: string | undefined;

    constructor(data?: IBoardItemCreateFromTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateId = _data["templateId"];
            this.specialOccurrenceId = _data["specialOccurrenceId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.flightLegEventId = _data["flightLegEventId"];
            this.creationComment = _data["creationComment"];
            this.plannedMinutesAfterCreation = _data["plannedMinutesAfterCreation"];
            this.dueMinutesAfterCreation = _data["dueMinutesAfterCreation"];
            this.interfaceBk = _data["interfaceBk"];
        }
    }

    static fromJS(data: any): BoardItemCreateFromTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemCreateFromTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateId"] = this.templateId;
        data["specialOccurrenceId"] = this.specialOccurrenceId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["flightLegEventId"] = this.flightLegEventId;
        data["creationComment"] = this.creationComment;
        data["plannedMinutesAfterCreation"] = this.plannedMinutesAfterCreation;
        data["dueMinutesAfterCreation"] = this.dueMinutesAfterCreation;
        data["interfaceBk"] = this.interfaceBk;
        return data;
    }
}

export interface IBoardItemCreateFromTemplateDto {
    id?: string | undefined;
    templateId?: string;
    specialOccurrenceId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    flightLegEventId?: string | undefined;
    creationComment?: string | undefined;
    plannedMinutesAfterCreation?: number;
    dueMinutesAfterCreation?: number;
    interfaceBk?: string | undefined;
}

export class BoardItemUpdateDto implements IBoardItemUpdateDto {
    id?: string;
    title?: string | undefined;
    isRelevantForReport?: boolean;
    isConfidential?: boolean;
    spreadsheetData?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    dueDate?: string | undefined;
    plannedDate?: string | undefined;
    validFromDate?: string | undefined;
    validToDate?: string | undefined;
    assignedToUserId?: string | undefined;
    rowVersion?: number;
    boardItemTypeId?: string;
    boardItemListId?: string;
    boardItemStatus?: BoardItemStatusDto;
    priority?: BoardItemPriorityDto;
    postActionUpdates?: BoardItemActionDto[] | undefined;
    actionsDataJson?: string | undefined;
    dynamicTemplateFilesJson?: string | undefined;

    constructor(data?: IBoardItemUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.isRelevantForReport = _data["isRelevantForReport"];
            this.isConfidential = _data["isConfidential"];
            this.spreadsheetData = _data["spreadsheetData"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.dueDate = _data["dueDate"];
            this.plannedDate = _data["plannedDate"];
            this.validFromDate = _data["validFromDate"];
            this.validToDate = _data["validToDate"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.rowVersion = _data["rowVersion"];
            this.boardItemTypeId = _data["boardItemTypeId"];
            this.boardItemListId = _data["boardItemListId"];
            this.boardItemStatus = _data["boardItemStatus"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["postActionUpdates"])) {
                this.postActionUpdates = [] as any;
                for (let item of _data["postActionUpdates"])
                    this.postActionUpdates!.push(BoardItemActionDto.fromJS(item));
            }
            this.actionsDataJson = _data["actionsDataJson"];
            this.dynamicTemplateFilesJson = _data["dynamicTemplateFilesJson"];
        }
    }

    static fromJS(data: any): BoardItemUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["isRelevantForReport"] = this.isRelevantForReport;
        data["isConfidential"] = this.isConfidential;
        data["spreadsheetData"] = this.spreadsheetData;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["dueDate"] = this.dueDate;
        data["plannedDate"] = this.plannedDate;
        data["validFromDate"] = this.validFromDate;
        data["validToDate"] = this.validToDate;
        data["assignedToUserId"] = this.assignedToUserId;
        data["rowVersion"] = this.rowVersion;
        data["boardItemTypeId"] = this.boardItemTypeId;
        data["boardItemListId"] = this.boardItemListId;
        data["boardItemStatus"] = this.boardItemStatus;
        data["priority"] = this.priority;
        if (Array.isArray(this.postActionUpdates)) {
            data["postActionUpdates"] = [];
            for (let item of this.postActionUpdates)
                data["postActionUpdates"].push(item ? item.toJSON() : undefined as any);
        }
        data["actionsDataJson"] = this.actionsDataJson;
        data["dynamicTemplateFilesJson"] = this.dynamicTemplateFilesJson;
        return data;
    }
}

export interface IBoardItemUpdateDto {
    id?: string;
    title?: string | undefined;
    isRelevantForReport?: boolean;
    isConfidential?: boolean;
    spreadsheetData?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    dueDate?: string | undefined;
    plannedDate?: string | undefined;
    validFromDate?: string | undefined;
    validToDate?: string | undefined;
    assignedToUserId?: string | undefined;
    rowVersion?: number;
    boardItemTypeId?: string;
    boardItemListId?: string;
    boardItemStatus?: BoardItemStatusDto;
    priority?: BoardItemPriorityDto;
    postActionUpdates?: BoardItemActionDto[] | undefined;
    actionsDataJson?: string | undefined;
    dynamicTemplateFilesJson?: string | undefined;
}

export class BoardItemClickDto implements IBoardItemClickDto {
    boardId?: string;
    boardItemId?: string;

    constructor(data?: IBoardItemClickDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            this.boardItemId = _data["boardItemId"];
        }
    }

    static fromJS(data: any): BoardItemClickDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemClickDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        data["boardItemId"] = this.boardItemId;
        return data;
    }
}

export interface IBoardItemClickDto {
    boardId?: string;
    boardItemId?: string;
}

export class SendAsEmailOptionsDto implements ISendAsEmailOptionsDto {
    replyToAddresses?: SendAsEmailReplyToAddress[] | undefined;
    signature?: string | undefined;
    sender?: string | undefined;

    constructor(data?: ISendAsEmailOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["replyToAddresses"])) {
                this.replyToAddresses = [] as any;
                for (let item of _data["replyToAddresses"])
                    this.replyToAddresses!.push(SendAsEmailReplyToAddress.fromJS(item));
            }
            this.signature = _data["signature"];
            this.sender = _data["sender"];
        }
    }

    static fromJS(data: any): SendAsEmailOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendAsEmailOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.replyToAddresses)) {
            data["replyToAddresses"] = [];
            for (let item of this.replyToAddresses)
                data["replyToAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        data["signature"] = this.signature;
        data["sender"] = this.sender;
        return data;
    }
}

export interface ISendAsEmailOptionsDto {
    replyToAddresses?: SendAsEmailReplyToAddress[] | undefined;
    signature?: string | undefined;
    sender?: string | undefined;
}

export class SendAsEmailReplyToAddress implements ISendAsEmailReplyToAddress {
    emailAddress?: string | undefined;
    description?: string | undefined;

    constructor(data?: ISendAsEmailReplyToAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SendAsEmailReplyToAddress {
        data = typeof data === 'object' ? data : {};
        let result = new SendAsEmailReplyToAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["description"] = this.description;
        return data;
    }
}

export interface ISendAsEmailReplyToAddress {
    emailAddress?: string | undefined;
    description?: string | undefined;
}

export class SendAsEmailGetOptionsDto implements ISendAsEmailGetOptionsDto {
    boardItemId?: string;
    currentBoardId?: string | undefined;

    constructor(data?: ISendAsEmailGetOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardItemId = _data["boardItemId"];
            this.currentBoardId = _data["currentBoardId"];
        }
    }

    static fromJS(data: any): SendAsEmailGetOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendAsEmailGetOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardItemId"] = this.boardItemId;
        data["currentBoardId"] = this.currentBoardId;
        return data;
    }
}

export interface ISendAsEmailGetOptionsDto {
    boardItemId?: string;
    currentBoardId?: string | undefined;
}

export class SendAsEmailDto implements ISendAsEmailDto {
    sender?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    includeComments?: boolean;
    includeChecklists?: boolean;
    includeLabels?: boolean;
    attachmentIds?: string[] | undefined;
    replyTo?: string | undefined;

    constructor(data?: ISendAsEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sender = _data["sender"];
            this.to = _data["to"];
            this.cc = _data["cc"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.includeComments = _data["includeComments"];
            this.includeChecklists = _data["includeChecklists"];
            this.includeLabels = _data["includeLabels"];
            if (Array.isArray(_data["attachmentIds"])) {
                this.attachmentIds = [] as any;
                for (let item of _data["attachmentIds"])
                    this.attachmentIds!.push(item);
            }
            this.replyTo = _data["replyTo"];
        }
    }

    static fromJS(data: any): SendAsEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendAsEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender;
        data["to"] = this.to;
        data["cc"] = this.cc;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["includeComments"] = this.includeComments;
        data["includeChecklists"] = this.includeChecklists;
        data["includeLabels"] = this.includeLabels;
        if (Array.isArray(this.attachmentIds)) {
            data["attachmentIds"] = [];
            for (let item of this.attachmentIds)
                data["attachmentIds"].push(item);
        }
        data["replyTo"] = this.replyTo;
        return data;
    }
}

export interface ISendAsEmailDto {
    sender?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    includeComments?: boolean;
    includeChecklists?: boolean;
    includeLabels?: boolean;
    attachmentIds?: string[] | undefined;
    replyTo?: string | undefined;
}

export class BoardItemShareDto implements IBoardItemShareDto {
    boardItemId?: string;
    currentBoardId?: string;
    sharedBoardId?: string;

    constructor(data?: IBoardItemShareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardItemId = _data["boardItemId"];
            this.currentBoardId = _data["currentBoardId"];
            this.sharedBoardId = _data["sharedBoardId"];
        }
    }

    static fromJS(data: any): BoardItemShareDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemShareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardItemId"] = this.boardItemId;
        data["currentBoardId"] = this.currentBoardId;
        data["sharedBoardId"] = this.sharedBoardId;
        return data;
    }
}

export interface IBoardItemShareDto {
    boardItemId?: string;
    currentBoardId?: string;
    sharedBoardId?: string;
}

export class BoardItemUnshareDto implements IBoardItemUnshareDto {
    boardItemId?: string;
    currentBoardId?: string;
    unsharedBoardId?: string;

    constructor(data?: IBoardItemUnshareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardItemId = _data["boardItemId"];
            this.currentBoardId = _data["currentBoardId"];
            this.unsharedBoardId = _data["unsharedBoardId"];
        }
    }

    static fromJS(data: any): BoardItemUnshareDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemUnshareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardItemId"] = this.boardItemId;
        data["currentBoardId"] = this.currentBoardId;
        data["unsharedBoardId"] = this.unsharedBoardId;
        return data;
    }
}

export interface IBoardItemUnshareDto {
    boardItemId?: string;
    currentBoardId?: string;
    unsharedBoardId?: string;
}

export class BoardItemStopSharingDto implements IBoardItemStopSharingDto {
    boardItemId?: string;
    currentBoardId?: string;

    constructor(data?: IBoardItemStopSharingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardItemId = _data["boardItemId"];
            this.currentBoardId = _data["currentBoardId"];
        }
    }

    static fromJS(data: any): BoardItemStopSharingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemStopSharingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardItemId"] = this.boardItemId;
        data["currentBoardId"] = this.currentBoardId;
        return data;
    }
}

export interface IBoardItemStopSharingDto {
    boardItemId?: string;
    currentBoardId?: string;
}

export class TemplateCategoryWithTemplatesDto implements ITemplateCategoryWithTemplatesDto {
    category?: TemplateCategoryDto | undefined;
    templates?: BoardItemTemplateWithScheduleAndAvailabilityDto[] | undefined;

    constructor(data?: ITemplateCategoryWithTemplatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"] ? TemplateCategoryDto.fromJS(_data["category"]) : undefined as any;
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(BoardItemTemplateWithScheduleAndAvailabilityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateCategoryWithTemplatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateCategoryWithTemplatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITemplateCategoryWithTemplatesDto {
    category?: TemplateCategoryDto | undefined;
    templates?: BoardItemTemplateWithScheduleAndAvailabilityDto[] | undefined;
}

export class TemplateCategoryDto implements ITemplateCategoryDto {
    guid?: string | undefined;
    boardGuid?: string;
    name?: string | undefined;
    icon?: string | undefined;
    sortOrder?: number;

    constructor(data?: ITemplateCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.boardGuid = _data["boardGuid"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): TemplateCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["boardGuid"] = this.boardGuid;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ITemplateCategoryDto {
    guid?: string | undefined;
    boardGuid?: string;
    name?: string | undefined;
    icon?: string | undefined;
    sortOrder?: number;
}

export class BoardItemTemplateWithScheduleAndAvailabilityDto implements IBoardItemTemplateWithScheduleAndAvailabilityDto {
    template?: BoardItemDto | undefined;
    availability?: BoardItemTemplateAvailabilityViewDto[] | undefined;
    schedules?: BoardItemTemplateScheduleDto[] | undefined;

    constructor(data?: IBoardItemTemplateWithScheduleAndAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"] ? BoardItemDto.fromJS(_data["template"]) : undefined as any;
            if (Array.isArray(_data["availability"])) {
                this.availability = [] as any;
                for (let item of _data["availability"])
                    this.availability!.push(BoardItemTemplateAvailabilityViewDto.fromJS(item));
            }
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["schedules"])
                    this.schedules!.push(BoardItemTemplateScheduleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BoardItemTemplateWithScheduleAndAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemTemplateWithScheduleAndAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        if (Array.isArray(this.availability)) {
            data["availability"] = [];
            for (let item of this.availability)
                data["availability"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (let item of this.schedules)
                data["schedules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBoardItemTemplateWithScheduleAndAvailabilityDto {
    template?: BoardItemDto | undefined;
    availability?: BoardItemTemplateAvailabilityViewDto[] | undefined;
    schedules?: BoardItemTemplateScheduleDto[] | undefined;
}

export class BoardItemTemplateAvailabilityViewDto implements IBoardItemTemplateAvailabilityViewDto {
    specialOccurrenceType?: SpecialOccurrenceType;
    isAvailable?: boolean;
    sortOrder?: number;

    constructor(data?: IBoardItemTemplateAvailabilityViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialOccurrenceType = _data["specialOccurrenceType"];
            this.isAvailable = _data["isAvailable"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): BoardItemTemplateAvailabilityViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemTemplateAvailabilityViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialOccurrenceType"] = this.specialOccurrenceType;
        data["isAvailable"] = this.isAvailable;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IBoardItemTemplateAvailabilityViewDto {
    specialOccurrenceType?: SpecialOccurrenceType;
    isAvailable?: boolean;
    sortOrder?: number;
}

export enum SpecialOccurrenceType {
    None = "None",
    TechnicalOccurrence = "TechnicalOccurrence",
    Comat = "Comat",
    Diversion = "Diversion",
    MaterialRequest = "MaterialRequest",
}

export class BoardItemTemplateScheduleDto implements IBoardItemTemplateScheduleDto {
    id?: string;
    scheduleType?: BoardItemScheduleType;
    description?: string | undefined;
    cronExpression?: string | undefined;
    cronExpressionIsLocalTime?: boolean;
    shiftTypeId?: string;
    shiftTypeName?: string | undefined;
    plannedMinutesAfterCreation?: number;
    dueMinutesAfterCreation?: number;

    constructor(data?: IBoardItemTemplateScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduleType = _data["scheduleType"];
            this.description = _data["description"];
            this.cronExpression = _data["cronExpression"];
            this.cronExpressionIsLocalTime = _data["cronExpressionIsLocalTime"];
            this.shiftTypeId = _data["shiftTypeId"];
            this.shiftTypeName = _data["shiftTypeName"];
            this.plannedMinutesAfterCreation = _data["plannedMinutesAfterCreation"];
            this.dueMinutesAfterCreation = _data["dueMinutesAfterCreation"];
        }
    }

    static fromJS(data: any): BoardItemTemplateScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemTemplateScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduleType"] = this.scheduleType;
        data["description"] = this.description;
        data["cronExpression"] = this.cronExpression;
        data["cronExpressionIsLocalTime"] = this.cronExpressionIsLocalTime;
        data["shiftTypeId"] = this.shiftTypeId;
        data["shiftTypeName"] = this.shiftTypeName;
        data["plannedMinutesAfterCreation"] = this.plannedMinutesAfterCreation;
        data["dueMinutesAfterCreation"] = this.dueMinutesAfterCreation;
        return data;
    }
}

export interface IBoardItemTemplateScheduleDto {
    id?: string;
    scheduleType?: BoardItemScheduleType;
    description?: string | undefined;
    cronExpression?: string | undefined;
    cronExpressionIsLocalTime?: boolean;
    shiftTypeId?: string;
    shiftTypeName?: string | undefined;
    plannedMinutesAfterCreation?: number;
    dueMinutesAfterCreation?: number;
}

export enum BoardItemScheduleType {
    Date = "Date",
    ShiftStart = "ShiftStart",
}

export class BoardItemTemplateScheduleInsertDto implements IBoardItemTemplateScheduleInsertDto {
    boardItemId?: string;
    scheduleType?: BoardItemScheduleType;
    cronExpression?: string | undefined;
    cronExpressionIsLocalTime?: boolean;
    shiftTypeId?: string | undefined;
    plannedMinutesAfterCreation?: number;
    dueMinutesAfterCreation?: number;

    constructor(data?: IBoardItemTemplateScheduleInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardItemId = _data["boardItemId"];
            this.scheduleType = _data["scheduleType"];
            this.cronExpression = _data["cronExpression"];
            this.cronExpressionIsLocalTime = _data["cronExpressionIsLocalTime"];
            this.shiftTypeId = _data["shiftTypeId"];
            this.plannedMinutesAfterCreation = _data["plannedMinutesAfterCreation"];
            this.dueMinutesAfterCreation = _data["dueMinutesAfterCreation"];
        }
    }

    static fromJS(data: any): BoardItemTemplateScheduleInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemTemplateScheduleInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardItemId"] = this.boardItemId;
        data["scheduleType"] = this.scheduleType;
        data["cronExpression"] = this.cronExpression;
        data["cronExpressionIsLocalTime"] = this.cronExpressionIsLocalTime;
        data["shiftTypeId"] = this.shiftTypeId;
        data["plannedMinutesAfterCreation"] = this.plannedMinutesAfterCreation;
        data["dueMinutesAfterCreation"] = this.dueMinutesAfterCreation;
        return data;
    }
}

export interface IBoardItemTemplateScheduleInsertDto {
    boardItemId?: string;
    scheduleType?: BoardItemScheduleType;
    cronExpression?: string | undefined;
    cronExpressionIsLocalTime?: boolean;
    shiftTypeId?: string | undefined;
    plannedMinutesAfterCreation?: number;
    dueMinutesAfterCreation?: number;
}

export enum MoveBackTypeDto {
    GiveBack = "GiveBack",
    TakeBack = "TakeBack",
}

export class ValueTupleOfBoardItemDtoAndBoardItemDto implements IValueTupleOfBoardItemDtoAndBoardItemDto {
    item1?: BoardItemDto | undefined;
    item2?: BoardItemDto | undefined;

    constructor(data?: IValueTupleOfBoardItemDtoAndBoardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? BoardItemDto.fromJS(_data["item1"]) : undefined as any;
            this.item2 = _data["item2"] ? BoardItemDto.fromJS(_data["item2"]) : undefined as any;
        }
    }

    static fromJS(data: any): ValueTupleOfBoardItemDtoAndBoardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfBoardItemDtoAndBoardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : undefined as any;
        data["item2"] = this.item2 ? this.item2.toJSON() : undefined as any;
        return data;
    }
}

export interface IValueTupleOfBoardItemDtoAndBoardItemDto {
    item1?: BoardItemDto | undefined;
    item2?: BoardItemDto | undefined;
}

export class BoardItemTransferDto implements IBoardItemTransferDto {
    currentBoardId?: string;
    newBoardId?: string;
    boardItemId?: string;

    constructor(data?: IBoardItemTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentBoardId = _data["currentBoardId"];
            this.newBoardId = _data["newBoardId"];
            this.boardItemId = _data["boardItemId"];
        }
    }

    static fromJS(data: any): BoardItemTransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentBoardId"] = this.currentBoardId;
        data["newBoardId"] = this.newBoardId;
        data["boardItemId"] = this.boardItemId;
        return data;
    }
}

export interface IBoardItemTransferDto {
    currentBoardId?: string;
    newBoardId?: string;
    boardItemId?: string;
}

export class PublicConfigDto implements IPublicConfigDto {
    authMode?: string | undefined;
    azureAd?: AzureAdConfigDto | undefined;
    enableDemoFeatures?: boolean;
    branding?: PublicBrandingDto | undefined;

    constructor(data?: IPublicConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authMode = _data["authMode"];
            this.azureAd = _data["azureAd"] ? AzureAdConfigDto.fromJS(_data["azureAd"]) : undefined as any;
            this.enableDemoFeatures = _data["enableDemoFeatures"];
            this.branding = _data["branding"] ? PublicBrandingDto.fromJS(_data["branding"]) : undefined as any;
        }
    }

    static fromJS(data: any): PublicConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authMode"] = this.authMode;
        data["azureAd"] = this.azureAd ? this.azureAd.toJSON() : undefined as any;
        data["enableDemoFeatures"] = this.enableDemoFeatures;
        data["branding"] = this.branding ? this.branding.toJSON() : undefined as any;
        return data;
    }
}

export interface IPublicConfigDto {
    authMode?: string | undefined;
    azureAd?: AzureAdConfigDto | undefined;
    enableDemoFeatures?: boolean;
    branding?: PublicBrandingDto | undefined;
}

export class AzureAdConfigDto implements IAzureAdConfigDto {
    clientId?: string | undefined;
    tenantId?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IAzureAdConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.tenantId = _data["tenantId"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): AzureAdConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureAdConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["tenantId"] = this.tenantId;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IAzureAdConfigDto {
    clientId?: string | undefined;
    tenantId?: string | undefined;
    instance?: string | undefined;
}

export class PublicBrandingDto implements IPublicBrandingDto {
    companyName?: string | undefined;
    appName?: string | undefined;
    logoFileName?: string | undefined;
    backgroundImageFilename?: string | undefined;

    constructor(data?: IPublicBrandingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.appName = _data["appName"];
            this.logoFileName = _data["logoFileName"];
            this.backgroundImageFilename = _data["backgroundImageFilename"];
        }
    }

    static fromJS(data: any): PublicBrandingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicBrandingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["appName"] = this.appName;
        data["logoFileName"] = this.logoFileName;
        data["backgroundImageFilename"] = this.backgroundImageFilename;
        return data;
    }
}

export interface IPublicBrandingDto {
    companyName?: string | undefined;
    appName?: string | undefined;
    logoFileName?: string | undefined;
    backgroundImageFilename?: string | undefined;
}

export class BoardLabelDto implements IBoardLabelDto {
    id?: string;
    labelId?: string;
    isAvailable?: boolean;

    constructor(data?: IBoardLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.labelId = _data["labelId"];
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): BoardLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["labelId"] = this.labelId;
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IBoardLabelDto {
    id?: string;
    labelId?: string;
    isAvailable?: boolean;
}

export class ServiceResult implements IServiceResult {
    errors?: string[] | undefined;
    errorCode?: ServiceErrorCode;
    isSuccess?: boolean;

    constructor(data?: IServiceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.errorCode = _data["errorCode"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): ServiceResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["errorCode"] = this.errorCode;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IServiceResult {
    errors?: string[] | undefined;
    errorCode?: ServiceErrorCode;
    isSuccess?: boolean;
}

export class ServiceResultOfGuid extends ServiceResult implements IServiceResultOfGuid {
    entity?: string;

    constructor(data?: IServiceResultOfGuid) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"];
        }
    }

    static override fromJS(data: any): ServiceResultOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfGuid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfGuid extends IServiceResult {
    entity?: string;
}

export enum ServiceErrorCode {
    None = "None",
    EntityNotFound = "EntityNotFound",
    EntityInUse = "EntityInUse",
}

export class BoardItemLabelsDto implements IBoardItemLabelsDto {
    boardItemId?: string;
    labels?: LabelDto[] | undefined;

    constructor(data?: IBoardItemLabelsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardItemId = _data["boardItemId"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(LabelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BoardItemLabelsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemLabelsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardItemId"] = this.boardItemId;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBoardItemLabelsDto {
    boardItemId?: string;
    labels?: LabelDto[] | undefined;
}

export class LogDto implements ILogDto {
    id?: number;
    insertDate?: string;
    logger?: string | undefined;
    message?: string | undefined;
    level?: string | undefined;
    requestUrl?: string | undefined;
    action?: string | undefined;
    exception?: string | undefined;
    userIdentity?: string | undefined;
    callSite?: string | undefined;

    constructor(data?: ILogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.insertDate = _data["insertDate"];
            this.logger = _data["logger"];
            this.message = _data["message"];
            this.level = _data["level"];
            this.requestUrl = _data["requestUrl"];
            this.action = _data["action"];
            this.exception = _data["exception"];
            this.userIdentity = _data["userIdentity"];
            this.callSite = _data["callSite"];
        }
    }

    static fromJS(data: any): LogDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["insertDate"] = this.insertDate;
        data["logger"] = this.logger;
        data["message"] = this.message;
        data["level"] = this.level;
        data["requestUrl"] = this.requestUrl;
        data["action"] = this.action;
        data["exception"] = this.exception;
        data["userIdentity"] = this.userIdentity;
        data["callSite"] = this.callSite;
        return data;
    }
}

export interface ILogDto {
    id?: number;
    insertDate?: string;
    logger?: string | undefined;
    message?: string | undefined;
    level?: string | undefined;
    requestUrl?: string | undefined;
    action?: string | undefined;
    exception?: string | undefined;
    userIdentity?: string | undefined;
    callSite?: string | undefined;
}

export class ConnectedUserInfo implements IConnectedUserInfo {
    connectionId?: string | undefined;
    username?: string | undefined;
    version?: string | undefined;

    constructor(data?: IConnectedUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionId = _data["connectionId"];
            this.username = _data["username"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ConnectedUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectedUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionId"] = this.connectionId;
        data["username"] = this.username;
        data["version"] = this.version;
        return data;
    }
}

export interface IConnectedUserInfo {
    connectionId?: string | undefined;
    username?: string | undefined;
    version?: string | undefined;
}

export class AirportDto implements IAirportDto {
    id?: string | undefined;
    iataCode?: string | undefined;
    icaoCode?: string | undefined;
    name?: string | undefined;
    mro?: string | undefined;
    mroEmail?: string | undefined;
    sisPdfUrl?: string | undefined;
    latitude?: number;
    longitude?: number;

    constructor(data?: IAirportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iataCode = _data["iataCode"];
            this.icaoCode = _data["icaoCode"];
            this.name = _data["name"];
            this.mro = _data["mro"];
            this.mroEmail = _data["mroEmail"];
            this.sisPdfUrl = _data["sisPdfUrl"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): AirportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AirportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iataCode"] = this.iataCode;
        data["icaoCode"] = this.icaoCode;
        data["name"] = this.name;
        data["mro"] = this.mro;
        data["mroEmail"] = this.mroEmail;
        data["sisPdfUrl"] = this.sisPdfUrl;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IAirportDto {
    id?: string | undefined;
    iataCode?: string | undefined;
    icaoCode?: string | undefined;
    name?: string | undefined;
    mro?: string | undefined;
    mroEmail?: string | undefined;
    sisPdfUrl?: string | undefined;
    latitude?: number;
    longitude?: number;
}

export class EmailContactDto implements IEmailContactDto {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: IEmailContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EmailContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IEmailContactDto {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
}

export class DiversionReasonDto implements IDiversionReasonDto {
    id?: string | undefined;
    name?: string | undefined;
    isOther?: boolean;
    sortOrder?: number;

    constructor(data?: IDiversionReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isOther = _data["isOther"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): DiversionReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiversionReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isOther"] = this.isOther;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IDiversionReasonDto {
    id?: string | undefined;
    name?: string | undefined;
    isOther?: boolean;
    sortOrder?: number;
}

export class SpecialOccurrenceDto implements ISpecialOccurrenceDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    ownerBoardId?: string;
    type?: SpecialOccurrenceTypeDto;
    boardItems?: BoardItemDto[] | undefined;
    outcomeComment?: string | undefined;
    flights?: FlightInfoDto[] | undefined;
    createdDate?: string;
    isCompleted?: boolean;
    boardIds?: string[] | undefined;
    linkedMaterialRequestId?: string | undefined;
    cssClass?: string | undefined;

    protected _discriminator: string;

    constructor(data?: ISpecialOccurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "SpecialOccurrenceDto";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ownerBoardId = _data["ownerBoardId"];
            this.type = _data["type"];
            if (Array.isArray(_data["boardItems"])) {
                this.boardItems = [] as any;
                for (let item of _data["boardItems"])
                    this.boardItems!.push(BoardItemDto.fromJS(item));
            }
            this.outcomeComment = _data["outcomeComment"];
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(FlightInfoDto.fromJS(item));
            }
            this.createdDate = _data["createdDate"];
            this.isCompleted = _data["isCompleted"];
            if (Array.isArray(_data["boardIds"])) {
                this.boardIds = [] as any;
                for (let item of _data["boardIds"])
                    this.boardIds!.push(item);
            }
            this.linkedMaterialRequestId = _data["linkedMaterialRequestId"];
            this.cssClass = _data["cssClass"];
        }
    }

    static fromJS(data: any): SpecialOccurrenceDto {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "MaterialRequestDto") {
            let result = new MaterialRequestDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TechnicalOccurrenceDto") {
            let result = new TechnicalOccurrenceDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ComatDto") {
            let result = new ComatDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DiversionDto") {
            let result = new DiversionDto();
            result.init(data);
            return result;
        }
        let result = new SpecialOccurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ownerBoardId"] = this.ownerBoardId;
        data["type"] = this.type;
        if (Array.isArray(this.boardItems)) {
            data["boardItems"] = [];
            for (let item of this.boardItems)
                data["boardItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["outcomeComment"] = this.outcomeComment;
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdDate"] = this.createdDate;
        data["isCompleted"] = this.isCompleted;
        if (Array.isArray(this.boardIds)) {
            data["boardIds"] = [];
            for (let item of this.boardIds)
                data["boardIds"].push(item);
        }
        data["linkedMaterialRequestId"] = this.linkedMaterialRequestId;
        data["cssClass"] = this.cssClass;
        return data;
    }
}

export interface ISpecialOccurrenceDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    ownerBoardId?: string;
    type?: SpecialOccurrenceTypeDto;
    boardItems?: BoardItemDto[] | undefined;
    outcomeComment?: string | undefined;
    flights?: FlightInfoDto[] | undefined;
    createdDate?: string;
    isCompleted?: boolean;
    boardIds?: string[] | undefined;
    linkedMaterialRequestId?: string | undefined;
    cssClass?: string | undefined;
}

export class MaterialRequestDto extends SpecialOccurrenceDto implements IMaterialRequestDto {
    aircraft?: string | undefined;
    airport?: string | undefined;
    isEditable?: boolean;
    technicalOccurrenceGuid?: string | undefined;
    managementReportLastSent?: string | undefined;
    managementReportNextSend?: string | undefined;

    constructor(data?: IMaterialRequestDto) {
        super(data);
        this._discriminator = "MaterialRequestDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.aircraft = _data["aircraft"];
            this.airport = _data["airport"];
            this.isEditable = _data["isEditable"];
            this.technicalOccurrenceGuid = _data["technicalOccurrenceGuid"];
            this.managementReportLastSent = _data["managementReportLastSent"];
            this.managementReportNextSend = _data["managementReportNextSend"];
        }
    }

    static override fromJS(data: any): MaterialRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aircraft"] = this.aircraft;
        data["airport"] = this.airport;
        data["isEditable"] = this.isEditable;
        data["technicalOccurrenceGuid"] = this.technicalOccurrenceGuid;
        data["managementReportLastSent"] = this.managementReportLastSent;
        data["managementReportNextSend"] = this.managementReportNextSend;
        super.toJSON(data);
        return data;
    }
}

export interface IMaterialRequestDto extends ISpecialOccurrenceDto {
    aircraft?: string | undefined;
    airport?: string | undefined;
    isEditable?: boolean;
    technicalOccurrenceGuid?: string | undefined;
    managementReportLastSent?: string | undefined;
    managementReportNextSend?: string | undefined;
}

export enum SpecialOccurrenceTypeDto {
    None = "None",
    TechnicalOccurrence = "TechnicalOccurrence",
    Comat = "Comat",
    Diversion = "Diversion",
    MaterialRequest = "MaterialRequest",
}

export class FlightInfoDto implements IFlightInfoDto {
    internalId?: string;
    id?: string | undefined;
    date?: string | undefined;
    flightNo?: string | undefined;
    departureAirport?: string | undefined;
    arrivalAirport?: string | undefined;
    diversionAirport?: string | undefined;
    scheduledTimeOfDeparture?: string | undefined;
    scheduledTimeOfArrival?: string | undefined;
    aircraftRegistration?: string | undefined;
    aircraftType?: string | undefined;
    operator?: string | undefined;
    flightState?: string | undefined;
    url?: string | undefined;
    selectedReason?: string | undefined;
    selectedReasonComment?: string | undefined;

    constructor(data?: IFlightInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalId = _data["internalId"];
            this.id = _data["id"];
            this.date = _data["date"];
            this.flightNo = _data["flightNo"];
            this.departureAirport = _data["departureAirport"];
            this.arrivalAirport = _data["arrivalAirport"];
            this.diversionAirport = _data["diversionAirport"];
            this.scheduledTimeOfDeparture = _data["scheduledTimeOfDeparture"];
            this.scheduledTimeOfArrival = _data["scheduledTimeOfArrival"];
            this.aircraftRegistration = _data["aircraftRegistration"];
            this.aircraftType = _data["aircraftType"];
            this.operator = _data["operator"];
            this.flightState = _data["flightState"];
            this.url = _data["url"];
            this.selectedReason = _data["selectedReason"];
            this.selectedReasonComment = _data["selectedReasonComment"];
        }
    }

    static fromJS(data: any): FlightInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId;
        data["id"] = this.id;
        data["date"] = this.date;
        data["flightNo"] = this.flightNo;
        data["departureAirport"] = this.departureAirport;
        data["arrivalAirport"] = this.arrivalAirport;
        data["diversionAirport"] = this.diversionAirport;
        data["scheduledTimeOfDeparture"] = this.scheduledTimeOfDeparture;
        data["scheduledTimeOfArrival"] = this.scheduledTimeOfArrival;
        data["aircraftRegistration"] = this.aircraftRegistration;
        data["aircraftType"] = this.aircraftType;
        data["operator"] = this.operator;
        data["flightState"] = this.flightState;
        data["url"] = this.url;
        data["selectedReason"] = this.selectedReason;
        data["selectedReasonComment"] = this.selectedReasonComment;
        return data;
    }
}

export interface IFlightInfoDto {
    internalId?: string;
    id?: string | undefined;
    date?: string | undefined;
    flightNo?: string | undefined;
    departureAirport?: string | undefined;
    arrivalAirport?: string | undefined;
    diversionAirport?: string | undefined;
    scheduledTimeOfDeparture?: string | undefined;
    scheduledTimeOfArrival?: string | undefined;
    aircraftRegistration?: string | undefined;
    aircraftType?: string | undefined;
    operator?: string | undefined;
    flightState?: string | undefined;
    url?: string | undefined;
    selectedReason?: string | undefined;
    selectedReasonComment?: string | undefined;
}

export class TechnicalOccurrenceDto extends SpecialOccurrenceDto implements ITechnicalOccurrenceDto {
    aircraft?: string | undefined;
    airport?: string | undefined;
    technicalOccurrenceTypeId?: string | undefined;
    groundTimeAta?: string;
    scheduledTimeOfDeparture?: string | undefined;
    estimatedTimeOfDeparture?: string | undefined;
    maintenanceCompanyId?: string | undefined;
    maintenanceCompanyInfo?: string | undefined;
    isEngineeringSupport?: boolean;
    isHangar?: boolean;
    generalRemarks?: string | undefined;
    specialOccurrenceUpdates?: SpecialOccurrenceUpdateDto[] | undefined;
    technicalOccurrenceType?: TechnicalOccurrenceTypeDto | undefined;
    materialRequestGuid?: string | undefined;

    constructor(data?: ITechnicalOccurrenceDto) {
        super(data);
        this._discriminator = "TechnicalOccurrenceDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.aircraft = _data["aircraft"];
            this.airport = _data["airport"];
            this.technicalOccurrenceTypeId = _data["technicalOccurrenceTypeId"];
            this.groundTimeAta = _data["groundTimeAta"];
            this.scheduledTimeOfDeparture = _data["scheduledTimeOfDeparture"];
            this.estimatedTimeOfDeparture = _data["estimatedTimeOfDeparture"];
            this.maintenanceCompanyId = _data["maintenanceCompanyId"];
            this.maintenanceCompanyInfo = _data["maintenanceCompanyInfo"];
            this.isEngineeringSupport = _data["isEngineeringSupport"];
            this.isHangar = _data["isHangar"];
            this.generalRemarks = _data["generalRemarks"];
            if (Array.isArray(_data["specialOccurrenceUpdates"])) {
                this.specialOccurrenceUpdates = [] as any;
                for (let item of _data["specialOccurrenceUpdates"])
                    this.specialOccurrenceUpdates!.push(SpecialOccurrenceUpdateDto.fromJS(item));
            }
            this.technicalOccurrenceType = _data["technicalOccurrenceType"] ? TechnicalOccurrenceTypeDto.fromJS(_data["technicalOccurrenceType"]) : undefined as any;
            this.materialRequestGuid = _data["materialRequestGuid"];
        }
    }

    static override fromJS(data: any): TechnicalOccurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalOccurrenceDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aircraft"] = this.aircraft;
        data["airport"] = this.airport;
        data["technicalOccurrenceTypeId"] = this.technicalOccurrenceTypeId;
        data["groundTimeAta"] = this.groundTimeAta;
        data["scheduledTimeOfDeparture"] = this.scheduledTimeOfDeparture;
        data["estimatedTimeOfDeparture"] = this.estimatedTimeOfDeparture;
        data["maintenanceCompanyId"] = this.maintenanceCompanyId;
        data["maintenanceCompanyInfo"] = this.maintenanceCompanyInfo;
        data["isEngineeringSupport"] = this.isEngineeringSupport;
        data["isHangar"] = this.isHangar;
        data["generalRemarks"] = this.generalRemarks;
        if (Array.isArray(this.specialOccurrenceUpdates)) {
            data["specialOccurrenceUpdates"] = [];
            for (let item of this.specialOccurrenceUpdates)
                data["specialOccurrenceUpdates"].push(item ? item.toJSON() : undefined as any);
        }
        data["technicalOccurrenceType"] = this.technicalOccurrenceType ? this.technicalOccurrenceType.toJSON() : undefined as any;
        data["materialRequestGuid"] = this.materialRequestGuid;
        super.toJSON(data);
        return data;
    }
}

export interface ITechnicalOccurrenceDto extends ISpecialOccurrenceDto {
    aircraft?: string | undefined;
    airport?: string | undefined;
    technicalOccurrenceTypeId?: string | undefined;
    groundTimeAta?: string;
    scheduledTimeOfDeparture?: string | undefined;
    estimatedTimeOfDeparture?: string | undefined;
    maintenanceCompanyId?: string | undefined;
    maintenanceCompanyInfo?: string | undefined;
    isEngineeringSupport?: boolean;
    isHangar?: boolean;
    generalRemarks?: string | undefined;
    specialOccurrenceUpdates?: SpecialOccurrenceUpdateDto[] | undefined;
    technicalOccurrenceType?: TechnicalOccurrenceTypeDto | undefined;
    materialRequestGuid?: string | undefined;
}

export class SpecialOccurrenceUpdateDto implements ISpecialOccurrenceUpdateDto {
    id?: string;
    specialOccurrenceId?: string;
    defectDescription?: string | undefined;
    furtherSteps?: string | undefined;
    sparesStatus?: string | undefined;
    toolsStatus?: string | undefined;
    createdDate?: string;
    updatedDate?: string | undefined;
    text?: string | undefined;
    nextInfoDate?: string | undefined;
    updates?: string | undefined;
    recipients?: string[] | undefined;
    userId?: string;
    user?: UserDto | undefined;
    isCompletion?: boolean;
    includeMaterialRequestStatus?: boolean;
    includeEstimatedDelay?: boolean;
    estimatedDelayHours?: number | undefined;
    estimatedDelayDescription?: string | undefined;

    constructor(data?: ISpecialOccurrenceUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.specialOccurrenceId = _data["specialOccurrenceId"];
            this.defectDescription = _data["defectDescription"];
            this.furtherSteps = _data["furtherSteps"];
            this.sparesStatus = _data["sparesStatus"];
            this.toolsStatus = _data["toolsStatus"];
            this.createdDate = _data["createdDate"];
            this.updatedDate = _data["updatedDate"];
            this.text = _data["text"];
            this.nextInfoDate = _data["nextInfoDate"];
            this.updates = _data["updates"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.isCompletion = _data["isCompletion"];
            this.includeMaterialRequestStatus = _data["includeMaterialRequestStatus"];
            this.includeEstimatedDelay = _data["includeEstimatedDelay"];
            this.estimatedDelayHours = _data["estimatedDelayHours"];
            this.estimatedDelayDescription = _data["estimatedDelayDescription"];
        }
    }

    static fromJS(data: any): SpecialOccurrenceUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["specialOccurrenceId"] = this.specialOccurrenceId;
        data["defectDescription"] = this.defectDescription;
        data["furtherSteps"] = this.furtherSteps;
        data["sparesStatus"] = this.sparesStatus;
        data["toolsStatus"] = this.toolsStatus;
        data["createdDate"] = this.createdDate;
        data["updatedDate"] = this.updatedDate;
        data["text"] = this.text;
        data["nextInfoDate"] = this.nextInfoDate;
        data["updates"] = this.updates;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["isCompletion"] = this.isCompletion;
        data["includeMaterialRequestStatus"] = this.includeMaterialRequestStatus;
        data["includeEstimatedDelay"] = this.includeEstimatedDelay;
        data["estimatedDelayHours"] = this.estimatedDelayHours;
        data["estimatedDelayDescription"] = this.estimatedDelayDescription;
        return data;
    }
}

export interface ISpecialOccurrenceUpdateDto {
    id?: string;
    specialOccurrenceId?: string;
    defectDescription?: string | undefined;
    furtherSteps?: string | undefined;
    sparesStatus?: string | undefined;
    toolsStatus?: string | undefined;
    createdDate?: string;
    updatedDate?: string | undefined;
    text?: string | undefined;
    nextInfoDate?: string | undefined;
    updates?: string | undefined;
    recipients?: string[] | undefined;
    userId?: string;
    user?: UserDto | undefined;
    isCompletion?: boolean;
    includeMaterialRequestStatus?: boolean;
    includeEstimatedDelay?: boolean;
    estimatedDelayHours?: number | undefined;
    estimatedDelayDescription?: string | undefined;
}

export class TechnicalOccurrenceTypeDto implements ITechnicalOccurrenceTypeDto {
    id?: string;
    name?: string | undefined;
    cssClass?: string | undefined;

    constructor(data?: ITechnicalOccurrenceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cssClass = _data["cssClass"];
        }
    }

    static fromJS(data: any): TechnicalOccurrenceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalOccurrenceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cssClass"] = this.cssClass;
        return data;
    }
}

export interface ITechnicalOccurrenceTypeDto {
    id?: string;
    name?: string | undefined;
    cssClass?: string | undefined;
}

export class ComatDto extends SpecialOccurrenceDto implements IComatDto {
    origin?: string | undefined;
    destination?: string | undefined;
    shipper?: string | undefined;
    plannedDate?: string | undefined;
    partNumber?: string | undefined;
    serialNumber?: string | undefined;
    packageWeight?: number;
    packageWidth?: number;
    packageHeight?: number;
    packageLength?: number;
    packageCount?: number;
    packageType?: string | undefined;
    clearanceStatus?: string | undefined;
    clearanceComment?: string | undefined;
    certificate?: string | undefined;

    constructor(data?: IComatDto) {
        super(data);
        this._discriminator = "ComatDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.shipper = _data["shipper"];
            this.plannedDate = _data["plannedDate"];
            this.partNumber = _data["partNumber"];
            this.serialNumber = _data["serialNumber"];
            this.packageWeight = _data["packageWeight"];
            this.packageWidth = _data["packageWidth"];
            this.packageHeight = _data["packageHeight"];
            this.packageLength = _data["packageLength"];
            this.packageCount = _data["packageCount"];
            this.packageType = _data["packageType"];
            this.clearanceStatus = _data["clearanceStatus"];
            this.clearanceComment = _data["clearanceComment"];
            this.certificate = _data["certificate"];
        }
    }

    static override fromJS(data: any): ComatDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComatDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["shipper"] = this.shipper;
        data["plannedDate"] = this.plannedDate;
        data["partNumber"] = this.partNumber;
        data["serialNumber"] = this.serialNumber;
        data["packageWeight"] = this.packageWeight;
        data["packageWidth"] = this.packageWidth;
        data["packageHeight"] = this.packageHeight;
        data["packageLength"] = this.packageLength;
        data["packageCount"] = this.packageCount;
        data["packageType"] = this.packageType;
        data["clearanceStatus"] = this.clearanceStatus;
        data["clearanceComment"] = this.clearanceComment;
        data["certificate"] = this.certificate;
        super.toJSON(data);
        return data;
    }
}

export interface IComatDto extends ISpecialOccurrenceDto {
    origin?: string | undefined;
    destination?: string | undefined;
    shipper?: string | undefined;
    plannedDate?: string | undefined;
    partNumber?: string | undefined;
    serialNumber?: string | undefined;
    packageWeight?: number;
    packageWidth?: number;
    packageHeight?: number;
    packageLength?: number;
    packageCount?: number;
    packageType?: string | undefined;
    clearanceStatus?: string | undefined;
    clearanceComment?: string | undefined;
    certificate?: string | undefined;
}

export class DiversionDto extends SpecialOccurrenceDto implements IDiversionDto {
    aircraft?: string | undefined;
    airportOriginal?: string | undefined;
    airportDiversion?: string | undefined;
    diversionReason?: string | undefined;
    diversionReasonRemarks?: string | undefined;
    diversionReasonComment?: string | undefined;
    diversionStart?: string | undefined;
    diversionEndEstimated?: string | undefined;
    generalRemarks?: string | undefined;

    constructor(data?: IDiversionDto) {
        super(data);
        this._discriminator = "DiversionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.aircraft = _data["aircraft"];
            this.airportOriginal = _data["airportOriginal"];
            this.airportDiversion = _data["airportDiversion"];
            this.diversionReason = _data["diversionReason"];
            this.diversionReasonRemarks = _data["diversionReasonRemarks"];
            this.diversionReasonComment = _data["diversionReasonComment"];
            this.diversionStart = _data["diversionStart"];
            this.diversionEndEstimated = _data["diversionEndEstimated"];
            this.generalRemarks = _data["generalRemarks"];
        }
    }

    static override fromJS(data: any): DiversionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiversionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aircraft"] = this.aircraft;
        data["airportOriginal"] = this.airportOriginal;
        data["airportDiversion"] = this.airportDiversion;
        data["diversionReason"] = this.diversionReason;
        data["diversionReasonRemarks"] = this.diversionReasonRemarks;
        data["diversionReasonComment"] = this.diversionReasonComment;
        data["diversionStart"] = this.diversionStart;
        data["diversionEndEstimated"] = this.diversionEndEstimated;
        data["generalRemarks"] = this.generalRemarks;
        super.toJSON(data);
        return data;
    }
}

export interface IDiversionDto extends ISpecialOccurrenceDto {
    aircraft?: string | undefined;
    airportOriginal?: string | undefined;
    airportDiversion?: string | undefined;
    diversionReason?: string | undefined;
    diversionReasonRemarks?: string | undefined;
    diversionReasonComment?: string | undefined;
    diversionStart?: string | undefined;
    diversionEndEstimated?: string | undefined;
    generalRemarks?: string | undefined;
}

export class PartOverviewViewDto implements IPartOverviewViewDto {
    id?: string;
    description?: string | undefined;
    pn?: string | undefined;
    ipc?: string | undefined;
    altPn?: string | undefined;
    altIpc?: string | undefined;
    altPartsChecked?: boolean;
    quantityRequested?: number;
    remark?: string | undefined;
    requestStatus?: RequestStatusViewDto[] | undefined;
    orderStatus?: OrderStatusViewDto[] | undefined;
    shipmentStatus?: ShipmentStatusViewDto[] | undefined;
    minAvailable?: string | undefined;
    minEstimated?: string | undefined;
    minActual?: string | undefined;

    constructor(data?: IPartOverviewViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.pn = _data["pn"];
            this.ipc = _data["ipc"];
            this.altPn = _data["altPn"];
            this.altIpc = _data["altIpc"];
            this.altPartsChecked = _data["altPartsChecked"];
            this.quantityRequested = _data["quantityRequested"];
            this.remark = _data["remark"];
            if (Array.isArray(_data["requestStatus"])) {
                this.requestStatus = [] as any;
                for (let item of _data["requestStatus"])
                    this.requestStatus!.push(RequestStatusViewDto.fromJS(item));
            }
            if (Array.isArray(_data["orderStatus"])) {
                this.orderStatus = [] as any;
                for (let item of _data["orderStatus"])
                    this.orderStatus!.push(OrderStatusViewDto.fromJS(item));
            }
            if (Array.isArray(_data["shipmentStatus"])) {
                this.shipmentStatus = [] as any;
                for (let item of _data["shipmentStatus"])
                    this.shipmentStatus!.push(ShipmentStatusViewDto.fromJS(item));
            }
            this.minAvailable = _data["minAvailable"];
            this.minEstimated = _data["minEstimated"];
            this.minActual = _data["minActual"];
        }
    }

    static fromJS(data: any): PartOverviewViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartOverviewViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["pn"] = this.pn;
        data["ipc"] = this.ipc;
        data["altPn"] = this.altPn;
        data["altIpc"] = this.altIpc;
        data["altPartsChecked"] = this.altPartsChecked;
        data["quantityRequested"] = this.quantityRequested;
        data["remark"] = this.remark;
        if (Array.isArray(this.requestStatus)) {
            data["requestStatus"] = [];
            for (let item of this.requestStatus)
                data["requestStatus"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.orderStatus)) {
            data["orderStatus"] = [];
            for (let item of this.orderStatus)
                data["orderStatus"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.shipmentStatus)) {
            data["shipmentStatus"] = [];
            for (let item of this.shipmentStatus)
                data["shipmentStatus"].push(item ? item.toJSON() : undefined as any);
        }
        data["minAvailable"] = this.minAvailable;
        data["minEstimated"] = this.minEstimated;
        data["minActual"] = this.minActual;
        return data;
    }
}

export interface IPartOverviewViewDto {
    id?: string;
    description?: string | undefined;
    pn?: string | undefined;
    ipc?: string | undefined;
    altPn?: string | undefined;
    altIpc?: string | undefined;
    altPartsChecked?: boolean;
    quantityRequested?: number;
    remark?: string | undefined;
    requestStatus?: RequestStatusViewDto[] | undefined;
    orderStatus?: OrderStatusViewDto[] | undefined;
    shipmentStatus?: ShipmentStatusViewDto[] | undefined;
    minAvailable?: string | undefined;
    minEstimated?: string | undefined;
    minActual?: string | undefined;
}

export class RequestStatusViewDto implements IRequestStatusViewDto {
    count?: number;
    requestStatus?: RequestStatus | undefined;

    constructor(data?: IRequestStatusViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.requestStatus = _data["requestStatus"] ? RequestStatus.fromJS(_data["requestStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): RequestStatusViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestStatusViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["requestStatus"] = this.requestStatus ? this.requestStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IRequestStatusViewDto {
    count?: number;
    requestStatus?: RequestStatus | undefined;
}

export class Entity implements IEntity {
    guid?: string;
    createdDate?: string;
    updatedDate?: string | undefined;

    constructor(data?: IEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.createdDate = _data["createdDate"];
            this.updatedDate = _data["updatedDate"];
        }
    }

    static fromJS(data: any): Entity {
        data = typeof data === 'object' ? data : {};
        let result = new Entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["createdDate"] = this.createdDate;
        data["updatedDate"] = this.updatedDate;
        return data;
    }
}

export interface IEntity {
    guid?: string;
    createdDate?: string;
    updatedDate?: string | undefined;
}

export abstract class MaterialRequestStatus extends Entity implements IMaterialRequestStatus {
    name?: string | undefined;
    cssClass?: string | undefined;
    sortOrder?: number;
    sortOrderDisplay?: number;
    isSelectable?: boolean;

    constructor(data?: IMaterialRequestStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.cssClass = _data["cssClass"];
            this.sortOrder = _data["sortOrder"];
            this.sortOrderDisplay = _data["sortOrderDisplay"];
            this.isSelectable = _data["isSelectable"];
        }
    }

    static override fromJS(data: any): MaterialRequestStatus {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MaterialRequestStatus' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cssClass"] = this.cssClass;
        data["sortOrder"] = this.sortOrder;
        data["sortOrderDisplay"] = this.sortOrderDisplay;
        data["isSelectable"] = this.isSelectable;
        super.toJSON(data);
        return data;
    }
}

export interface IMaterialRequestStatus extends IEntity {
    name?: string | undefined;
    cssClass?: string | undefined;
    sortOrder?: number;
    sortOrderDisplay?: number;
    isSelectable?: boolean;
}

export class RequestStatus extends MaterialRequestStatus implements IRequestStatus {
    requestStatusEnum?: RequestStatusEnum;

    constructor(data?: IRequestStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestStatusEnum = _data["requestStatusEnum"];
        }
    }

    static override fromJS(data: any): RequestStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RequestStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestStatusEnum"] = this.requestStatusEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IRequestStatus extends IMaterialRequestStatus {
    requestStatusEnum?: RequestStatusEnum;
}

export enum RequestStatusEnum {
    NotRequested = "NotRequested",
    Requested = "Requested",
    NotAvailable = "NotAvailable",
    Available = "Available",
    ExternallyOrdered = "ExternallyOrdered",
}

export class OrderStatusViewDto implements IOrderStatusViewDto {
    count?: number;
    orderStatus?: OrderStatus | undefined;

    constructor(data?: IOrderStatusViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.orderStatus = _data["orderStatus"] ? OrderStatus.fromJS(_data["orderStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrderStatusViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrderStatusViewDto {
    count?: number;
    orderStatus?: OrderStatus | undefined;
}

export class OrderStatus extends MaterialRequestStatus implements IOrderStatus {
    orderStatusEnum?: OrderStatusEnum;

    constructor(data?: IOrderStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderStatusEnum = _data["orderStatusEnum"];
        }
    }

    static override fromJS(data: any): OrderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderStatusEnum"] = this.orderStatusEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderStatus extends IMaterialRequestStatus {
    orderStatusEnum?: OrderStatusEnum;
}

export enum OrderStatusEnum {
    NotOrdered = "NotOrdered",
    Ordered = "Ordered",
    ExternallyOrdered = "ExternallyOrdered",
}

export class ShipmentStatusViewDto implements IShipmentStatusViewDto {
    count?: number;
    shipmentStatus?: ShipmentStatus | undefined;

    constructor(data?: IShipmentStatusViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.shipmentStatus = _data["shipmentStatus"] ? ShipmentStatus.fromJS(_data["shipmentStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): ShipmentStatusViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentStatusViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["shipmentStatus"] = this.shipmentStatus ? this.shipmentStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IShipmentStatusViewDto {
    count?: number;
    shipmentStatus?: ShipmentStatus | undefined;
}

export class ShipmentStatus extends MaterialRequestStatus implements IShipmentStatus {
    shipmentStatusEnum?: ShipmentStatusEnum;

    constructor(data?: IShipmentStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shipmentStatusEnum = _data["shipmentStatusEnum"];
        }
    }

    static override fromJS(data: any): ShipmentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentStatusEnum"] = this.shipmentStatusEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IShipmentStatus extends IMaterialRequestStatus {
    shipmentStatusEnum?: ShipmentStatusEnum;
}

export enum ShipmentStatusEnum {
    NotShipped = "NotShipped",
    Pending = "Pending",
    Shipped = "Shipped",
    Arrived = "Arrived",
    ExternallyOrdered = "ExternallyOrdered",
}

export class PartDto implements IPartDto {
    id?: string;
    materialRequestId?: string;
    description?: string | undefined;
    pn?: string | undefined;
    ipc?: string | undefined;
    altPn?: string | undefined;
    altIpc?: string | undefined;
    altPartsChecked?: boolean;
    quantityRequested?: number;
    remark?: string | undefined;
    isExternallyOrdered?: boolean;
    isReadonly?: boolean;

    constructor(data?: IPartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialRequestId = _data["materialRequestId"];
            this.description = _data["description"];
            this.pn = _data["pn"];
            this.ipc = _data["ipc"];
            this.altPn = _data["altPn"];
            this.altIpc = _data["altIpc"];
            this.altPartsChecked = _data["altPartsChecked"];
            this.quantityRequested = _data["quantityRequested"];
            this.remark = _data["remark"];
            this.isExternallyOrdered = _data["isExternallyOrdered"];
            this.isReadonly = _data["isReadonly"];
        }
    }

    static fromJS(data: any): PartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialRequestId"] = this.materialRequestId;
        data["description"] = this.description;
        data["pn"] = this.pn;
        data["ipc"] = this.ipc;
        data["altPn"] = this.altPn;
        data["altIpc"] = this.altIpc;
        data["altPartsChecked"] = this.altPartsChecked;
        data["quantityRequested"] = this.quantityRequested;
        data["remark"] = this.remark;
        data["isExternallyOrdered"] = this.isExternallyOrdered;
        data["isReadonly"] = this.isReadonly;
        return data;
    }
}

export interface IPartDto {
    id?: string;
    materialRequestId?: string;
    description?: string | undefined;
    pn?: string | undefined;
    ipc?: string | undefined;
    altPn?: string | undefined;
    altIpc?: string | undefined;
    altPartsChecked?: boolean;
    quantityRequested?: number;
    remark?: string | undefined;
    isExternallyOrdered?: boolean;
    isReadonly?: boolean;
}

export class VendorRequestDto implements IVendorRequestDto {
    id?: string;
    vendor?: VendorDto | undefined;
    parts?: VendorRequestPartViewDto[] | undefined;
    requestEmailSentAt?: string | undefined;
    availableShippers?: AvailableShipperDto[] | undefined;
    canMarkAsNoPartsAvailable?: boolean;
    remarks?: string | undefined;

    constructor(data?: IVendorRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : undefined as any;
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(VendorRequestPartViewDto.fromJS(item));
            }
            this.requestEmailSentAt = _data["requestEmailSentAt"];
            if (Array.isArray(_data["availableShippers"])) {
                this.availableShippers = [] as any;
                for (let item of _data["availableShippers"])
                    this.availableShippers!.push(AvailableShipperDto.fromJS(item));
            }
            this.canMarkAsNoPartsAvailable = _data["canMarkAsNoPartsAvailable"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): VendorRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : undefined as any;
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item ? item.toJSON() : undefined as any);
        }
        data["requestEmailSentAt"] = this.requestEmailSentAt;
        if (Array.isArray(this.availableShippers)) {
            data["availableShippers"] = [];
            for (let item of this.availableShippers)
                data["availableShippers"].push(item ? item.toJSON() : undefined as any);
        }
        data["canMarkAsNoPartsAvailable"] = this.canMarkAsNoPartsAvailable;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IVendorRequestDto {
    id?: string;
    vendor?: VendorDto | undefined;
    parts?: VendorRequestPartViewDto[] | undefined;
    requestEmailSentAt?: string | undefined;
    availableShippers?: AvailableShipperDto[] | undefined;
    canMarkAsNoPartsAvailable?: boolean;
    remarks?: string | undefined;
}

export class VendorDto implements IVendorDto {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    code?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    latitude?: number;
    longitude?: number;
    distance?: number;
    location?: string | undefined;
    vendorContacts?: VendorContactDto[] | undefined;
    isExternallyOrderedVendor?: boolean;
    isFavorite?: boolean;
    isAmosVendor?: boolean;

    constructor(data?: IVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.distance = _data["distance"];
            this.location = _data["location"];
            if (Array.isArray(_data["vendorContacts"])) {
                this.vendorContacts = [] as any;
                for (let item of _data["vendorContacts"])
                    this.vendorContacts!.push(VendorContactDto.fromJS(item));
            }
            this.isExternallyOrderedVendor = _data["isExternallyOrderedVendor"];
            this.isFavorite = _data["isFavorite"];
            this.isAmosVendor = _data["isAmosVendor"];
        }
    }

    static fromJS(data: any): VendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["code"] = this.code;
        data["address"] = this.address;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["distance"] = this.distance;
        data["location"] = this.location;
        if (Array.isArray(this.vendorContacts)) {
            data["vendorContacts"] = [];
            for (let item of this.vendorContacts)
                data["vendorContacts"].push(item ? item.toJSON() : undefined as any);
        }
        data["isExternallyOrderedVendor"] = this.isExternallyOrderedVendor;
        data["isFavorite"] = this.isFavorite;
        data["isAmosVendor"] = this.isAmosVendor;
        return data;
    }
}

export interface IVendorDto {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    code?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    latitude?: number;
    longitude?: number;
    distance?: number;
    location?: string | undefined;
    vendorContacts?: VendorContactDto[] | undefined;
    isExternallyOrderedVendor?: boolean;
    isFavorite?: boolean;
    isAmosVendor?: boolean;
}

export class VendorContactDto implements IVendorContactDto {
    id?: string;
    contactType?: string | undefined;
    contact?: string | undefined;
    isPrimary?: boolean;

    constructor(data?: IVendorContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactType = _data["contactType"];
            this.contact = _data["contact"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): VendorContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactType"] = this.contactType;
        data["contact"] = this.contact;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IVendorContactDto {
    id?: string;
    contactType?: string | undefined;
    contact?: string | undefined;
    isPrimary?: boolean;
}

export class VendorRequestPartViewDto implements IVendorRequestPartViewDto {
    id?: string;
    part?: PartDto | undefined;
    quantityRequested?: number;
    quantityAvailable?: number | undefined;
    quantityOrdered?: number | undefined;
    pricePerUnit?: number | undefined;
    currency?: string | undefined;
    location?: string | undefined;
    amosOrderNo?: string | undefined;
    packageLength?: number;
    packageWidth?: number;
    packageHeight?: number;
    packageWeight?: number;
    requestStatus?: RequestStatusDto | undefined;
    orderStatus?: OrderStatusDto | undefined;
    shipmentStatus?: ShipmentStatusDto | undefined;
    dateAvailable?: string | undefined;
    dateRequested?: string | undefined;
    shipmentRequestedAt?: string | undefined;
    estimatedTimeOfArrival?: string | undefined;
    actualTimeOfArrival?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IVendorRequestPartViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.part = _data["part"] ? PartDto.fromJS(_data["part"]) : undefined as any;
            this.quantityRequested = _data["quantityRequested"];
            this.quantityAvailable = _data["quantityAvailable"];
            this.quantityOrdered = _data["quantityOrdered"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.currency = _data["currency"];
            this.location = _data["location"];
            this.amosOrderNo = _data["amosOrderNo"];
            this.packageLength = _data["packageLength"];
            this.packageWidth = _data["packageWidth"];
            this.packageHeight = _data["packageHeight"];
            this.packageWeight = _data["packageWeight"];
            this.requestStatus = _data["requestStatus"] ? RequestStatusDto.fromJS(_data["requestStatus"]) : undefined as any;
            this.orderStatus = _data["orderStatus"] ? OrderStatusDto.fromJS(_data["orderStatus"]) : undefined as any;
            this.shipmentStatus = _data["shipmentStatus"] ? ShipmentStatusDto.fromJS(_data["shipmentStatus"]) : undefined as any;
            this.dateAvailable = _data["dateAvailable"];
            this.dateRequested = _data["dateRequested"];
            this.shipmentRequestedAt = _data["shipmentRequestedAt"];
            this.estimatedTimeOfArrival = _data["estimatedTimeOfArrival"];
            this.actualTimeOfArrival = _data["actualTimeOfArrival"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): VendorRequestPartViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorRequestPartViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["part"] = this.part ? this.part.toJSON() : undefined as any;
        data["quantityRequested"] = this.quantityRequested;
        data["quantityAvailable"] = this.quantityAvailable;
        data["quantityOrdered"] = this.quantityOrdered;
        data["pricePerUnit"] = this.pricePerUnit;
        data["currency"] = this.currency;
        data["location"] = this.location;
        data["amosOrderNo"] = this.amosOrderNo;
        data["packageLength"] = this.packageLength;
        data["packageWidth"] = this.packageWidth;
        data["packageHeight"] = this.packageHeight;
        data["packageWeight"] = this.packageWeight;
        data["requestStatus"] = this.requestStatus ? this.requestStatus.toJSON() : undefined as any;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : undefined as any;
        data["shipmentStatus"] = this.shipmentStatus ? this.shipmentStatus.toJSON() : undefined as any;
        data["dateAvailable"] = this.dateAvailable;
        data["dateRequested"] = this.dateRequested;
        data["shipmentRequestedAt"] = this.shipmentRequestedAt;
        data["estimatedTimeOfArrival"] = this.estimatedTimeOfArrival;
        data["actualTimeOfArrival"] = this.actualTimeOfArrival;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IVendorRequestPartViewDto {
    id?: string;
    part?: PartDto | undefined;
    quantityRequested?: number;
    quantityAvailable?: number | undefined;
    quantityOrdered?: number | undefined;
    pricePerUnit?: number | undefined;
    currency?: string | undefined;
    location?: string | undefined;
    amosOrderNo?: string | undefined;
    packageLength?: number;
    packageWidth?: number;
    packageHeight?: number;
    packageWeight?: number;
    requestStatus?: RequestStatusDto | undefined;
    orderStatus?: OrderStatusDto | undefined;
    shipmentStatus?: ShipmentStatusDto | undefined;
    dateAvailable?: string | undefined;
    dateRequested?: string | undefined;
    shipmentRequestedAt?: string | undefined;
    estimatedTimeOfArrival?: string | undefined;
    actualTimeOfArrival?: string | undefined;
    comment?: string | undefined;
}

export abstract class MaterialRequestStatusDto implements IMaterialRequestStatusDto {
    id?: string;
    name?: string | undefined;
    cssClass?: string | undefined;
    sortOrder?: number;
    isSelectable?: boolean;

    constructor(data?: IMaterialRequestStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cssClass = _data["cssClass"];
            this.sortOrder = _data["sortOrder"];
            this.isSelectable = _data["isSelectable"];
        }
    }

    static fromJS(data: any): MaterialRequestStatusDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MaterialRequestStatusDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cssClass"] = this.cssClass;
        data["sortOrder"] = this.sortOrder;
        data["isSelectable"] = this.isSelectable;
        return data;
    }
}

export interface IMaterialRequestStatusDto {
    id?: string;
    name?: string | undefined;
    cssClass?: string | undefined;
    sortOrder?: number;
    isSelectable?: boolean;
}

export class RequestStatusDto extends MaterialRequestStatusDto implements IRequestStatusDto {
    requestStatusEnum?: RequestStatusEnum;

    constructor(data?: IRequestStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestStatusEnum = _data["requestStatusEnum"];
        }
    }

    static override fromJS(data: any): RequestStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestStatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestStatusEnum"] = this.requestStatusEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IRequestStatusDto extends IMaterialRequestStatusDto {
    requestStatusEnum?: RequestStatusEnum;
}

export class OrderStatusDto extends MaterialRequestStatusDto implements IOrderStatusDto {
    orderStatusEnum?: OrderStatusEnum;

    constructor(data?: IOrderStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderStatusEnum = _data["orderStatusEnum"];
        }
    }

    static override fromJS(data: any): OrderStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderStatusEnum"] = this.orderStatusEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderStatusDto extends IMaterialRequestStatusDto {
    orderStatusEnum?: OrderStatusEnum;
}

export class ShipmentStatusDto extends MaterialRequestStatusDto implements IShipmentStatusDto {
    shipmentStatusEnum?: ShipmentStatusEnum;

    constructor(data?: IShipmentStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shipmentStatusEnum = _data["shipmentStatusEnum"];
        }
    }

    static override fromJS(data: any): ShipmentStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentStatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentStatusEnum"] = this.shipmentStatusEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IShipmentStatusDto extends IMaterialRequestStatusDto {
    shipmentStatusEnum?: ShipmentStatusEnum;
}

export class AvailableShipperDto implements IAvailableShipperDto {
    shipperId?: string;
    shipperName?: string | undefined;
    numberOfParts?: number;

    constructor(data?: IAvailableShipperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipperId = _data["shipperId"];
            this.shipperName = _data["shipperName"];
            this.numberOfParts = _data["numberOfParts"];
        }
    }

    static fromJS(data: any): AvailableShipperDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableShipperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipperId"] = this.shipperId;
        data["shipperName"] = this.shipperName;
        data["numberOfParts"] = this.numberOfParts;
        return data;
    }
}

export interface IAvailableShipperDto {
    shipperId?: string;
    shipperName?: string | undefined;
    numberOfParts?: number;
}

export class AddMaterialRequestVendorDto implements IAddMaterialRequestVendorDto {
    materialRequestId?: string;
    name?: string | undefined;
    email?: string | undefined;
    partIds?: string[] | undefined;

    constructor(data?: IAddMaterialRequestVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialRequestId = _data["materialRequestId"];
            this.name = _data["name"];
            this.email = _data["email"];
            if (Array.isArray(_data["partIds"])) {
                this.partIds = [] as any;
                for (let item of _data["partIds"])
                    this.partIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddMaterialRequestVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddMaterialRequestVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialRequestId"] = this.materialRequestId;
        data["name"] = this.name;
        data["email"] = this.email;
        if (Array.isArray(this.partIds)) {
            data["partIds"] = [];
            for (let item of this.partIds)
                data["partIds"].push(item);
        }
        return data;
    }
}

export interface IAddMaterialRequestVendorDto {
    materialRequestId?: string;
    name?: string | undefined;
    email?: string | undefined;
    partIds?: string[] | undefined;
}

export class ServiceResultOfMaterialRequestSettingsDto extends ServiceResult implements IServiceResultOfMaterialRequestSettingsDto {
    entity?: MaterialRequestSettingsDto | undefined;

    constructor(data?: IServiceResultOfMaterialRequestSettingsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? MaterialRequestSettingsDto.fromJS(_data["entity"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ServiceResultOfMaterialRequestSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfMaterialRequestSettingsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfMaterialRequestSettingsDto extends IServiceResult {
    entity?: MaterialRequestSettingsDto | undefined;
}

export class MaterialRequestSettingsDto implements IMaterialRequestSettingsDto {
    id?: string;
    materialRequestCc?: string | undefined;
    materialRequestBcc?: string | undefined;
    materialRequestManagementReportTo?: string | undefined;
    materialRequestManagementReportCc?: string | undefined;
    materialRequestLogisticsEmailCc?: string | undefined;
    materialRequestReplyTo?: string | undefined;
    materialRequestAogDeskNotificationEmailTo?: string | undefined;
    materialRequestAogDeskNotificationEmailCc?: string | undefined;
    autoManagementReportIntervalMinutes?: number;

    constructor(data?: IMaterialRequestSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialRequestCc = _data["materialRequestCc"];
            this.materialRequestBcc = _data["materialRequestBcc"];
            this.materialRequestManagementReportTo = _data["materialRequestManagementReportTo"];
            this.materialRequestManagementReportCc = _data["materialRequestManagementReportCc"];
            this.materialRequestLogisticsEmailCc = _data["materialRequestLogisticsEmailCc"];
            this.materialRequestReplyTo = _data["materialRequestReplyTo"];
            this.materialRequestAogDeskNotificationEmailTo = _data["materialRequestAogDeskNotificationEmailTo"];
            this.materialRequestAogDeskNotificationEmailCc = _data["materialRequestAogDeskNotificationEmailCc"];
            this.autoManagementReportIntervalMinutes = _data["autoManagementReportIntervalMinutes"];
        }
    }

    static fromJS(data: any): MaterialRequestSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialRequestSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialRequestCc"] = this.materialRequestCc;
        data["materialRequestBcc"] = this.materialRequestBcc;
        data["materialRequestManagementReportTo"] = this.materialRequestManagementReportTo;
        data["materialRequestManagementReportCc"] = this.materialRequestManagementReportCc;
        data["materialRequestLogisticsEmailCc"] = this.materialRequestLogisticsEmailCc;
        data["materialRequestReplyTo"] = this.materialRequestReplyTo;
        data["materialRequestAogDeskNotificationEmailTo"] = this.materialRequestAogDeskNotificationEmailTo;
        data["materialRequestAogDeskNotificationEmailCc"] = this.materialRequestAogDeskNotificationEmailCc;
        data["autoManagementReportIntervalMinutes"] = this.autoManagementReportIntervalMinutes;
        return data;
    }
}

export interface IMaterialRequestSettingsDto {
    id?: string;
    materialRequestCc?: string | undefined;
    materialRequestBcc?: string | undefined;
    materialRequestManagementReportTo?: string | undefined;
    materialRequestManagementReportCc?: string | undefined;
    materialRequestLogisticsEmailCc?: string | undefined;
    materialRequestReplyTo?: string | undefined;
    materialRequestAogDeskNotificationEmailTo?: string | undefined;
    materialRequestAogDeskNotificationEmailCc?: string | undefined;
    autoManagementReportIntervalMinutes?: number;
}

export class SelectMaterialRequestVendorDto implements ISelectMaterialRequestVendorDto {
    materialRequestId?: string;
    vendorIds?: string[] | undefined;
    partIds?: string[] | undefined;

    constructor(data?: ISelectMaterialRequestVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialRequestId = _data["materialRequestId"];
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            if (Array.isArray(_data["partIds"])) {
                this.partIds = [] as any;
                for (let item of _data["partIds"])
                    this.partIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SelectMaterialRequestVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectMaterialRequestVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialRequestId"] = this.materialRequestId;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (Array.isArray(this.partIds)) {
            data["partIds"] = [];
            for (let item of this.partIds)
                data["partIds"].push(item);
        }
        return data;
    }
}

export interface ISelectMaterialRequestVendorDto {
    materialRequestId?: string;
    vendorIds?: string[] | undefined;
    partIds?: string[] | undefined;
}

export class VendorRequestEditRemarksDto implements IVendorRequestEditRemarksDto {
    id?: string;
    remarks?: string | undefined;

    constructor(data?: IVendorRequestEditRemarksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): VendorRequestEditRemarksDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorRequestEditRemarksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IVendorRequestEditRemarksDto {
    id?: string;
    remarks?: string | undefined;
}

export class VendorRequestPartEditDto implements IVendorRequestPartEditDto {
    id?: string;
    part?: PartDto | undefined;
    vendorName?: string | undefined;
    quantityRequested?: number;
    quantityAvailable?: number | undefined;
    pricePerUnit?: number | undefined;
    currency?: string | undefined;
    location?: string | undefined;
    requestStatusId?: string | undefined;
    dateAvailable?: string | undefined;

    constructor(data?: IVendorRequestPartEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.part = _data["part"] ? PartDto.fromJS(_data["part"]) : undefined as any;
            this.vendorName = _data["vendorName"];
            this.quantityRequested = _data["quantityRequested"];
            this.quantityAvailable = _data["quantityAvailable"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.currency = _data["currency"];
            this.location = _data["location"];
            this.requestStatusId = _data["requestStatusId"];
            this.dateAvailable = _data["dateAvailable"];
        }
    }

    static fromJS(data: any): VendorRequestPartEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorRequestPartEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["part"] = this.part ? this.part.toJSON() : undefined as any;
        data["vendorName"] = this.vendorName;
        data["quantityRequested"] = this.quantityRequested;
        data["quantityAvailable"] = this.quantityAvailable;
        data["pricePerUnit"] = this.pricePerUnit;
        data["currency"] = this.currency;
        data["location"] = this.location;
        data["requestStatusId"] = this.requestStatusId;
        data["dateAvailable"] = this.dateAvailable;
        return data;
    }
}

export interface IVendorRequestPartEditDto {
    id?: string;
    part?: PartDto | undefined;
    vendorName?: string | undefined;
    quantityRequested?: number;
    quantityAvailable?: number | undefined;
    pricePerUnit?: number | undefined;
    currency?: string | undefined;
    location?: string | undefined;
    requestStatusId?: string | undefined;
    dateAvailable?: string | undefined;
}

export class VendorRequestPartOrderEditDto implements IVendorRequestPartOrderEditDto {
    id?: string;
    part?: PartDto | undefined;
    vendorName?: string | undefined;
    quantityRequested?: number;
    quantityAvailable?: number | undefined;
    pricePerUnit?: number | undefined;
    currency?: string | undefined;
    location?: string | undefined;
    quantityOrdered?: number | undefined;
    amosOrderNo?: string | undefined;
    orderStatusId?: string | undefined;
    shipmentStatusId?: string | undefined;
    shipperId?: string | undefined;
    shipperFreetext?: string | undefined;
    estimatedTimeOfArrival?: string | undefined;
    actualTimeOfArrival?: string | undefined;
    remarks?: string | undefined;
    shipperPopupConfirmationTlc?: string | undefined;
    packageLength?: number;
    packageWidth?: number;
    packageHeight?: number;
    packageWeight?: number;

    constructor(data?: IVendorRequestPartOrderEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.part = _data["part"] ? PartDto.fromJS(_data["part"]) : undefined as any;
            this.vendorName = _data["vendorName"];
            this.quantityRequested = _data["quantityRequested"];
            this.quantityAvailable = _data["quantityAvailable"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.currency = _data["currency"];
            this.location = _data["location"];
            this.quantityOrdered = _data["quantityOrdered"];
            this.amosOrderNo = _data["amosOrderNo"];
            this.orderStatusId = _data["orderStatusId"];
            this.shipmentStatusId = _data["shipmentStatusId"];
            this.shipperId = _data["shipperId"];
            this.shipperFreetext = _data["shipperFreetext"];
            this.estimatedTimeOfArrival = _data["estimatedTimeOfArrival"];
            this.actualTimeOfArrival = _data["actualTimeOfArrival"];
            this.remarks = _data["remarks"];
            this.shipperPopupConfirmationTlc = _data["shipperPopupConfirmationTlc"];
            this.packageLength = _data["packageLength"];
            this.packageWidth = _data["packageWidth"];
            this.packageHeight = _data["packageHeight"];
            this.packageWeight = _data["packageWeight"];
        }
    }

    static fromJS(data: any): VendorRequestPartOrderEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorRequestPartOrderEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["part"] = this.part ? this.part.toJSON() : undefined as any;
        data["vendorName"] = this.vendorName;
        data["quantityRequested"] = this.quantityRequested;
        data["quantityAvailable"] = this.quantityAvailable;
        data["pricePerUnit"] = this.pricePerUnit;
        data["currency"] = this.currency;
        data["location"] = this.location;
        data["quantityOrdered"] = this.quantityOrdered;
        data["amosOrderNo"] = this.amosOrderNo;
        data["orderStatusId"] = this.orderStatusId;
        data["shipmentStatusId"] = this.shipmentStatusId;
        data["shipperId"] = this.shipperId;
        data["shipperFreetext"] = this.shipperFreetext;
        data["estimatedTimeOfArrival"] = this.estimatedTimeOfArrival;
        data["actualTimeOfArrival"] = this.actualTimeOfArrival;
        data["remarks"] = this.remarks;
        data["shipperPopupConfirmationTlc"] = this.shipperPopupConfirmationTlc;
        data["packageLength"] = this.packageLength;
        data["packageWidth"] = this.packageWidth;
        data["packageHeight"] = this.packageHeight;
        data["packageWeight"] = this.packageWeight;
        return data;
    }
}

export interface IVendorRequestPartOrderEditDto {
    id?: string;
    part?: PartDto | undefined;
    vendorName?: string | undefined;
    quantityRequested?: number;
    quantityAvailable?: number | undefined;
    pricePerUnit?: number | undefined;
    currency?: string | undefined;
    location?: string | undefined;
    quantityOrdered?: number | undefined;
    amosOrderNo?: string | undefined;
    orderStatusId?: string | undefined;
    shipmentStatusId?: string | undefined;
    shipperId?: string | undefined;
    shipperFreetext?: string | undefined;
    estimatedTimeOfArrival?: string | undefined;
    actualTimeOfArrival?: string | undefined;
    remarks?: string | undefined;
    shipperPopupConfirmationTlc?: string | undefined;
    packageLength?: number;
    packageWidth?: number;
    packageHeight?: number;
    packageWeight?: number;
}

export class ShipperDto implements IShipperDto {
    id?: string;
    name?: string | undefined;
    popupText?: string | undefined;
    isOther?: boolean;

    constructor(data?: IShipperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.popupText = _data["popupText"];
            this.isOther = _data["isOther"];
        }
    }

    static fromJS(data: any): ShipperDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["popupText"] = this.popupText;
        data["isOther"] = this.isOther;
        return data;
    }
}

export interface IShipperDto {
    id?: string;
    name?: string | undefined;
    popupText?: string | undefined;
    isOther?: boolean;
}

export class SendVendorRequestDto implements ISendVendorRequestDto {
    vendorRequestId?: string;
    emailText?: string | undefined;

    constructor(data?: ISendVendorRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorRequestId = _data["vendorRequestId"];
            this.emailText = _data["emailText"];
        }
    }

    static fromJS(data: any): SendVendorRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVendorRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorRequestId"] = this.vendorRequestId;
        data["emailText"] = this.emailText;
        return data;
    }
}

export interface ISendVendorRequestDto {
    vendorRequestId?: string;
    emailText?: string | undefined;
}

export class SendLogisticsEmailDto implements ISendLogisticsEmailDto {
    vendorRequestId?: string;
    shipperId?: string;

    constructor(data?: ISendLogisticsEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorRequestId = _data["vendorRequestId"];
            this.shipperId = _data["shipperId"];
        }
    }

    static fromJS(data: any): SendLogisticsEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendLogisticsEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorRequestId"] = this.vendorRequestId;
        data["shipperId"] = this.shipperId;
        return data;
    }
}

export interface ISendLogisticsEmailDto {
    vendorRequestId?: string;
    shipperId?: string;
}

export class MaterialRequestReportResponse implements IMaterialRequestReportResponse {
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IMaterialRequestReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MaterialRequestReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialRequestReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IMaterialRequestReportResponse {
    isSuccess?: boolean;
    message?: string | undefined;
}

export class ServiceResultOfManagementReportInfoDto extends ServiceResult implements IServiceResultOfManagementReportInfoDto {
    entity?: ManagementReportInfoDto | undefined;

    constructor(data?: IServiceResultOfManagementReportInfoDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? ManagementReportInfoDto.fromJS(_data["entity"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ServiceResultOfManagementReportInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfManagementReportInfoDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfManagementReportInfoDto extends IServiceResult {
    entity?: ManagementReportInfoDto | undefined;
}

export class ManagementReportInfoDto implements IManagementReportInfoDto {
    materialRequestId?: string;
    lastSentDate?: string | undefined;
    nextSendDate?: string | undefined;

    constructor(data?: IManagementReportInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialRequestId = _data["materialRequestId"];
            this.lastSentDate = _data["lastSentDate"];
            this.nextSendDate = _data["nextSendDate"];
        }
    }

    static fromJS(data: any): ManagementReportInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagementReportInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialRequestId"] = this.materialRequestId;
        data["lastSentDate"] = this.lastSentDate;
        data["nextSendDate"] = this.nextSendDate;
        return data;
    }
}

export interface IManagementReportInfoDto {
    materialRequestId?: string;
    lastSentDate?: string | undefined;
    nextSendDate?: string | undefined;
}

export class ManagementReportPostponeDto implements IManagementReportPostponeDto {
    materialRequestId?: string;
    postponeHours?: number;

    constructor(data?: IManagementReportPostponeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialRequestId = _data["materialRequestId"];
            this.postponeHours = _data["postponeHours"];
        }
    }

    static fromJS(data: any): ManagementReportPostponeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagementReportPostponeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialRequestId"] = this.materialRequestId;
        data["postponeHours"] = this.postponeHours;
        return data;
    }
}

export interface IManagementReportPostponeDto {
    materialRequestId?: string;
    postponeHours?: number;
}

export class NodeStatusDto implements INodeStatusDto {
    nodeId?: string | undefined;
    isAllowed?: boolean;
    isLeader?: boolean;

    constructor(data?: INodeStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeId = _data["nodeId"];
            this.isAllowed = _data["isAllowed"];
            this.isLeader = _data["isLeader"];
        }
    }

    static fromJS(data: any): NodeStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new NodeStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        data["isAllowed"] = this.isAllowed;
        data["isLeader"] = this.isLeader;
        return data;
    }
}

export interface INodeStatusDto {
    nodeId?: string | undefined;
    isAllowed?: boolean;
    isLeader?: boolean;
}

export class ShiftHandoverOverviewDto implements IShiftHandoverOverviewDto {
    id?: string;
    shiftId?: string | undefined;
    shift?: ShiftDto | undefined;
    shiftDateFrom?: string;
    shiftDateTo?: string;
    shiftSupervisor?: string | undefined;
    handoverDateTime?: string;
    comment?: string | undefined;
    relevantItemsCount?: number;
    sharedItemsCount?: number;
    boardItems?: ShiftHandoverBoardItemDto[] | undefined;
    boardItemsSummary?: BoardItemsSummary[] | undefined;

    constructor(data?: IShiftHandoverOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shiftId = _data["shiftId"];
            this.shift = _data["shift"] ? ShiftDto.fromJS(_data["shift"]) : undefined as any;
            this.shiftDateFrom = _data["shiftDateFrom"];
            this.shiftDateTo = _data["shiftDateTo"];
            this.shiftSupervisor = _data["shiftSupervisor"];
            this.handoverDateTime = _data["handoverDateTime"];
            this.comment = _data["comment"];
            this.relevantItemsCount = _data["relevantItemsCount"];
            this.sharedItemsCount = _data["sharedItemsCount"];
            if (Array.isArray(_data["boardItems"])) {
                this.boardItems = [] as any;
                for (let item of _data["boardItems"])
                    this.boardItems!.push(ShiftHandoverBoardItemDto.fromJS(item));
            }
            if (Array.isArray(_data["boardItemsSummary"])) {
                this.boardItemsSummary = [] as any;
                for (let item of _data["boardItemsSummary"])
                    this.boardItemsSummary!.push(BoardItemsSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftHandoverOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftHandoverOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shiftId"] = this.shiftId;
        data["shift"] = this.shift ? this.shift.toJSON() : undefined as any;
        data["shiftDateFrom"] = this.shiftDateFrom;
        data["shiftDateTo"] = this.shiftDateTo;
        data["shiftSupervisor"] = this.shiftSupervisor;
        data["handoverDateTime"] = this.handoverDateTime;
        data["comment"] = this.comment;
        data["relevantItemsCount"] = this.relevantItemsCount;
        data["sharedItemsCount"] = this.sharedItemsCount;
        if (Array.isArray(this.boardItems)) {
            data["boardItems"] = [];
            for (let item of this.boardItems)
                data["boardItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.boardItemsSummary)) {
            data["boardItemsSummary"] = [];
            for (let item of this.boardItemsSummary)
                data["boardItemsSummary"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShiftHandoverOverviewDto {
    id?: string;
    shiftId?: string | undefined;
    shift?: ShiftDto | undefined;
    shiftDateFrom?: string;
    shiftDateTo?: string;
    shiftSupervisor?: string | undefined;
    handoverDateTime?: string;
    comment?: string | undefined;
    relevantItemsCount?: number;
    sharedItemsCount?: number;
    boardItems?: ShiftHandoverBoardItemDto[] | undefined;
    boardItemsSummary?: BoardItemsSummary[] | undefined;
}

export class ShiftHandoverBoardItemDto implements IShiftHandoverBoardItemDto {
    boardItemId?: string;
    boardItem?: BoardItemDto | undefined;
    status?: BoardItemStatusDto;
    reportRelevant?: boolean;

    constructor(data?: IShiftHandoverBoardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardItemId = _data["boardItemId"];
            this.boardItem = _data["boardItem"] ? BoardItemDto.fromJS(_data["boardItem"]) : undefined as any;
            this.status = _data["status"];
            this.reportRelevant = _data["reportRelevant"];
        }
    }

    static fromJS(data: any): ShiftHandoverBoardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftHandoverBoardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardItemId"] = this.boardItemId;
        data["boardItem"] = this.boardItem ? this.boardItem.toJSON() : undefined as any;
        data["status"] = this.status;
        data["reportRelevant"] = this.reportRelevant;
        return data;
    }
}

export interface IShiftHandoverBoardItemDto {
    boardItemId?: string;
    boardItem?: BoardItemDto | undefined;
    status?: BoardItemStatusDto;
    reportRelevant?: boolean;
}

export class BoardItemsSummary implements IBoardItemsSummary {
    status?: BoardItemStatusDto;
    count?: number;

    constructor(data?: IBoardItemsSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): BoardItemsSummary {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemsSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["count"] = this.count;
        return data;
    }
}

export interface IBoardItemsSummary {
    status?: BoardItemStatusDto;
    count?: number;
}

export class SpecialOccurrenceOverviewDto implements ISpecialOccurrenceOverviewDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    type?: SpecialOccurrenceTypeDto;
    boardItemsSummary?: BoardItemsSummary[] | undefined;
    createdDate?: string;
    archivedDate?: string;

    constructor(data?: ISpecialOccurrenceOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            if (Array.isArray(_data["boardItemsSummary"])) {
                this.boardItemsSummary = [] as any;
                for (let item of _data["boardItemsSummary"])
                    this.boardItemsSummary!.push(BoardItemsSummary.fromJS(item));
            }
            this.createdDate = _data["createdDate"];
            this.archivedDate = _data["archivedDate"];
        }
    }

    static fromJS(data: any): SpecialOccurrenceOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        if (Array.isArray(this.boardItemsSummary)) {
            data["boardItemsSummary"] = [];
            for (let item of this.boardItemsSummary)
                data["boardItemsSummary"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdDate"] = this.createdDate;
        data["archivedDate"] = this.archivedDate;
        return data;
    }
}

export interface ISpecialOccurrenceOverviewDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    type?: SpecialOccurrenceTypeDto;
    boardItemsSummary?: BoardItemsSummary[] | undefined;
    createdDate?: string;
    archivedDate?: string;
}

export class GetLabelsStatisticQuery implements IGetLabelsStatisticQuery {
    boardId?: string;
    dateFrom?: string;
    dateTo?: string;
    useOnlyBoardSpecificLabels?: boolean;

    constructor(data?: IGetLabelsStatisticQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.useOnlyBoardSpecificLabels = _data["useOnlyBoardSpecificLabels"];
        }
    }

    static fromJS(data: any): GetLabelsStatisticQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLabelsStatisticQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["useOnlyBoardSpecificLabels"] = this.useOnlyBoardSpecificLabels;
        return data;
    }
}

export interface IGetLabelsStatisticQuery {
    boardId?: string;
    dateFrom?: string;
    dateTo?: string;
    useOnlyBoardSpecificLabels?: boolean;
}

export class GeneralLabelUsageInfo implements IGeneralLabelUsageInfo {
    labelId?: string;
    labelTitle?: string | undefined;
    labelColor?: string | undefined;
    usedCount?: number;

    constructor(data?: IGeneralLabelUsageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelId = _data["labelId"];
            this.labelTitle = _data["labelTitle"];
            this.labelColor = _data["labelColor"];
            this.usedCount = _data["usedCount"];
        }
    }

    static fromJS(data: any): GeneralLabelUsageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralLabelUsageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelId"] = this.labelId;
        data["labelTitle"] = this.labelTitle;
        data["labelColor"] = this.labelColor;
        data["usedCount"] = this.usedCount;
        return data;
    }
}

export interface IGeneralLabelUsageInfo {
    labelId?: string;
    labelTitle?: string | undefined;
    labelColor?: string | undefined;
    usedCount?: number;
}

export class LabelsOverTimeUsageApiDto implements ILabelsOverTimeUsageApiDto {
    columnDates?: string[] | undefined;
    labelsColors?: string[] | undefined;
    labels?: LabelOverTimeUsageApiDto[] | undefined;

    constructor(data?: ILabelsOverTimeUsageApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columnDates"])) {
                this.columnDates = [] as any;
                for (let item of _data["columnDates"])
                    this.columnDates!.push(item);
            }
            if (Array.isArray(_data["labelsColors"])) {
                this.labelsColors = [] as any;
                for (let item of _data["labelsColors"])
                    this.labelsColors!.push(item);
            }
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(LabelOverTimeUsageApiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LabelsOverTimeUsageApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabelsOverTimeUsageApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnDates)) {
            data["columnDates"] = [];
            for (let item of this.columnDates)
                data["columnDates"].push(item);
        }
        if (Array.isArray(this.labelsColors)) {
            data["labelsColors"] = [];
            for (let item of this.labelsColors)
                data["labelsColors"].push(item);
        }
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILabelsOverTimeUsageApiDto {
    columnDates?: string[] | undefined;
    labelsColors?: string[] | undefined;
    labels?: LabelOverTimeUsageApiDto[] | undefined;
}

export class LabelOverTimeUsageApiDto implements ILabelOverTimeUsageApiDto {
    name?: string | undefined;
    data?: number[] | undefined;

    constructor(data?: ILabelOverTimeUsageApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["Data"])) {
                this.data = [] as any;
                for (let item of _data["Data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): LabelOverTimeUsageApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabelOverTimeUsageApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.data)) {
            data["Data"] = [];
            for (let item of this.data)
                data["Data"].push(item);
        }
        return data;
    }
}

export interface ILabelOverTimeUsageApiDto {
    name?: string | undefined;
    data?: number[] | undefined;
}

export class InitialBoardSettingsDto implements IInitialBoardSettingsDto {
    id?: string;
    title?: string | undefined;
    enableShifts?: boolean;
    enableAutomaticStatusChangeOnShiftHandover?: boolean;

    constructor(data?: IInitialBoardSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.enableShifts = _data["enableShifts"];
            this.enableAutomaticStatusChangeOnShiftHandover = _data["enableAutomaticStatusChangeOnShiftHandover"];
        }
    }

    static fromJS(data: any): InitialBoardSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitialBoardSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["enableShifts"] = this.enableShifts;
        data["enableAutomaticStatusChangeOnShiftHandover"] = this.enableAutomaticStatusChangeOnShiftHandover;
        return data;
    }
}

export interface IInitialBoardSettingsDto {
    id?: string;
    title?: string | undefined;
    enableShifts?: boolean;
    enableAutomaticStatusChangeOnShiftHandover?: boolean;
}

export class SendAsEmailConfigDto implements ISendAsEmailConfigDto {
    emailSender?: string | undefined;
    emailAddress?: string | undefined;
    emailSignature?: string | undefined;

    constructor(data?: ISendAsEmailConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailSender = _data["emailSender"];
            this.emailAddress = _data["emailAddress"];
            this.emailSignature = _data["emailSignature"];
        }
    }

    static fromJS(data: any): SendAsEmailConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendAsEmailConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailSender"] = this.emailSender;
        data["emailAddress"] = this.emailAddress;
        data["emailSignature"] = this.emailSignature;
        return data;
    }
}

export interface ISendAsEmailConfigDto {
    emailSender?: string | undefined;
    emailAddress?: string | undefined;
    emailSignature?: string | undefined;
}

export class ShiftValidationSettingsDto implements IShiftValidationSettingsDto {
    boardId?: string;
    isValidationEnabled?: boolean;
    enableShifts?: boolean;
    types?: BoardItemValidationTypeDto[] | undefined;

    constructor(data?: IShiftValidationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            this.isValidationEnabled = _data["isValidationEnabled"];
            this.enableShifts = _data["enableShifts"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(BoardItemValidationTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftValidationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftValidationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        data["isValidationEnabled"] = this.isValidationEnabled;
        data["enableShifts"] = this.enableShifts;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShiftValidationSettingsDto {
    boardId?: string;
    isValidationEnabled?: boolean;
    enableShifts?: boolean;
    types?: BoardItemValidationTypeDto[] | undefined;
}

export class BoardItemValidationTypeDto implements IBoardItemValidationTypeDto {
    typeId?: string;
    isRelevant?: boolean;
    isAvailable?: boolean;
    isRelevantForShiftReport?: boolean;

    constructor(data?: IBoardItemValidationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.isRelevant = _data["isRelevant"];
            this.isAvailable = _data["isAvailable"];
            this.isRelevantForShiftReport = _data["isRelevantForShiftReport"];
        }
    }

    static fromJS(data: any): BoardItemValidationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemValidationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["isRelevant"] = this.isRelevant;
        data["isAvailable"] = this.isAvailable;
        data["isRelevantForShiftReport"] = this.isRelevantForShiftReport;
        return data;
    }
}

export interface IBoardItemValidationTypeDto {
    typeId?: string;
    isRelevant?: boolean;
    isAvailable?: boolean;
    isRelevantForShiftReport?: boolean;
}

export class EmailConfigDto implements IEmailConfigDto {
    id?: string;
    boardId?: string;
    boardItemTypeGuid?: string;
    email?: string | undefined;
    userName?: string | undefined;
    isEnabled?: boolean;
    lastSync?: string | undefined;
    successfulImports?: number;

    constructor(data?: IEmailConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.boardId = _data["boardId"];
            this.boardItemTypeGuid = _data["boardItemTypeGuid"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.isEnabled = _data["isEnabled"];
            this.lastSync = _data["lastSync"];
            this.successfulImports = _data["successfulImports"];
        }
    }

    static fromJS(data: any): EmailConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["boardId"] = this.boardId;
        data["boardItemTypeGuid"] = this.boardItemTypeGuid;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["isEnabled"] = this.isEnabled;
        data["lastSync"] = this.lastSync;
        data["successfulImports"] = this.successfulImports;
        return data;
    }
}

export interface IEmailConfigDto {
    id?: string;
    boardId?: string;
    boardItemTypeGuid?: string;
    email?: string | undefined;
    userName?: string | undefined;
    isEnabled?: boolean;
    lastSync?: string | undefined;
    successfulImports?: number;
}

export class SpecialOccurrenceViewListDto implements ISpecialOccurrenceViewListDto {
    activeSpecialOccurrences?: SpecialOccurrenceViewDto[] | undefined;
    archivedSpecialOccurrences?: SpecialOccurrenceViewDto[] | undefined;

    constructor(data?: ISpecialOccurrenceViewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activeSpecialOccurrences"])) {
                this.activeSpecialOccurrences = [] as any;
                for (let item of _data["activeSpecialOccurrences"])
                    this.activeSpecialOccurrences!.push(SpecialOccurrenceViewDto.fromJS(item));
            }
            if (Array.isArray(_data["archivedSpecialOccurrences"])) {
                this.archivedSpecialOccurrences = [] as any;
                for (let item of _data["archivedSpecialOccurrences"])
                    this.archivedSpecialOccurrences!.push(SpecialOccurrenceViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpecialOccurrenceViewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceViewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeSpecialOccurrences)) {
            data["activeSpecialOccurrences"] = [];
            for (let item of this.activeSpecialOccurrences)
                data["activeSpecialOccurrences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.archivedSpecialOccurrences)) {
            data["archivedSpecialOccurrences"] = [];
            for (let item of this.archivedSpecialOccurrences)
                data["archivedSpecialOccurrences"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISpecialOccurrenceViewListDto {
    activeSpecialOccurrences?: SpecialOccurrenceViewDto[] | undefined;
    archivedSpecialOccurrences?: SpecialOccurrenceViewDto[] | undefined;
}

export class SpecialOccurrenceViewDto implements ISpecialOccurrenceViewDto {
    id?: string;
    name?: string | undefined;
    isCompleted?: boolean;
    type?: SpecialOccurrenceTypeDto;
    createdDate?: string;
    updatedDate?: string | undefined;

    protected _discriminator: string;

    constructor(data?: ISpecialOccurrenceViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "SpecialOccurrenceViewDto";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCompleted = _data["isCompleted"];
            this.type = _data["type"];
            this.createdDate = _data["createdDate"];
            this.updatedDate = _data["updatedDate"];
        }
    }

    static fromJS(data: any): SpecialOccurrenceViewDto {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "TechnicalOccurrenceViewDto") {
            let result = new TechnicalOccurrenceViewDto();
            result.init(data);
            return result;
        }
        let result = new SpecialOccurrenceViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCompleted"] = this.isCompleted;
        data["type"] = this.type;
        data["createdDate"] = this.createdDate;
        data["updatedDate"] = this.updatedDate;
        return data;
    }
}

export interface ISpecialOccurrenceViewDto {
    id?: string;
    name?: string | undefined;
    isCompleted?: boolean;
    type?: SpecialOccurrenceTypeDto;
    createdDate?: string;
    updatedDate?: string | undefined;
}

export class TechnicalOccurrenceViewDto extends SpecialOccurrenceViewDto implements ITechnicalOccurrenceViewDto {
    technicalOccurrenceTypeId?: string | undefined;

    constructor(data?: ITechnicalOccurrenceViewDto) {
        super(data);
        this._discriminator = "TechnicalOccurrenceViewDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.technicalOccurrenceTypeId = _data["technicalOccurrenceTypeId"];
        }
    }

    static override fromJS(data: any): TechnicalOccurrenceViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalOccurrenceViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["technicalOccurrenceTypeId"] = this.technicalOccurrenceTypeId;
        super.toJSON(data);
        return data;
    }
}

export interface ITechnicalOccurrenceViewDto extends ISpecialOccurrenceViewDto {
    technicalOccurrenceTypeId?: string | undefined;
}

export class MaintenanceCompanyDto implements IMaintenanceCompanyDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: IMaintenanceCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MaintenanceCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMaintenanceCompanyDto {
    id?: string;
    name?: string | undefined;
}

export class SelectedFlightReasonDto implements ISelectedFlightReasonDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: ISelectedFlightReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SelectedFlightReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedFlightReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISelectedFlightReasonDto {
    id?: string;
    name?: string | undefined;
}

export enum SpecialOccurrenceAccessLevel {
    None = "None",
    Contributor = "Contributor",
    Editor = "Editor",
    Admin = "Admin",
}

export class SpecialOccurrenceListDto implements ISpecialOccurrenceListDto {
    id?: string;
    linkedMaterialRequestId?: string | undefined;
    name?: string | undefined;
    type?: SpecialOccurrenceTypeDto;
    boardIds?: string[] | undefined;
    cssClass?: string | undefined;
    aircraftRegistration?: string | undefined;
    isOccurrenceFulFilled?: boolean;
    technicalOccurrenceType?: TechnicalOccurrenceTypeDto | undefined;

    constructor(data?: ISpecialOccurrenceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.linkedMaterialRequestId = _data["linkedMaterialRequestId"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["boardIds"])) {
                this.boardIds = [] as any;
                for (let item of _data["boardIds"])
                    this.boardIds!.push(item);
            }
            this.cssClass = _data["cssClass"];
            this.aircraftRegistration = _data["aircraftRegistration"];
            this.isOccurrenceFulFilled = _data["isOccurrenceFulFilled"];
            this.technicalOccurrenceType = _data["technicalOccurrenceType"] ? TechnicalOccurrenceTypeDto.fromJS(_data["technicalOccurrenceType"]) : undefined as any;
        }
    }

    static fromJS(data: any): SpecialOccurrenceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["linkedMaterialRequestId"] = this.linkedMaterialRequestId;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.boardIds)) {
            data["boardIds"] = [];
            for (let item of this.boardIds)
                data["boardIds"].push(item);
        }
        data["cssClass"] = this.cssClass;
        data["aircraftRegistration"] = this.aircraftRegistration;
        data["isOccurrenceFulFilled"] = this.isOccurrenceFulFilled;
        data["technicalOccurrenceType"] = this.technicalOccurrenceType ? this.technicalOccurrenceType.toJSON() : undefined as any;
        return data;
    }
}

export interface ISpecialOccurrenceListDto {
    id?: string;
    linkedMaterialRequestId?: string | undefined;
    name?: string | undefined;
    type?: SpecialOccurrenceTypeDto;
    boardIds?: string[] | undefined;
    cssClass?: string | undefined;
    aircraftRegistration?: string | undefined;
    isOccurrenceFulFilled?: boolean;
    technicalOccurrenceType?: TechnicalOccurrenceTypeDto | undefined;
}

export class CreateSpecialOccurrenceDto implements ICreateSpecialOccurrenceDto {
    name?: string | undefined;
    type?: SpecialOccurrenceTypeDto;
    ownerBoardId?: string;

    constructor(data?: ICreateSpecialOccurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.ownerBoardId = _data["ownerBoardId"];
        }
    }

    static fromJS(data: any): CreateSpecialOccurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpecialOccurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["ownerBoardId"] = this.ownerBoardId;
        return data;
    }
}

export interface ICreateSpecialOccurrenceDto {
    name?: string | undefined;
    type?: SpecialOccurrenceTypeDto;
    ownerBoardId?: string;
}

export class BoardItemTemplateSpecialOccurenceDto implements IBoardItemTemplateSpecialOccurenceDto {
    boardId?: string;
    boardTitle?: string | undefined;
    templates?: BoardItemDto[] | undefined;

    constructor(data?: IBoardItemTemplateSpecialOccurenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            this.boardTitle = _data["boardTitle"];
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(BoardItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BoardItemTemplateSpecialOccurenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemTemplateSpecialOccurenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        data["boardTitle"] = this.boardTitle;
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBoardItemTemplateSpecialOccurenceDto {
    boardId?: string;
    boardTitle?: string | undefined;
    templates?: BoardItemDto[] | undefined;
}

export class AircraftDto implements IAircraftDto {
    id?: string | undefined;
    registration?: string | undefined;
    type?: string | undefined;
    hours?: number;
    cycles?: number;
    previousFlightDescription?: string | undefined;
    nextFlightDescription?: string | undefined;
    previousFlightAta?: string | undefined;
    nextFlightStd?: string | undefined;
    previousFlightArrIataCode?: string | undefined;
    previousFlightArrAirportId?: number;

    constructor(data?: IAircraftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registration = _data["registration"];
            this.type = _data["type"];
            this.hours = _data["hours"];
            this.cycles = _data["cycles"];
            this.previousFlightDescription = _data["previousFlightDescription"];
            this.nextFlightDescription = _data["nextFlightDescription"];
            this.previousFlightAta = _data["previousFlightAta"];
            this.nextFlightStd = _data["nextFlightStd"];
            this.previousFlightArrIataCode = _data["previousFlightArrIataCode"];
            this.previousFlightArrAirportId = _data["previousFlightArrAirportId"];
        }
    }

    static fromJS(data: any): AircraftDto {
        data = typeof data === 'object' ? data : {};
        let result = new AircraftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registration"] = this.registration;
        data["type"] = this.type;
        data["hours"] = this.hours;
        data["cycles"] = this.cycles;
        data["previousFlightDescription"] = this.previousFlightDescription;
        data["nextFlightDescription"] = this.nextFlightDescription;
        data["previousFlightAta"] = this.previousFlightAta;
        data["nextFlightStd"] = this.nextFlightStd;
        data["previousFlightArrIataCode"] = this.previousFlightArrIataCode;
        data["previousFlightArrAirportId"] = this.previousFlightArrAirportId;
        return data;
    }
}

export interface IAircraftDto {
    id?: string | undefined;
    registration?: string | undefined;
    type?: string | undefined;
    hours?: number;
    cycles?: number;
    previousFlightDescription?: string | undefined;
    nextFlightDescription?: string | undefined;
    previousFlightAta?: string | undefined;
    nextFlightStd?: string | undefined;
    previousFlightArrIataCode?: string | undefined;
    previousFlightArrAirportId?: number;
}

export class ComatRoutingDto implements IComatRoutingDto {
    scheduledTimeOfDeparture?: string;
    scheduledTimeOfArrival?: string;
    duration?: string | undefined;
    numberOfFlights?: number;
    flights?: FlightInfoDto[] | undefined;

    constructor(data?: IComatRoutingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduledTimeOfDeparture = _data["scheduledTimeOfDeparture"];
            this.scheduledTimeOfArrival = _data["scheduledTimeOfArrival"];
            this.duration = _data["duration"];
            this.numberOfFlights = _data["numberOfFlights"];
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(FlightInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComatRoutingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComatRoutingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduledTimeOfDeparture"] = this.scheduledTimeOfDeparture;
        data["scheduledTimeOfArrival"] = this.scheduledTimeOfArrival;
        data["duration"] = this.duration;
        data["numberOfFlights"] = this.numberOfFlights;
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IComatRoutingDto {
    scheduledTimeOfDeparture?: string;
    scheduledTimeOfArrival?: string;
    duration?: string | undefined;
    numberOfFlights?: number;
    flights?: FlightInfoDto[] | undefined;
}

export class BoardItemUpdateResultOfBoardItemDto implements IBoardItemUpdateResultOfBoardItemDto {
    entity?: BoardItemDto | undefined;
    pushNotifications?: boolean;
    authorId?: string;

    constructor(data?: IBoardItemUpdateResultOfBoardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"] ? BoardItemDto.fromJS(_data["entity"]) : undefined as any;
            this.pushNotifications = _data["pushNotifications"];
            this.authorId = _data["authorId"];
        }
    }

    static fromJS(data: any): BoardItemUpdateResultOfBoardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardItemUpdateResultOfBoardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        data["pushNotifications"] = this.pushNotifications;
        data["authorId"] = this.authorId;
        return data;
    }
}

export interface IBoardItemUpdateResultOfBoardItemDto {
    entity?: BoardItemDto | undefined;
    pushNotifications?: boolean;
    authorId?: string;
}

export class SpecialOccurrenceBoardDto implements ISpecialOccurrenceBoardDto {
    boardId?: string;
    boardTitle?: string | undefined;
    items?: BoardItemDto[] | undefined;

    constructor(data?: ISpecialOccurrenceBoardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            this.boardTitle = _data["boardTitle"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BoardItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpecialOccurrenceBoardDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceBoardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        data["boardTitle"] = this.boardTitle;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISpecialOccurrenceBoardDto {
    boardId?: string;
    boardTitle?: string | undefined;
    items?: BoardItemDto[] | undefined;
}

export class SpecialOccurrenceBoardSummaryDto implements ISpecialOccurrenceBoardSummaryDto {
    boardId?: string;
    boardName?: string | undefined;
    items?: SpecialOccurrenceBoardListSummaryDto[] | undefined;

    constructor(data?: ISpecialOccurrenceBoardSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            this.boardName = _data["boardName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpecialOccurrenceBoardListSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpecialOccurrenceBoardSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceBoardSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        data["boardName"] = this.boardName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISpecialOccurrenceBoardSummaryDto {
    boardId?: string;
    boardName?: string | undefined;
    items?: SpecialOccurrenceBoardListSummaryDto[] | undefined;
}

export class SpecialOccurrenceBoardListSummaryDto implements ISpecialOccurrenceBoardListSummaryDto {
    name?: BoardItemStatusDto;
    count?: number;

    constructor(data?: ISpecialOccurrenceBoardListSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): SpecialOccurrenceBoardListSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceBoardListSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        return data;
    }
}

export interface ISpecialOccurrenceBoardListSummaryDto {
    name?: BoardItemStatusDto;
    count?: number;
}

export class CompleteOccurrenceDto implements ICompleteOccurrenceDto {
    id?: string;
    sendFinalManagementReport?: boolean;

    constructor(data?: ICompleteOccurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sendFinalManagementReport = _data["sendFinalManagementReport"];
        }
    }

    static fromJS(data: any): CompleteOccurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteOccurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sendFinalManagementReport"] = this.sendFinalManagementReport;
        return data;
    }
}

export interface ICompleteOccurrenceDto {
    id?: string;
    sendFinalManagementReport?: boolean;
}

export class SpecialOccurrenceFlightInsertDto implements ISpecialOccurrenceFlightInsertDto {
    occurrenceId?: string;
    flights?: FlightInfoDto[] | undefined;

    constructor(data?: ISpecialOccurrenceFlightInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.occurrenceId = _data["occurrenceId"];
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(FlightInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpecialOccurrenceFlightInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceFlightInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occurrenceId"] = this.occurrenceId;
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISpecialOccurrenceFlightInsertDto {
    occurrenceId?: string;
    flights?: FlightInfoDto[] | undefined;
}

export class SpecialOccurrenceUpdatesDto implements ISpecialOccurrenceUpdatesDto {
    occurrenceId?: string;
    updates?: SpecialOccurrenceUpdateDto[] | undefined;

    constructor(data?: ISpecialOccurrenceUpdatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.occurrenceId = _data["occurrenceId"];
            if (Array.isArray(_data["updates"])) {
                this.updates = [] as any;
                for (let item of _data["updates"])
                    this.updates!.push(SpecialOccurrenceUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpecialOccurrenceUpdatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceUpdatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occurrenceId"] = this.occurrenceId;
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item of this.updates)
                data["updates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISpecialOccurrenceUpdatesDto {
    occurrenceId?: string;
    updates?: SpecialOccurrenceUpdateDto[] | undefined;
}

export class OccurrenceUpdateRecipientDto implements IOccurrenceUpdateRecipientDto {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    isDefault?: boolean;

    constructor(data?: IOccurrenceUpdateRecipientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): OccurrenceUpdateRecipientDto {
        data = typeof data === 'object' ? data : {};
        let result = new OccurrenceUpdateRecipientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IOccurrenceUpdateRecipientDto {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    isDefault?: boolean;
}

export class SpecialOccurrenceAccessLevelDto implements ISpecialOccurrenceAccessLevelDto {
    boardId?: string;
    boardName?: string | undefined;
    accessLevel?: SpecialOccurrenceAccessLevel;

    constructor(data?: ISpecialOccurrenceAccessLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            this.boardName = _data["boardName"];
            this.accessLevel = _data["accessLevel"];
        }
    }

    static fromJS(data: any): SpecialOccurrenceAccessLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceAccessLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        data["boardName"] = this.boardName;
        data["accessLevel"] = this.accessLevel;
        return data;
    }
}

export interface ISpecialOccurrenceAccessLevelDto {
    boardId?: string;
    boardName?: string | undefined;
    accessLevel?: SpecialOccurrenceAccessLevel;
}

export class SpecialOccurrenceAccessLevelUpdateDto implements ISpecialOccurrenceAccessLevelUpdateDto {
    specialOccurrenceId?: string;
    boardId?: string;
    accessLevel?: SpecialOccurrenceAccessLevel;

    constructor(data?: ISpecialOccurrenceAccessLevelUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialOccurrenceId = _data["specialOccurrenceId"];
            this.boardId = _data["boardId"];
            this.accessLevel = _data["accessLevel"];
        }
    }

    static fromJS(data: any): SpecialOccurrenceAccessLevelUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOccurrenceAccessLevelUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialOccurrenceId"] = this.specialOccurrenceId;
        data["boardId"] = this.boardId;
        data["accessLevel"] = this.accessLevel;
        return data;
    }
}

export interface ISpecialOccurrenceAccessLevelUpdateDto {
    specialOccurrenceId?: string;
    boardId?: string;
    accessLevel?: SpecialOccurrenceAccessLevel;
}

export class SystemSettingsDto implements ISystemSettingsDto {
    enableMaterialRequest?: boolean;
    companyName?: string | undefined;
    appName?: string | undefined;
    logoFileName?: string | undefined;
    backgroundImageFilename?: string | undefined;

    constructor(data?: ISystemSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableMaterialRequest = _data["enableMaterialRequest"];
            this.companyName = _data["companyName"];
            this.appName = _data["appName"];
            this.logoFileName = _data["logoFileName"];
            this.backgroundImageFilename = _data["backgroundImageFilename"];
        }
    }

    static fromJS(data: any): SystemSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableMaterialRequest"] = this.enableMaterialRequest;
        data["companyName"] = this.companyName;
        data["appName"] = this.appName;
        data["logoFileName"] = this.logoFileName;
        data["backgroundImageFilename"] = this.backgroundImageFilename;
        return data;
    }
}

export interface ISystemSettingsDto {
    enableMaterialRequest?: boolean;
    companyName?: string | undefined;
    appName?: string | undefined;
    logoFileName?: string | undefined;
    backgroundImageFilename?: string | undefined;
}

export enum AvailabilityEntityType {
    Board = "Board",
}

export class UserEditDto implements IUserEditDto {
    email?: string | undefined;
    notificationAssigned?: boolean;
    notificationSubscription?: boolean;
    notificationNewTask?: boolean;
    notificationNewSpecialOccurrence?: boolean;
    notificationCompletedSpecialOccurrence?: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.notificationAssigned = _data["notificationAssigned"];
            this.notificationSubscription = _data["notificationSubscription"];
            this.notificationNewTask = _data["notificationNewTask"];
            this.notificationNewSpecialOccurrence = _data["notificationNewSpecialOccurrence"];
            this.notificationCompletedSpecialOccurrence = _data["notificationCompletedSpecialOccurrence"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["notificationAssigned"] = this.notificationAssigned;
        data["notificationSubscription"] = this.notificationSubscription;
        data["notificationNewTask"] = this.notificationNewTask;
        data["notificationNewSpecialOccurrence"] = this.notificationNewSpecialOccurrence;
        data["notificationCompletedSpecialOccurrence"] = this.notificationCompletedSpecialOccurrence;
        return data;
    }
}

export interface IUserEditDto {
    email?: string | undefined;
    notificationAssigned?: boolean;
    notificationSubscription?: boolean;
    notificationNewTask?: boolean;
    notificationNewSpecialOccurrence?: boolean;
    notificationCompletedSpecialOccurrence?: boolean;
}

export enum OpsHubEvents {
    UpdateTaskLabels = "UpdateTaskLabels",
    GeneralLabelWasDeleted = "GeneralLabelWasDeleted",
    SelectedBoardLabelsWereUpdated = "SelectedBoardLabelsWereUpdated",
    BoardLabelsUpdated = "BoardLabelsUpdated",
    AddNotification = "AddNotification",
    RemoveNotification = "RemoveNotification",
    SpecialOccurrenceCreated = "SpecialOccurrenceCreated",
    SpecialOccurrenceUpdated = "SpecialOccurrenceUpdated",
    LabelArchived = "LabelArchived",
    LabelReactivated = "LabelReactivated",
    ManagementReportPostponed = "ManagementReportPostponed",
    AttachmentUpdated = "AttachmentUpdated",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}